/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** Input for adding a team to a DevCycle audience */
export type AddTeamToDevcycleInput = {
  audienceKey: Scalars['String']['input'];
  teamId: Scalars['String']['input'];
};

/** Response containing multiple questions */
export type AdminBidQuestionsResponse = {
  __typename?: 'AdminBidQuestionsResponse';
  /** BidQuestion: A question in the bid process */
  questions: Array<BidQuestion>;
};

/** Response after asking a single bid question */
export type AskBidQuestionAnswer = {
  __typename?: 'AskBidQuestionAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  /** The sources used to describe where the answer for derived from */
  sources?: Maybe<Array<BidChatResponse_Sources>>;
};

/** Basic information for a document uploaded by a user for a bid */
export type BasicBidDocument = {
  __typename?: 'BasicBidDocument';
  bidId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

/** A comment without any complex relational data */
export type BasicComment = {
  __typename?: 'BasicComment';
  companyId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastEditedAt?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Enum values for BasicNotice.entityType */
export enum BasicNotice_EntityTypeEnum_0 {
  BridgeNotice = 'BridgeNotice',
  Contract = 'Contract',
  DosNotice = 'DosNotice',
  Tender = 'Tender',
  TenderIntent = 'TenderIntent'
}

/** Enum values for BasicNotice.stage */
export enum BasicNotice_StageEnum_0 {
  Awarded = 'AWARDED',
  Closed = 'CLOSED',
  Open = 'OPEN',
  PreTender = 'PRE_TENDER',
  StalePreTender = 'STALE_PRE_TENDER'
}

/** A team without any complex relational data */
export type BasicTeam = {
  __typename?: 'BasicTeam';
  companyGuid: Scalars['String']['output'];
  feedSettingsId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Basic information for a stotles user */
export type BasicUser = {
  __typename?: 'BasicUser';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
};

/** Bid: A simple bid object */
export type Bid = {
  __typename?: 'Bid';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  notice?: Maybe<Notice>;
  opportunity: Opportunity;
  opportunityId: Scalars['String']['output'];
  procurementStageId?: Maybe<Scalars['String']['output']>;
  publicHash?: Maybe<Scalars['String']['output']>;
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type BidAnswer = {
  __typename?: 'BidAnswer';
  answer: BidAnswer_Answer;
  bidId: Scalars['String']['output'];
  bidQuestion: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type BidAnswer_Answer = {
  __typename?: 'BidAnswer_Answer';
  answer?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<BidQualification_Result_Sources>>;
};

/** Response body containing a list of bid answers */
export type BidAnswersResponse = {
  __typename?: 'BidAnswersResponse';
  items: Array<BidAnswer>;
};

/** Request to start or continue a chat with stotles AI on a bid */
export type BidChatRequest = {
  bidId: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

/** BidChatResponse: Response after asking a bid question when it's using streaming AI */
export type BidChatResponse = {
  __typename?: 'BidChatResponse';
  answer?: Maybe<Scalars['String']['output']>;
  bidId: Scalars['String']['output'];
  /** The conversation ID for the ongoing conversation with stotles AI */
  conversationId: Scalars['String']['output'];
  /** Whether the answer is complete or still streaming */
  isComplete: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  responseReceivedAt?: Maybe<Scalars['String']['output']>;
  /** DocumentSources: The sources used to describe where the answer from the LLM was derived from */
  sources?: Maybe<Array<BidChatResponse_Sources>>;
};

/** DocumentSources: The sources used to describe where the answer from the LLM was derived from */
export type BidChatResponse_Sources = {
  __typename?: 'BidChatResponse_Sources';
  chunkNumber?: Maybe<Scalars['Float']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  locations: Array<BidChatResponse_Sources_Locations>;
};

export type BidChatResponse_Sources_Locations = {
  __typename?: 'BidChatResponse_Sources_Locations';
  bbox?: Maybe<BidChatResponse_Sources_Locations_Bbox>;
  pageNumber: Scalars['Float']['output'];
};

export type BidChatResponse_Sources_Locations_Bbox = {
  __typename?: 'BidChatResponse_Sources_Locations_Bbox';
  height: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/** request to delete one bid */
export type BidDeleteRequest = {
  bidId: Scalars['String']['input'];
};

/** BidDocument: A document uploaded by a user for a bid */
export type BidDocument = {
  __typename?: 'BidDocument';
  bidId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  s3Url: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Response containing the URL of a document */
export type BidDocumentUrlResponse = {
  __typename?: 'BidDocumentUrlResponse';
  documentUrl: Scalars['String']['output'];
};

/** Response containing a list of documents uploaded for a bid */
export type BidDocumentsResponse = {
  __typename?: 'BidDocumentsResponse';
  /** BidDocument: A document uploaded by a user for a bid */
  items: Array<BidDocument>;
};

/** Response for evaluation */
export type BidEvaluationResponse = {
  __typename?: 'BidEvaluationResponse';
  experimentWebUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** BidQualificationResult: the result of the auto qualification */
export type BidQualification_Result = {
  __typename?: 'BidQualification_Result';
  /** The answer to the question which is displayed in the UI */
  answer: Scalars['String']['output'];
  /** The raw json response from the LLM for debugging */
  json?: Maybe<BidQualification_Result_Json>;
  question: Scalars['String']['output'];
  /** The sources used to generate the answer */
  sources: Array<BidQualification_Result_Sources>;
};

export type BidQualification_Result_Json = {
  __typename?: 'BidQualification_Result_Json';
  answer?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Array<BidQualification_Result_Sources>>;
};

export type BidQualification_Result_Sources = {
  __typename?: 'BidQualification_Result_Sources';
  chunkNumber?: Maybe<Scalars['Float']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
};

/** A question in the bid process */
export type BidQuestion = {
  __typename?: 'BidQuestion';
  autoQualify: Scalars['Boolean']['output'];
  /** Guid of the company who this question belongs to. If null, it is a default question */
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  groupName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  promptId: Scalars['String']['output'];
  question: Scalars['String']['output'];
  /** ID of the team who this question belongs to. If null, it is a default question */
  teamId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Response containing multiple questions */
export type BidQuestionGroupsResponse = {
  __typename?: 'BidQuestionGroupsResponse';
  /** BidQuestionGroup: A list of questions under a particular group name as it would appear in the scorecard */
  groups: Array<BidQuestionGroupsResponse_Groups>;
};

/** BidQuestionGroup: A list of questions under a particular group name as it would appear in the scorecard */
export type BidQuestionGroupsResponse_Groups = {
  __typename?: 'BidQuestionGroupsResponse_Groups';
  name: Scalars['String']['output'];
  /** BidQuestion: A question in the bid process */
  questions: Array<BidQuestion>;
};

/** Response for question operations */
export type BidQuestionResponse = {
  __typename?: 'BidQuestionResponse';
  /** BidQuestion: A question in the bid process */
  question?: Maybe<BidQuestion>;
  success: Scalars['Boolean']['output'];
};

/** Request to get a bid. Includes urlShareSignature to allow access for external users */
export type BidRequest = {
  /** The ID of the bid */
  id: Scalars['String']['input'];
  urlShareSignature?: InputMaybe<Scalars['String']['input']>;
};

/** Request to search for bids */
export type BidsSearchRequest = {
  /** The opportunity ids to search for */
  opportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Returns a list of bids that match ANY of the given criteria */
export type BidsSearchResponse = {
  __typename?: 'BidsSearchResponse';
  /** Bid: A simple bid object */
  results: Array<Bid>;
  totalResults: Scalars['Float']['output'];
};

/** Input for updating the stage of multiple opportunities */
export type BulkUpdateOpportunitiesStageInput = {
  opportunityIds: Array<Scalars['String']['input']>;
  stageId: Scalars['String']['input'];
};

/** Response for bulk updating opportunity stages */
export type BulkUpdateOpportunitiesStageResponse = {
  __typename?: 'BulkUpdateOpportunitiesStageResponse';
  count: Scalars['Float']['output'];
};

export type Buyer = {
  __typename?: 'Buyer';
  address?: Maybe<Scalars['String']['output']>;
  annualSpend?: Maybe<Scalars['String']['output']>;
  buyerUrl?: Maybe<Scalars['String']['output']>;
  categoryAssignments: Array<Buyer_CategoryAssignments>;
  categorySource?: Maybe<Scalars['String']['output']>;
  categoryUni?: Maybe<Scalars['String']['output']>;
  cleanName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  employeeCount?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isInactive?: Maybe<Scalars['Boolean']['output']>;
  isStotlesVerified?: Maybe<Scalars['Boolean']['output']>;
  locationSummary?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nutsLocation?: Maybe<Scalars['String']['output']>;
  oscarCategory?: Maybe<Array<Scalars['String']['output']>>;
  oscarId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  town?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Buyer activity status model */
export type BuyerActivitySummaryStatus = {
  __typename?: 'BuyerActivitySummaryStatus';
  isComplete: Scalars['Boolean']['output'];
  opportunityId: Scalars['String']['output'];
  /** OpportunityBuyerActivity: the buyer activity for an opportunity */
  result: OpportunityBuyerActivity;
};

/** BuyersList: Users lists of buyers */
export type BuyerList = {
  __typename?: 'BuyerList';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  listType: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  ownerId: Scalars['String']['output'];
  sharingType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Response object for fetching buyers */
export type BuyerResponse = {
  __typename?: 'BuyerResponse';
  results: Array<Buyer>;
  totalResults: Scalars['Float']['output'];
};

export type Buyer_CategoryAssignments = {
  __typename?: 'Buyer_CategoryAssignments';
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['String']['output']>;
  parentCategoryName?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};

/** Request object for fetching buyers by ID */
export type BuyersRequest = {
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CallOff = {
  __typename?: 'CallOff';
  buyers: Array<Organisation>;
  lotId: Scalars['String']['output'];
  /** The notices associated with the call-off */
  notice?: Maybe<CallOffNotice>;
  /** The unique identifier for the procurement process AKA record family ID */
  procurementProcessId: Scalars['String']['output'];
  suppliers: Array<Organisation>;
};

export type CallOffNotice = {
  __typename?: 'CallOffNotice';
  /** Guids of the organisations who are procuring through this call-off */
  buyerGuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Buyers: The organisations wishing to purchase goods or services through the call off notice */
  buyers?: Maybe<Array<Organisation>>;
  guid?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Scalars['String']['output']>;
  /** Guids of the organisations the call off is awarded to */
  supplierGuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Suppliers: The organisations that are providing goods or services through the call off notice */
  suppliers?: Maybe<Array<Organisation>>;
  /** The value of the notice */
  value?: Maybe<Framework_Value>;
};

/** a users comment */
export type Comment = {
  __typename?: 'Comment';
  /** BasicUser: Basic information for a stotles user */
  author: BasicUser;
  companyId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastEditedAt?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Users companies */
export type Company = {
  __typename?: 'Company';
  /** Is this a demo company */
  demo: Scalars['Boolean']['output'];
  guid: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** User: Stotles user */
  users: Array<User>;
};

/** Consumes an amount of credits for a particular credit type */
export type ConsumeCreditRequest = {
  amount: Scalars['Float']['input'];
  /** CreditType: The type of entity which this credit is based upon */
  creditType: Scalars['String']['input'];
};

/** Contact: a Stotles contact (underlying model comes from Oscar) */
export type Contact = {
  __typename?: 'Contact';
  /** Organisation: Broad type which can describe a buyer, a supplier, a public body, etc. */
  buyer?: Maybe<Organisation>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  jobFunction: Array<Scalars['String']['output']>;
  jobTitle: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  opportunities: Array<OpportunityBasic>;
  orgId?: Maybe<Scalars['String']['output']>;
  orgUrn?: Maybe<Scalars['String']['output']>;
  oscarOrgName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  seniority: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Response from searching contacts */
export type ContactsSearchResponse = {
  __typename?: 'ContactsSearchResponse';
  /** Contact: a Stotles contact (underlying model comes from Oscar) */
  results: Array<Contact>;
  totalResults: Scalars['Float']['output'];
};

/** Request object for fetching CPV codes by their codes */
export type CpvCodesRequest = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export type CpvCodesResponse = {
  __typename?: 'CpvCodesResponse';
  cpvCodes: Array<CpvCodesResponse_CpvCodes>;
  total: Scalars['Float']['output'];
};

export type CpvCodesResponse_CpvCodes = {
  __typename?: 'CpvCodesResponse_CpvCodes';
  /** CPV codes for whom this CPV Code is the parent */
  childIds?: Maybe<Array<Scalars['String']['output']>>;
  code: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parentCode?: Maybe<Scalars['String']['output']>;
};

/** Statistics for a CPV code */
export type CpvStat = {
  __typename?: 'CpvStat';
  avgContractValue: Scalars['Float']['output'];
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentToSmes: Scalars['Float']['output'];
  totalAwarded: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
};

/** Request parameters for CPV stats */
export type CpvStatsRequest = {
  /** Time period in ISO 8601 duration format (e.g., P1Y for 1 year) */
  period?: Scalars['String']['input'];
  /** Whether to show upcoming expiries instead of past contracts */
  upcomingExpiries?: Scalars['Boolean']['input'];
};

/** Overall and per-CPV statistics */
export type CpvStatsResponse = {
  __typename?: 'CpvStatsResponse';
  /** CpvStat: Statistics for a CPV code */
  overallStats: CpvStat;
  /** CpvStat: Statistics for a CPV code */
  perCpvStats: Array<CpvStat>;
};

/** input for creating an AI report */
export type CreateAiReportInput = {
  questions: Array<CreateAiReportInput_Questions>;
  title: Scalars['String']['input'];
};

/** input for creating an AI report */
export type CreateAiReportInput_Questions = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<Scalars['String']['input']>;
};

/** Request to retrieve uploaded documents for a bid */
export type CreateBidDocumentRequest = {
  bidId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

/** Request to create a new bid */
export type CreateBidRequest = {
  opportunityId: Scalars['String']['input'];
  procurementStageId?: InputMaybe<Scalars['String']['input']>;
};

/** Request object for creating a new comment */
export type CreateCommentRequest = {
  content: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  objectType: CreateCommentRequest_ObjectTypeEnum_2;
};

/** Enum values for CreateCommentRequest.objectType */
export enum CreateCommentRequest_ObjectTypeEnum_2 {
  ProcurementStage = 'ProcurementStage',
  Opportunity = 'opportunity'
}

/** input for creating a credit transaction */
export type CreateCreditTransactionRequest = {
  amount: Scalars['Float']['input'];
  creditHolderId: Scalars['String']['input'];
  /** CreditType: The type of entity which this credit is based upon */
  creditType: Scalars['String']['input'];
};

/** a list of created SEO indexing rule exemptions */
export type CreateExemptionResponse = {
  __typename?: 'CreateExemptionResponse';
  /** SeoExemption: a listing for an exemption to SEO indexing rules */
  createExemptions: Array<SeoExemption>;
};

/** Arguments for creating a new workflow */
export type CreateNewWorkflow = {
  /** StageReplacements: A map of stage replacements used when updating a workflow */
  stageReplacements: Array<CreateNewWorkflow_StageReplacements>;
  /** NewTransition: Arguments for creating a new transition */
  transitions: Array<CreateNewWorkflow_Transitions>;
};

/** Arguments for creating a new workflow */
export type CreateNewWorkflow_StageReplacements = {
  newStageName: Scalars['String']['input'];
  oldStageId: Scalars['String']['input'];
};

/** Arguments for creating a new workflow */
export type CreateNewWorkflow_Transitions = {
  /** WorkflowTransitionGroup: The group which the transition belongs to */
  group: CreateNewWorkflow_Transitions_GroupEnum_2;
  order: Scalars['Float']['input'];
  stageColor: Scalars['String']['input'];
  stageIconColor: Scalars['String']['input'];
  stageIconName: Scalars['String']['input'];
  stageName: Scalars['String']['input'];
};

/** WorkflowTransitionGroup: The group which the transition belongs to */
export enum CreateNewWorkflow_Transitions_GroupEnum_2 {
  Bidding = 'Bidding',
  Closed = 'Closed',
  PreEngagement = 'Pre_Engagement',
  TenderQualification = 'Tender_Qualification',
  Won = 'Won'
}

/** A stotles opportunity creation input */
export type CreateOpportunity = {
  assignedToId?: InputMaybe<Scalars['String']['input']>;
  closeDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  existingExpiryDate?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  stageId: Scalars['String']['input'];
  submissionDate?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** input for creating a prompt */
export type CreatePromptInput = {
  /** Model: openai model to use */
  model: CreatePromptInput_ModelEnum_0;
  numberOfResults: Scalars['Float']['input'];
  numberOfSemanticSearchResults?: InputMaybe<Scalars['Float']['input']>;
  promptType: CreatePromptInput_PromptTypeEnum_0;
};

/** Model: openai model to use */
export enum CreatePromptInput_ModelEnum_0 {
  Gpt_3p5Turbo = 'gpt_3p5_turbo',
  Gpt_3p5Turbo_0301 = 'gpt_3p5_turbo_0301',
  Gpt_3p5Turbo_0613 = 'gpt_3p5_turbo_0613',
  Gpt_3p5Turbo_16k = 'gpt_3p5_turbo_16k',
  Gpt_3p5Turbo_16k_0613 = 'gpt_3p5_turbo_16k_0613',
  Gpt_3p5Turbo_1106 = 'gpt_3p5_turbo_1106',
  Gpt_4 = 'gpt_4',
  Gpt_4_0314 = 'gpt_4_0314',
  Gpt_4_0613 = 'gpt_4_0613',
  Gpt_4_32k = 'gpt_4_32k',
  Gpt_4_32k_0314 = 'gpt_4_32k_0314',
  Gpt_4_32k_0613 = 'gpt_4_32k_0613',
  Gpt_4_1106Preview = 'gpt_4_1106_preview',
  Gpt_4VisionPreview = 'gpt_4_vision_preview',
  Gpt_4o = 'gpt_4o'
}

/** Enum values for CreatePromptInput.promptType */
export enum CreatePromptInput_PromptTypeEnum_0 {
  BuyerQa = 'buyer_qa',
  KeywordGenerator = 'keyword_generator',
  KeywordRecommendation = 'keyword_recommendation'
}

/** Request to create a new question */
export type CreateQuestionRequest = {
  autoQualify: Scalars['Boolean']['input'];
  /** Guid of the company who this question belongs to. If null, it is a default question */
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupName: Scalars['String']['input'];
  isDefault: Scalars['Boolean']['input'];
  order: Scalars['Int']['input'];
  promptId: Scalars['String']['input'];
  question: Scalars['String']['input'];
  /** ID of the team who this question belongs to. If null, it is a default question */
  teamId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Request object for creating a new SEO Exemption */
export type CreateSeoExemptionsRequest = {
  recordIds: Array<Scalars['String']['input']>;
};

/** input for creating a team */
export type CreateTeamInput = {
  isPrivate: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

/** Credit: Credit model */
export type Credit = {
  __typename?: 'Credit';
  /** CreditHolder: The ownership type upon which these credits are based */
  creditHolder?: Maybe<Credit_CreditHolder>;
  /** CreditType: The type of entity which this credit is based upon */
  creditType: Scalars['String']['output'];
  holderId: Scalars['String']['output'];
  /** CreditHolderType: Describes the ID of the customer entity which holds the credits */
  holderType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  remainingCredits: Scalars['Float']['output'];
  totalCredits: Scalars['Float']['output'];
  totalUsed: Scalars['Float']['output'];
};

/** Credit Transaction model */
export type CreditTransaction = {
  __typename?: 'CreditTransaction';
  createdAt?: Maybe<Scalars['String']['output']>;
  creditChange: Scalars['Float']['output'];
  creditHolderId: Scalars['String']['output'];
  /** CreditType: The type of entity which this credit is based upon */
  creditType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

/** CreditHolder: The ownership type upon which these credits are based */
export type Credit_CreditHolder = {
  __typename?: 'Credit_CreditHolder';
  /** Company: Users companies */
  company?: Maybe<Company>;
  /** Team: a team of users within a company */
  team?: Maybe<Team>;
  /** BasicUser: Basic information for a stotles user */
  user?: Maybe<BasicUser>;
};

/** returns a list of credit summaries */
export type CreditsResponse = {
  __typename?: 'CreditsResponse';
  /** Credit: Credit model */
  results: Array<Credit>;
  totalResults: Scalars['Float']['output'];
};

/** Filters for searching for credits */
export type CreditsSearchRequest = {
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** CreditType: The type of entity which this credit is based upon */
  creditTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** CreditHolderType: Describes the ID of the customer entity which holds the credits */
  holderType: Scalars['String']['input'];
  limit: Scalars['Float']['input'];
  offset: Scalars['Float']['input'];
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Credits status model */
export type CreditsStatus = {
  __typename?: 'CreditsStatus';
  creditHolderId: Scalars['String']['output'];
  creditLimitReached: Scalars['Boolean']['output'];
  teamId: Scalars['String']['output'];
  totalCredits: Scalars['Float']['output'];
};

/** Request to retrieve uploaded documents for a bid */
export type DeleteBidDocumentRequest = {
  bidId: Scalars['String']['input'];
  documentId: Scalars['String']['input'];
};

/** Request object for deleting a comment */
export type DeleteCommentRequest = {
  id: Scalars['String']['input'];
};

/** Request to delete a question */
export type DeleteQuestionRequest = {
  id: Scalars['String']['input'];
};

/** Request object for deleting an SEO Exemption */
export type DeleteSeoExemptionRequest = {
  seoExemptionId: Scalars['String']['input'];
};

/** input for deleting a team */
export type DeleteTeamInput = {
  id: Scalars['String']['input'];
};

/** id and recordId for a deleted SEO indexing rule exemption */
export type DeletedSeoExemption = {
  __typename?: 'DeletedSeoExemption';
  id: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
};

/** this is the response for when a team is hard-deleted. This should only be used in the onboarding flow. */
export type DeletedTeamResponse = {
  __typename?: 'DeletedTeamResponse';
  id: Scalars['String']['output'];
};

/** Details of an audience in DevCycle */
export type DevCycleAudienceDetails = {
  __typename?: 'DevCycleAudienceDetails';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Document: A document published by an organisation */
export type Document = {
  __typename?: 'Document';
  alternativeSource?: Maybe<Scalars['String']['output']>;
  /** Buyers associated with the document */
  buyers?: Maybe<Array<Organisation>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** BasicUser: Basic information for a stotles user */
  createdBy?: Maybe<BasicUser>;
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  originalMimeType?: Maybe<Scalars['String']['output']>;
  pdfDocumentUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  signalScore?: Maybe<Scalars['Float']['output']>;
  /** Signals: User's signals associated with the document */
  signals?: Maybe<Array<SignalDefinition>>;
  /** Source URLs associated with the document */
  sourceUrlLinks?: Maybe<Array<Document_SourceUrlLinks>>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Contains highlighted text for title and content within a document */
export type DocumentHighlightResponse = {
  __typename?: 'DocumentHighlightResponse';
  /** Highlights in the content that correspond to the search query */
  contentHighlights?: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights in the title that correspond to the search query */
  titleHighlights?: Maybe<Array<Scalars['String']['output']>>;
};

export type Document_SourceUrlLinks = {
  __typename?: 'Document_SourceUrlLinks';
  id: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
};

/** Request to highlight for a given document */
export type DocumentsHighlightRequest = {
  /** The document id to search for */
  documentId: Scalars['String']['input'];
  /** DocumentsSearchCriteria: Criteria for searching for documents */
  searchCriteria: DocumentsHighlightRequest_SearchCriteria;
};

/** Request to highlight for a given document */
export type DocumentsHighlightRequest_SearchCriteria = {
  /** Buyer filters */
  buyerFilters?: InputMaybe<NoticesSearchRequest_BuyerFilters>;
  /** Document categories */
  categories?: InputMaybe<Array<DocumentsSearchRequest_CategoriesEnum_2>>;
  /** The document ids to search for */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Keywords used to search the document title, description and content */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Minimum relevance score for the results. In the range of 0 - 3 */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** Date filter for the publish date of the document */
  publishDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  relationshipType?: InputMaybe<DocumentsSearchRequest_RelationshipTypeEnum_2>;
  /** Signals to filter documents by */
  signals?: InputMaybe<NoticesSearchRequest_Signals>;
  /** Keyword used to search the document title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Request to search for documents */
export type DocumentsSearchRequest = {
  /** Buyer filters */
  buyerFilters?: InputMaybe<NoticesSearchRequest_BuyerFilters>;
  /** Document categories */
  categories?: InputMaybe<Array<DocumentsSearchRequest_CategoriesEnum_2>>;
  /** The document ids to search for */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Keywords used to search the document title, description and content */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit the number of results returned */
  limit: Scalars['Float']['input'];
  /** Minimum relevance score for the results. In the range of 0 - 3 */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** The current page number */
  page: Scalars['Float']['input'];
  /** Date filter for the publish date of the document */
  publishDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  relationshipType?: InputMaybe<DocumentsSearchRequest_RelationshipTypeEnum_2>;
  /** Signals to filter documents by */
  signals?: InputMaybe<NoticesSearchRequest_Signals>;
  /** Sort field for the results */
  sort?: DocumentsSearchRequest_SortEnum_2;
  /** Sort order for the results */
  sortOrder?: DocumentsSearchRequest_SortOrderEnum_2;
  /** Keyword used to search the document title */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Enum values for DocumentsSearchRequest.categories */
export enum DocumentsSearchRequest_CategoriesEnum_2 {
  Budget = 'BUDGET',
  CaseStudy = 'CASE_STUDY',
  ConsultationAndResearch = 'CONSULTATION_AND_RESEARCH',
  Foi = 'FOI',
  GuidanceAndRegulation = 'GUIDANCE_AND_REGULATION',
  InternalOperations = 'INTERNAL_OPERATIONS',
  MeetingMinutes = 'MEETING_MINUTES',
  NewsAndCommunication = 'NEWS_AND_COMMUNICATION',
  Other = 'OTHER',
  ReportAndAccounts = 'REPORT_AND_ACCOUNTS',
  SpecificReport = 'SPECIFIC_REPORT',
  SpecificStrategy = 'SPECIFIC_STRATEGY',
  Statistics = 'STATISTICS',
  Strategy = 'STRATEGY',
  TribunalDecisions = 'TRIBUNAL_DECISIONS'
}

/** Enum values for DocumentsSearchRequest.relationshipType */
export enum DocumentsSearchRequest_RelationshipTypeEnum_2 {
  Document = 'DOCUMENT',
  Framework = 'FRAMEWORK',
  Organisation = 'ORGANISATION',
  ProcurementProcessEvent = 'PROCUREMENT_PROCESS_EVENT'
}

/** Enum values for DocumentsSearchRequest.sort */
export enum DocumentsSearchRequest_SortEnum_2 {
  Category = 'CATEGORY',
  CreateDate = 'CREATE_DATE',
  PublishDate = 'PUBLISH_DATE',
  Score = 'SCORE',
  Title = 'TITLE'
}

/** Sort order for the results */
export enum DocumentsSearchRequest_SortOrderEnum_2 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Returns a list of documents */
export type DocumentsSearchResponse = {
  __typename?: 'DocumentsSearchResponse';
  /** Document: A document published by an organisation */
  results: Array<Document>;
  totalResults: Scalars['Float']['output'];
};

/** Request to evaluate */
export type EvaluateNoticesRequest = {
  companyId: Scalars['String']['input'];
  contextChunkSize: Scalars['Float']['input'];
  datasetName: Scalars['String']['input'];
  dedupeResultChunks: Scalars['Boolean']['input'];
  documentProcessingEngine?: InputMaybe<EvaluateNoticesRequest_DocumentProcessingEngineEnum_2>;
  graderModel: Scalars['String']['input'];
  isFullDocumentSearchEnabled: Scalars['Boolean']['input'];
  isKeywordSearchEnabled: Scalars['Boolean']['input'];
  isNoticeSearchEnabled: Scalars['Boolean']['input'];
  llmModel: Scalars['String']['input'];
  numberOfSemanticSearchResultsPerCall: Scalars['Float']['input'];
  promptGraderKey: Scalars['String']['input'];
  promptKey: Scalars['String']['input'];
  /** Reprocess the documents, including re-parsing and re-indexing */
  reprocessDocuments: Scalars['Boolean']['input'];
  responseFormatGraderKey?: InputMaybe<Scalars['String']['input']>;
  semanticSearchFunctionDescription: Scalars['String']['input'];
};

/** Enum values for EvaluateNoticesRequest.documentProcessingEngine */
export enum EvaluateNoticesRequest_DocumentProcessingEngineEnum_2 {
  Apryse = 'APRYSE',
  ApryseIde = 'APRYSE_IDE',
  Docupanda = 'DOCUPANDA'
}

/** Request to export a bid report as a PDF */
export type ExportBidReportRequest = {
  /** The ID of the bid */
  id: Scalars['String']['input'];
};

/** Response containing the signed URL to download the PDF */
export type ExportBidReportResponse = {
  __typename?: 'ExportBidReportResponse';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** format for file export */
export type ExportFormatArgs = {
  /** ExportFormat: format for file export */
  fileFormat: ExportFormatArgs_FileFormatEnum_0;
};

/** ExportFormat: format for file export */
export enum ExportFormatArgs_FileFormatEnum_0 {
  Csv = 'csv',
  Xlsx = 'xlsx'
}

/** Feedback: Feedback provided by the user */
export type Feedback = {
  __typename?: 'Feedback';
  isPositive: Scalars['Boolean']['output'];
  questionId: Scalars['String']['output'];
  userDetailedFeedback?: Maybe<Scalars['String']['output']>;
};

/** id for file export */
export type FileExport = {
  __typename?: 'FileExport';
  id: Scalars['String']['output'];
};

/** status of the requested file export */
export type FileExportStatus = {
  __typename?: 'FileExportStatus';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  isError: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

/** Framework: Top level representation for the procurement process of a framework,     including past and present stages */
export type Framework = {
  __typename?: 'Framework';
  /** FrameworkAwardType: Method of awarding call-offs. */
  awardType?: Maybe<Framework_AwardTypeEnum_0>;
  /** The number of buyers participating in the framework */
  buyerCount: Scalars['Float']['output'];
  /** Buyers: The organisations wishing to purchase goods or services through the framework */
  buyers?: Maybe<Array<Organisation>>;
  /** The callOffs count and average amount */
  callOff: Framework_CallOff;
  /** The number of call-offs made through this framework */
  callOffCount: Scalars['Float']['output'];
  /** CallOffConfig: Config of the call-off */
  callOffIdentificationRule?: Maybe<Framework_CallOffIdentificationRule>;
  classifications?: Maybe<Array<Framework_Classifications>>;
  /** Details for contacting the framework provider. */
  contactDetails?: Maybe<Framework_ContactDetails>;
  /** ContractPeriod: The period during which call-offs can be published through this framework.       After this period the framework will be in 'EXPIRED' stage */
  contractPeriod?: Maybe<Framework_PlanningPeriod>;
  contractingAuthority?: Maybe<Organisation>;
  contractingAuthorityGuid?: Maybe<Scalars['String']['output']>;
  /** Country where the framework is operating. */
  countryCode: Scalars['String']['output'];
  /** CPV Codes: The cpv codes which describe the type of work being procured */
  cpvCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Temporary way to allow us to inspect the raw framework data coming through the API.       Contains both of the top level framework and the framework events from which we calculate it */
  debugInfo?: Maybe<Framework_DebugInfo>;
  extensionAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The unique identifier for the framework. */
  id: Scalars['String']['output'];
  /** When the framework either had new information added, notice stage changed or in the future call-off published. */
  lastActivity?: Maybe<Scalars['String']['output']>;
  /** The number of lots in the framework */
  lotCount: Scalars['Float']['output'];
  /** Lots of the framework. */
  lots: Array<Framework_Lots>;
  /** PlanningPeriod: The pre-tender period. Expect this to be rarely populated as pre-tender       notices for frameworks aren't common. Will only be retirved from scraped notice data,       will not appear in provider supplied data */
  planningPeriod?: Maybe<Framework_PlanningPeriod>;
  /** FrameworkProcedureType: Type of the framework. */
  procedureType?: Maybe<Framework_ProcedureTypeEnum_0>;
  regions?: Maybe<Array<Framework_Regions>>;
  serviceProvider?: Maybe<Organisation>;
  serviceProviderGuid?: Maybe<Scalars['String']['output']>;
  signalScore?: Maybe<Scalars['Float']['output']>;
  /** Signals: User's signals associated with the framework */
  signals?: Maybe<Array<SignalDefinition>>;
  /** External link to the source page of the framework */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** FrameworkStage: The stage in the lifecycle of a procurement process which the framework is presently at. */
  stage: Framework_StageEnum_0;
  /** URL to the stotles page for the framework */
  stotlesUrl: Scalars['String']['output'];
  /** The number of suppliers participating in the framework */
  supplierCount: Scalars['Float']['output'];
  /** Suppliers: The organisations that are providing goods or services through the framework */
  suppliers?: Maybe<Array<Organisation>>;
  /** TenderPeriod: period during which suppliers will be able to bid to join the framework. */
  tenderPeriod?: Maybe<Framework_PlanningPeriod>;
  /** Sections of text related to the framework agreement. */
  textSections?: Maybe<Array<Framework_TextSections>>;
  /** Timeline: Describes the timeline of the framework procurement process.       Links to stotles notices where possible and where they're absent, attempts to link to external notices */
  timeline?: Maybe<Array<Framework_Timeline>>;
  /** Title/name of the framework. */
  title: Scalars['String']['output'];
  /** Whether the framework has been validated by the provider. */
  validatedByProvider: Scalars['Boolean']['output'];
  /** TBC: total/estimated value of awards in the framework? */
  value?: Maybe<Framework_Value>;
};

/** Request to search through framework text fields for a given set of keywords and/or organisations & their aliases */
export type FrameworkHighlightRequest = {
  /** ID for the framework */
  frameworkId: Scalars['String']['input'];
  /** If true, all signals are highlighted in the framework text */
  highlightSignals: Scalars['Boolean']['input'];
  /** A list of keywords to search for in the framework. */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Guids of the organisations which we'd like to highlight in the framework text, their aliases will also be included later */
  orgIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Contains the text that should be highlighted in title and description at the top level and in the lots for frameworks */
export type FrameworkHighlightResponse = {
  __typename?: 'FrameworkHighlightResponse';
  /** Highlights in the description that correspond to the search query */
  description?: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights in the lot description that correspond to the search query */
  lotDescription?: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights in the lot title that correspond to the search query */
  lotTitle?: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights in the title that correspond to the search query */
  title?: Maybe<Array<Scalars['String']['output']>>;
};

export type FrameworkSearchResponse = {
  __typename?: 'FrameworkSearchResponse';
  /** Framework: Top level representation for the procurement process of a framework,     including past and present stages */
  results: Array<Framework>;
  totalResults: Scalars['Float']['output'];
};

/** Enum values for Framework.awardType */
export enum Framework_AwardTypeEnum_0 {
  CompetitionAndDirect = 'COMPETITION_AND_DIRECT',
  CompetitionOnly = 'COMPETITION_ONLY',
  DirectAward = 'DIRECT_AWARD',
  Other = 'OTHER'
}

/** The callOffs count and average amount */
export type Framework_CallOff = {
  __typename?: 'Framework_CallOff';
  /** Contains the raw JSON data for the framework events which made up this framework */
  averageAmount?: Maybe<Framework_CallOff_AverageAmount>;
  /** The total count of call-offs related to the framework */
  count: Scalars['Float']['output'];
};

/** CallOffConfig: Config of the call-off */
export type Framework_CallOffIdentificationRule = {
  __typename?: 'Framework_CallOffIdentificationRule';
  config: Framework_CallOffIdentificationRule_Config;
  /** the id of the framework which will be assigned, in the case of a match */
  frameworkId: Scalars['String']['output'];
  /** the id of the configuration object */
  id: Scalars['String']['output'];
};

export type Framework_CallOffIdentificationRule_Config = {
  __typename?: 'Framework_CallOffIdentificationRule_Config';
  /** Each element is an 'OR' - ie. any of the groups of words in the sub-arrays could be present for there to be a match. */
  keywords: Array<Array<Scalars['String']['output']>>;
};

export type Framework_CallOff_AverageAmount = {
  __typename?: 'Framework_CallOff_AverageAmount';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type Framework_Classifications = {
  __typename?: 'Framework_Classifications';
  codes: Array<Scalars['String']['output']>;
  scheme: Scalars['String']['output'];
};

export type Framework_ContactDetails = {
  __typename?: 'Framework_ContactDetails';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

/** Temporary way to allow us to inspect the raw framework data coming through the API. Both the top level framework and the framework events from which we calculate it */
export type Framework_DebugInfo = {
  __typename?: 'Framework_DebugInfo';
  /** Contains the raw JSON data for the framework events which made up this framework */
  frameworkEventInfo?: Maybe<Scalars['String']['output']>;
  /** Contains the raw JSON data for the top level framework */
  frameworkInfo?: Maybe<Scalars['String']['output']>;
};

export type Framework_Lots = {
  __typename?: 'Framework_Lots';
  /**  The start & end date of the lot */
  contractPeriod?: Maybe<Framework_PlanningPeriod>;
  /** A description of the lot */
  description?: Maybe<Framework_TextSections_Content>;
  /** The unique identifier for the framework lot. */
  id: Scalars['String']['output'];
  /** All of the organisation guids which belong to suppliers participating in this lot of the framework */
  supplierGuids?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Framework_Value>;
};

/** Period: Contains the start and end data of a period of time */
export type Framework_PlanningPeriod = {
  __typename?: 'Framework_PlanningPeriod';
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

/** Enum values for Framework.procedureType */
export enum Framework_ProcedureTypeEnum_0 {
  DynamicPurchasingSystem = 'DYNAMIC_PURCHASING_SYSTEM',
  Framework = 'FRAMEWORK'
}

export type Framework_Regions = {
  __typename?: 'Framework_Regions';
  nuts: Scalars['String']['output'];
};

/** Enum values for Framework.stage */
export enum Framework_StageEnum_0 {
  Awarded = 'AWARDED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Stale = 'STALE',
  Tendering = 'TENDERING',
  Upcoming = 'UPCOMING'
}

/**
 * A piece of text related to a framework or notice, includes a title that will be used as a header for display.
 *   Role is required and is a hint for how the text should be used in the UI or when searching.
 */
export type Framework_TextSections = {
  __typename?: 'Framework_TextSections';
  /** Describes not only the text content of this section, but also the content type so we know how to handle it on the frontend */
  content: Framework_TextSections_Content;
  /** Role is required and is a hint for how the text should be used in the UI or when searching. */
  role: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Describes not only the text content of this section, but also the content type so we know how to handle it on the frontend */
export type Framework_TextSections_Content = {
  __typename?: 'Framework_TextSections_Content';
  /** The actual content of the text section, whether it's plain ol' text or markdown */
  content: Scalars['String']['output'];
  /** MIME type of the content. Only specific types are supported. */
  content_type: Scalars['String']['output'];
};

/** FrameworkTimelineStage: Describes a stage in framework procurement process, with date periods for the stage and a link to either a stotles notice or an external notice where possible */
export type Framework_Timeline = {
  __typename?: 'Framework_Timeline';
  endDate?: Maybe<Scalars['String']['output']>;
  /** Link to the notice on an external source such as find-a-tender.service.gov.uk or ted.europa.eu */
  externalSourceUrl?: Maybe<Scalars['String']['output']>;
  notice?: Maybe<Framework_Timeline_Notice>;
  /** FrameworkStage: The stage in the lifecycle of a procurement process which the framework is presently at. */
  stage: Framework_Timeline_StageEnum_0;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Framework_Timeline_Notice = {
  __typename?: 'Framework_Timeline_Notice';
  /** The unique identifier for the procurement process AKA record family ID */
  procurementProcessId?: Maybe<Scalars['String']['output']>;
  publishDate?: Maybe<Scalars['String']['output']>;
  recordGuid?: Maybe<Scalars['String']['output']>;
  /** Link to the notice within the stotles platform, this will be used when we have a record family ID as a reference for this timeline stage */
  stotlesUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Enum values for Framework_Timeline.stage */
export enum Framework_Timeline_StageEnum_0 {
  Awarded = 'AWARDED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Stale = 'STALE',
  Tendering = 'TENDERING',
  Upcoming = 'UPCOMING'
}

export type Framework_Value = {
  __typename?: 'Framework_Value';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

/** Arguments for getting keyword recommendations */
export type GenerateKeywordsRecommendationRequest = {
  currentlySuggestedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  dismissedKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  domainAddress?: InputMaybe<Scalars['String']['input']>;
  existingKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  numberOfKeywords?: InputMaybe<Scalars['Float']['input']>;
};

/** Arguments for getting keywords */
export type GenerateKeywordsRequest = {
  domainAddress: Scalars['String']['input'];
};

/** Arguments for generating outreach text */
export type GenerateOutreachRequest = {
  buyerName: Scalars['String']['input'];
  companyInformation?: InputMaybe<Scalars['String']['input']>;
  contactJobTitle: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  intent: GenerateOutreachRequest_IntentEnum_0;
  length: GenerateOutreachRequest_LengthEnum_0;
  numberOfResponses?: Scalars['Float']['input'];
  senderPersonalisation?: InputMaybe<Scalars['String']['input']>;
  tone: Array<GenerateOutreachRequest_ToneEnum_0>;
};

/** Enum values for GenerateOutreachRequest.intent */
export enum GenerateOutreachRequest_IntentEnum_0 {
  Awareness = 'Awareness',
  Meeting = 'Meeting'
}

/** Enum values for GenerateOutreachRequest.length */
export enum GenerateOutreachRequest_LengthEnum_0 {
  Long = 'Long',
  Short = 'Short'
}

/** Enum values for GenerateOutreachRequest.tone */
export enum GenerateOutreachRequest_ToneEnum_0 {
  Bold = 'Bold',
  Casual = 'Casual',
  Empathetic = 'Empathetic',
  Friendly = 'Friendly',
  Fun = 'Fun',
  Knowledgeable = 'Knowledgeable',
  Professional = 'Professional',
  Relaxed = 'Relaxed',
  Witty = 'Witty'
}

/** Response from generating outreach text */
export type GenerateOutreachResponse = {
  __typename?: 'GenerateOutreachResponse';
  /** OutreachemailResponse: Response from generating outreach text */
  responses: Array<GenerateOutreachResponse_Responses>;
};

/** OutreachemailResponse: Response from generating outreach text */
export type GenerateOutreachResponse_Responses = {
  __typename?: 'GenerateOutreachResponse_Responses';
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

/** Request to get questions for a team */
export type GetQuestionsByTeamRequest = {
  teamId: Scalars['String']['input'];
};

/** Arguments for getting stored questions */
export type GetQuestionsRequest = {
  referenceId: Scalars['String']['input'];
};

/** Response object for fetching Hubspot id token */
export type HubspotIdTokenResponse = {
  __typename?: 'HubspotIdTokenResponse';
  token: Scalars['String']['output'];
};

/** Keywords: keywords/signals generated for a domain address */
export type Keywords = {
  __typename?: 'Keywords';
  companyName?: Maybe<Scalars['String']['output']>;
  keywords: Array<Scalars['String']['output']>;
};

/** A prompt object from langsmtih */
export type LangsmithPrompt = {
  __typename?: 'LangsmithPrompt';
  /** Usually not populated, but just having here for posterity */
  description?: Maybe<Scalars['String']['output']>;
  /** The name of the prompt */
  promptId: Scalars['String']['output'];
  /** The content of the prompts we use in the langsmith chain */
  questions: Array<Scalars['String']['output']>;
};

/** Arguments for calling a webhook */
export type MakeWebhookRequest = {
  /** HookName: The name of the webhook to call */
  hookName: MakeWebhookRequest_HookNameEnum_2;
};

/** HookName: The name of the webhook to call */
export enum MakeWebhookRequest_HookNameEnum_2 {
  BidWaitlist = 'bidWaitlist',
  CreditLimitReached = 'creditLimitReached',
  SlackMessage = 'slackMessage'
}

export type Mutation = {
  __typename?: 'Mutation';
  addOpportunityEntities: OpportunityEntitiesUpdateResponse;
  addTeamToDevcycleAudience: DevCycleAudienceDetails;
  askBidQuestion: AskBidQuestionAnswer;
  askQuestion: Question;
  bidChat: BidChatResponse;
  bulkUpdateOpportunitiesStage: BulkUpdateOpportunitiesStageResponse;
  buyerSummaryEvaluation: OppBuyerActivityEvaluationResponse;
  consumeCredit: RemainingCredits;
  createAiReport: Report;
  createBid: Bid;
  createBidDocument: BasicBidDocument;
  createComment: BasicComment;
  createCreditTransaction: CreditTransaction;
  createExemptions: CreateExemptionResponse;
  createOpportunity: OpportunityBasic;
  createOpportunityWorkflow: OpportunityWorkflow;
  createPrompt: Prompt;
  createQuestion: BidQuestionResponse;
  createTeam: Team;
  deleteBid: Bid;
  deleteBidDocument: BasicBidDocument;
  deleteComment: BasicComment;
  deleteExemption: DeletedSeoExemption;
  deleteOpportunity: OpportunityEntitiesDeleteResponse;
  deleteQuestion: BidQuestionResponse;
  evaluateNotices: BidEvaluationResponse;
  exportBidReportAsPDF: ExportBidReportResponse;
  exportContacts: FileExport;
  exportFrameworkSuppliers: FileExport;
  exportFrameworks: FileExport;
  exportNotices: FileExport;
  exportOpportunities: FileExport;
  generateKeywords: Keywords;
  generateOutreach: GenerateOutreachResponse;
  getBidDocumentUrl: BidDocumentUrlResponse;
  hardDeleteTeamFromOnboarding: DeletedTeamResponse;
  keywordsRecommendations: Keywords;
  makeWebhook: Scalars['Boolean']['output'];
  persistCallOffConfig: Framework_CallOffIdentificationRule;
  provideQaFeedback: Feedback;
  qualifyBid: Scorecard;
  qualifyQuestion: Scorecard_Result_Questions;
  regenerateOpportunityBuyerSummary: OpportunityBuyerActivity;
  removeOpportunityEntity: OpportunityEntitiesUpdateResponse;
  updateBidAnswerById: BidAnswer;
  updateBidPublicity: Bid;
  updateComment: BasicComment;
  updateOpportunity: Opportunity;
  updateOpportunityWorkflow: OpportunityWorkflow;
  updateQuestion: BidQuestionResponse;
  updateSignalSettings: SimpleSignalSettings;
  updateTeam: BasicTeam;
  updateUser: User;
  uploadNoticeDocument: UploadNoticeDocument;
  upsertBidReportQuestions: BidQuestionGroupsResponse;
};


export type MutationAddOpportunityEntitiesArgs = {
  entities: OpportunityEntitiesInput;
  id: Scalars['String']['input'];
};


export type MutationAddTeamToDevcycleAudienceArgs = {
  AddTeamToDevcycleInput: AddTeamToDevcycleInput;
};


export type MutationAskBidQuestionArgs = {
  QualifyQuestionRequest: QualifyQuestionRequest;
};


export type MutationAskQuestionArgs = {
  QuestionRequest: QuestionRequest;
};


export type MutationBidChatArgs = {
  BidChatRequest: BidChatRequest;
};


export type MutationBulkUpdateOpportunitiesStageArgs = {
  input: BulkUpdateOpportunitiesStageInput;
};


export type MutationBuyerSummaryEvaluationArgs = {
  OpportunityEvaluationRequest: OpportunityEvaluationRequest;
};


export type MutationConsumeCreditArgs = {
  ConsumeCreditRequest: ConsumeCreditRequest;
};


export type MutationCreateAiReportArgs = {
  CreateAiReportInput: CreateAiReportInput;
};


export type MutationCreateBidArgs = {
  bid: CreateBidRequest;
};


export type MutationCreateBidDocumentArgs = {
  CreateBidDocumentRequest: CreateBidDocumentRequest;
};


export type MutationCreateCommentArgs = {
  CreateCommentRequest: CreateCommentRequest;
};


export type MutationCreateCreditTransactionArgs = {
  CreateCreditTransactionRequest: CreateCreditTransactionRequest;
};


export type MutationCreateExemptionsArgs = {
  CreateSeoExemptionsRequest: CreateSeoExemptionsRequest;
};


export type MutationCreateOpportunityArgs = {
  entities: OpportunityEntitiesInput;
  opportunity: CreateOpportunity;
};


export type MutationCreateOpportunityWorkflowArgs = {
  createNewWorkflow: CreateNewWorkflow;
};


export type MutationCreatePromptArgs = {
  CreatePromptInput: CreatePromptInput;
  PromptTemplate: Array<PromptTemplateInput>;
};


export type MutationCreateQuestionArgs = {
  CreateQuestionRequest: CreateQuestionRequest;
};


export type MutationCreateTeamArgs = {
  CreateTeamInput: CreateTeamInput;
};


export type MutationDeleteBidArgs = {
  BidDeleteRequest: BidDeleteRequest;
};


export type MutationDeleteBidDocumentArgs = {
  DeleteBidDocumentRequest: DeleteBidDocumentRequest;
};


export type MutationDeleteCommentArgs = {
  DeleteCommentRequest: DeleteCommentRequest;
};


export type MutationDeleteExemptionArgs = {
  DeleteSeoExemptionRequest: DeleteSeoExemptionRequest;
};


export type MutationDeleteOpportunityArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteQuestionArgs = {
  DeleteQuestionRequest: DeleteQuestionRequest;
};


export type MutationEvaluateNoticesArgs = {
  EvaluateNoticesRequest: EvaluateNoticesRequest;
};


export type MutationExportBidReportAsPdfArgs = {
  ExportBidReportRequest: ExportBidReportRequest;
};


export type MutationExportContactsArgs = {
  ExportFormat: ExportFormatArgs;
  SearchContactsRequest: SearchContactsRequest;
  SelectedContacts: SelectedContacts;
};


export type MutationExportFrameworkSuppliersArgs = {
  ExportFormat: ExportFormatArgs;
  SelectedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  SelectedSupplierGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  frameworkId: Scalars['String']['input'];
};


export type MutationExportFrameworksArgs = {
  ExportFormat: ExportFormatArgs;
  SearchFrameworksRequest: SearchFrameworksRequest;
  SelectedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  SelectedFrameworks: SelectedFrameworks;
};


export type MutationExportNoticesArgs = {
  ExportFormat: ExportFormatArgs;
  NoticesSearchRequest: NoticesSearchRequest;
  SelectedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  SelectedNotices: SelectedNotices;
};


export type MutationExportOpportunitiesArgs = {
  ExportFormat: ExportFormatArgs;
  PaginationOptions: PaginationOptions;
  SearchOpportunityRequest: SearchOpportunitiesRequest;
  SelectedFields?: InputMaybe<Array<Scalars['String']['input']>>;
  SelectedOpportunities: SelectedOpportunities;
};


export type MutationGenerateKeywordsArgs = {
  GenerateKeywordsRequest: GenerateKeywordsRequest;
};


export type MutationGenerateOutreachArgs = {
  GenerateOutreachRequest: GenerateOutreachRequest;
};


export type MutationGetBidDocumentUrlArgs = {
  id: Scalars['String']['input'];
};


export type MutationHardDeleteTeamFromOnboardingArgs = {
  DeleteTeamInput: DeleteTeamInput;
};


export type MutationKeywordsRecommendationsArgs = {
  GenerateKeywordsRecommendationRequest: GenerateKeywordsRecommendationRequest;
};


export type MutationMakeWebhookArgs = {
  MakeWebhookRequest: MakeWebhookRequest;
};


export type MutationPersistCallOffConfigArgs = {
  PersistCallOffConfigRequest: PersistCallOffConfigRequest;
};


export type MutationProvideQaFeedbackArgs = {
  ProvideFeedbackRequest: ProvideFeedbackRequest;
};


export type MutationQualifyBidArgs = {
  id: Scalars['String']['input'];
};


export type MutationQualifyQuestionArgs = {
  QualifyQuestionRequest: QualifyQuestionRequest;
};


export type MutationRegenerateOpportunityBuyerSummaryArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOpportunityEntityArgs = {
  entities: OpportunityEntitiesInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateBidAnswerByIdArgs = {
  UpdateBidAnswerRequest: UpdateBidAnswerRequest;
};


export type MutationUpdateBidPublicityArgs = {
  UpdateBidPublicityRequest: UpdateBidPublicityRequest;
};


export type MutationUpdateCommentArgs = {
  UpdateCommentRequest: UpdateCommentRequest;
};


export type MutationUpdateOpportunityArgs = {
  opportunity: OpportunityUpdateInput;
};


export type MutationUpdateOpportunityWorkflowArgs = {
  updateWorkflow: UpdateWorkflowInput;
};


export type MutationUpdateQuestionArgs = {
  UpdateQuestionRequest: UpdateQuestionRequest;
};


export type MutationUpdateSignalSettingsArgs = {
  UpdateSignalSettings: UpdateSignalSettings;
};


export type MutationUpdateTeamArgs = {
  UpdateTeamInput: UpdateTeamInput;
};


export type MutationUpdateUserArgs = {
  user: UpdateUserRequest;
};


export type MutationUploadNoticeDocumentArgs = {
  UploadNoticeDocumentRequest: UploadNoticeDocumentRequest;
};


export type MutationUpsertBidReportQuestionsArgs = {
  UpsertBidReportQuestionsRequest: UpsertBidReportQuestionsRequest;
};

/** Notice of a tender or contract */
export type Notice = {
  __typename?: 'Notice';
  /** BasicUser: Basic information for a stotles user */
  assignee?: Maybe<BasicUser>;
  awardDate?: Maybe<Scalars['String']['output']>;
  buyerContactEmail?: Maybe<Scalars['String']['output']>;
  buyerContactName?: Maybe<Scalars['String']['output']>;
  buyerContactPhone?: Maybe<Scalars['String']['output']>;
  buyers: Array<Buyer>;
  closeDate?: Maybe<Scalars['String']['output']>;
  commentCount?: Maybe<Scalars['Float']['output']>;
  comments: Array<Comment>;
  contracts: Array<Notice_Contracts>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  cpvCodes: Array<Notice_Lotsv2_CpvCodes>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duplicates: Array<Notice>;
  entityType?: Maybe<BasicNotice_EntityTypeEnum_0>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  /** Legacy relevance score retrieved directly from the database */
  legacyRelevanceScore?: Maybe<Scalars['Float']['output']>;
  lists: Array<Notice_Lists>;
  lots: Array<Notice_Lots>;
  lotsv2: Array<Notice_Lotsv2>;
  name?: Maybe<Scalars['String']['output']>;
  opportunities: Array<OpportunityBasic>;
  procurementStage: Notice_ProcurementStage;
  publishDate?: Maybe<Scalars['String']['output']>;
  qualification?: Maybe<Notice_QualificationEnum_0>;
  redacted: Scalars['Boolean']['output'];
  relatedFrameworkProcess?: Maybe<Notice_RelatedFrameworkProcess>;
  /** Relevance score retrieved from OpenSearch */
  score?: Maybe<Scalars['Float']['output']>;
  /** BasicUser: Basic information for a stotles user */
  seenByUsers: Array<BasicUser>;
  /** Signals: User's signals associated with the notice */
  signals?: Maybe<Array<SignalDefinition>>;
  source: Scalars['String']['output'];
  stage?: Maybe<BasicNotice_StageEnum_0>;
  stagev2?: Maybe<Notice_Timeline_Award_StageEnum_0>;
  stotlesUrl: Scalars['String']['output'];
  suppliers: Array<Notice_Suppliers>;
  tenderDate?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Notice_Timeline>;
  url: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

/** Retrieves the number of contracts between the target orgs and a single anchor organisation. */
export type NoticeCountByCrossRefOrgRequest = {
  /** The organisation that is the reference point of the counts */
  anchorOrgId: Scalars['String']['input'];
  /** The role of the anchor organisation */
  anchorRole: NoticeCountByCrossRefOrgRequest_AnchorRoleEnum_1;
  /** The orgs which we are getting the notice counts for. If left empty then we don't subset the orgs which are cross references with the anchor */
  targetOrgIds: Array<Scalars['String']['input']>;
};

/** The role of the anchor organisation */
export enum NoticeCountByCrossRefOrgRequest_AnchorRoleEnum_1 {
  Buyer = 'Buyer',
  Supplier = 'Supplier'
}

/** Request to search through notice text fields for a given set of keywords and/or organisations & their aliases */
export type NoticeHighlightRequest = {
  /** If true, all signals are highlighted in the notice text */
  highlightSignals: Scalars['Boolean']['input'];
  /** A list of keywords to search for in the notice. */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Procurement stage IDs for the notice */
  noticeId: Scalars['String']['input'];
  /** Guids of the organisations which we'd like to highlight in the notice, their aliases will also be included later */
  orgIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Contains highlighted text for title and description in a notice */
export type NoticeHighlightResponse = {
  __typename?: 'NoticeHighlightResponse';
  /** Highlights in the description that correspond to the search query */
  description?: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights in the title that correspond to the search query */
  title?: Maybe<Array<Scalars['String']['output']>>;
};

export type Notice_Contracts = {
  __typename?: 'Notice_Contracts';
  awardDate?: Maybe<Scalars['String']['output']>;
  awardId: Scalars['String']['output'];
  contractPeriod?: Maybe<Notice_Contracts_ContractPeriod>;
  cpvCodes: Array<Notice_Lotsv2_CpvCodes>;
  description?: Maybe<Scalars['String']['output']>;
  lots: Array<Notice_Contracts_Lots>;
  suppliers: Array<Notice_Contracts_Suppliers>;
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Notice_Contracts_Value>;
};

export type Notice_Contracts_ContractPeriod = {
  __typename?: 'Notice_Contracts_ContractPeriod';
  endDate?: Maybe<Scalars['String']['output']>;
  maxExtentDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Notice_Contracts_Lots = {
  __typename?: 'Notice_Contracts_Lots';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Notice_Contracts_Suppliers = {
  __typename?: 'Notice_Contracts_Suppliers';
  guid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Notice_Contracts_Value = {
  __typename?: 'Notice_Contracts_Value';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Notice_Contracts_Value_CurrencyEnum_0>;
};

/** Enum values for Notice_Contracts_Value.currency */
export enum Notice_Contracts_Value_CurrencyEnum_0 {
  Amd = 'AMD',
  Arp = 'ARP',
  Adp = 'Adp',
  Aed = 'Aed',
  Afa = 'Afa',
  Afn = 'Afn',
  Alk = 'Alk',
  All = 'All',
  Ang = 'Ang',
  Aoa = 'Aoa',
  Aok = 'Aok',
  Aon = 'Aon',
  Aor = 'Aor',
  Ara = 'Ara',
  Ars = 'Ars',
  Ary = 'Ary',
  Ats = 'Ats',
  Aud = 'Aud',
  Awg = 'Awg',
  Aym = 'Aym',
  Azm = 'Azm',
  Azn = 'Azn',
  Bam = 'BAM',
  Brr = 'BRR',
  Bsd = 'BSD',
  Bad = 'Bad',
  Bbd = 'Bbd',
  Bdt = 'Bdt',
  Bec = 'Bec',
  Bef = 'Bef',
  Bel = 'Bel',
  Bgj = 'Bgj',
  Bgk = 'Bgk',
  Bgl = 'Bgl',
  Bgn = 'Bgn',
  Bhd = 'Bhd',
  Bif = 'Bif',
  Bmd = 'Bmd',
  Bnd = 'Bnd',
  Bob = 'Bob',
  Bop = 'Bop',
  Bov = 'Bov',
  Brb = 'Brb',
  Brc = 'Brc',
  Bre = 'Bre',
  Brl = 'Brl',
  Brn = 'Brn',
  Btn = 'Btn',
  Buk = 'Buk',
  Bwp = 'Bwp',
  Byb = 'Byb',
  Byn = 'Byn',
  Byr = 'Byr',
  Bzd = 'Bzd',
  Cad = 'CAD',
  Crc = 'CRC',
  Cdf = 'Cdf',
  Chc = 'Chc',
  Che = 'Che',
  Chf = 'Chf',
  Chw = 'Chw',
  Clf = 'Clf',
  Clp = 'Clp',
  Cny = 'Cny',
  Cop = 'Cop',
  Cou = 'Cou',
  Csd = 'Csd',
  Csj = 'Csj',
  Csk = 'Csk',
  Cuc = 'Cuc',
  Cup = 'Cup',
  Cve = 'Cve',
  Cyp = 'Cyp',
  Czk = 'Czk',
  Ddm = 'Ddm',
  Dem = 'Dem',
  Djf = 'Djf',
  Dkk = 'Dkk',
  Dop = 'Dop',
  Dzd = 'Dzd',
  Egp = 'EGP',
  Esb = 'ESB',
  Ecs = 'Ecs',
  Ecv = 'Ecv',
  Eek = 'Eek',
  Ern = 'Ern',
  Esa = 'Esa',
  Esp = 'Esp',
  Etb = 'Etb',
  Eur = 'Eur',
  Fim = 'Fim',
  Fjd = 'Fjd',
  Fkp = 'Fkp',
  Frf = 'Frf',
  Gbp = 'Gbp',
  Gek = 'Gek',
  Gel = 'Gel',
  Ghc = 'Ghc',
  Ghp = 'Ghp',
  Ghs = 'Ghs',
  Gip = 'Gip',
  Gmd = 'Gmd',
  Gne = 'Gne',
  Gnf = 'Gnf',
  Gns = 'Gns',
  Gqe = 'Gqe',
  Grd = 'Grd',
  Gtq = 'Gtq',
  Gwe = 'Gwe',
  Gwp = 'Gwp',
  Gyd = 'Gyd',
  Hkd = 'Hkd',
  Hnl = 'Hnl',
  Hrd = 'Hrd',
  Hrk = 'Hrk',
  Htg = 'Htg',
  Huf = 'Huf',
  Itl = 'ITL',
  Idr = 'Idr',
  Iep = 'Iep',
  Ilp = 'Ilp',
  Ilr = 'Ilr',
  Ils = 'Ils',
  Inr = 'Inr',
  Iqd = 'Iqd',
  Irr = 'Irr',
  Isj = 'Isj',
  Isk = 'Isk',
  Jmd = 'Jmd',
  Jod = 'Jod',
  Jpy = 'Jpy',
  Kes = 'Kes',
  Kgs = 'Kgs',
  Khr = 'Khr',
  Kmf = 'Kmf',
  Kpw = 'Kpw',
  Krw = 'Krw',
  Kwd = 'Kwd',
  Kyd = 'Kyd',
  Kzt = 'Kzt',
  Ltl = 'LTL',
  Laj = 'Laj',
  Lak = 'Lak',
  Lbp = 'Lbp',
  Lkr = 'Lkr',
  Lrd = 'Lrd',
  Lsl = 'Lsl',
  Lsm = 'Lsm',
  Ltt = 'Ltt',
  Luc = 'Luc',
  Luf = 'Luf',
  Lul = 'Lul',
  Lvl = 'Lvl',
  Lvr = 'Lvr',
  Lyd = 'Lyd',
  Mad = 'Mad',
  Mdl = 'Mdl',
  Mga = 'Mga',
  Mgf = 'Mgf',
  Mkd = 'Mkd',
  Mlf = 'Mlf',
  Mmk = 'Mmk',
  Mnt = 'Mnt',
  Mop = 'Mop',
  Mro = 'Mro',
  Mru = 'Mru',
  Mtl = 'Mtl',
  Mtp = 'Mtp',
  Mur = 'Mur',
  Mvq = 'Mvq',
  Mvr = 'Mvr',
  Mwk = 'Mwk',
  Mxn = 'Mxn',
  Mxp = 'Mxp',
  Mxv = 'Mxv',
  Myr = 'Myr',
  Mze = 'Mze',
  Mzm = 'Mzm',
  Mzn = 'Mzn',
  Nic = 'NIC',
  Nio = 'NIO',
  Nad = 'Nad',
  Ngn = 'Ngn',
  Nlg = 'Nlg',
  Nok = 'Nok',
  Npr = 'Npr',
  Nzd = 'Nzd',
  Omr = 'OMR',
  Php = 'PHP',
  Pab = 'Pab',
  Peh = 'Peh',
  Pei = 'Pei',
  Pen = 'Pen',
  Pes = 'Pes',
  Pgk = 'Pgk',
  Pkr = 'Pkr',
  Pln = 'Pln',
  Plz = 'Plz',
  Pte = 'Pte',
  Pyg = 'Pyg',
  Qar = 'Qar',
  Rhd = 'Rhd',
  Rok = 'Rok',
  Rol = 'Rol',
  Ron = 'Ron',
  Rsd = 'Rsd',
  Rub = 'Rub',
  Rur = 'Rur',
  Rwf = 'Rwf',
  Sdp = 'SDP',
  Ssp = 'SSP',
  Svc = 'SVC',
  Sar = 'Sar',
  Sbd = 'Sbd',
  Scr = 'Scr',
  Sdd = 'Sdd',
  Sdg = 'Sdg',
  Sek = 'Sek',
  Sgd = 'Sgd',
  Shp = 'Shp',
  Sit = 'Sit',
  Skk = 'Skk',
  Sll = 'Sll',
  Sos = 'Sos',
  Srd = 'Srd',
  Srg = 'Srg',
  Std = 'Std',
  Stn = 'Stn',
  Sur = 'Sur',
  Syp = 'Syp',
  Szl = 'Szl',
  Thb = 'Thb',
  Tjr = 'Tjr',
  Tjs = 'Tjs',
  Tmm = 'Tmm',
  Tmt = 'Tmt',
  Tnd = 'Tnd',
  Top = 'Top',
  Tpe = 'Tpe',
  Trl = 'Trl',
  Try = 'Try',
  Ttd = 'Ttd',
  Twd = 'Twd',
  Tzs = 'Tzs',
  Uah = 'Uah',
  Uak = 'Uak',
  Ugs = 'Ugs',
  Ugw = 'Ugw',
  Ugx = 'Ugx',
  Usd = 'Usd',
  Usn = 'Usn',
  Uss = 'Uss',
  Uyi = 'Uyi',
  Uyn = 'Uyn',
  Uyp = 'Uyp',
  Uyu = 'Uyu',
  Uyw = 'Uyw',
  Uzs = 'Uzs',
  Vnc = 'VNC',
  Veb = 'Veb',
  Vef = 'Vef',
  Ves = 'Ves',
  Vnd = 'Vnd',
  Vuv = 'Vuv',
  Wst = 'Wst',
  Xag = 'XAG',
  Xaf = 'Xaf',
  Xau = 'Xau',
  Xba = 'Xba',
  Xbb = 'Xbb',
  Xbc = 'Xbc',
  Xbd = 'Xbd',
  Xcd = 'Xcd',
  Xdr = 'Xdr',
  Xeu = 'Xeu',
  Xfo = 'Xfo',
  Xfu = 'Xfu',
  Xof = 'Xof',
  Xpd = 'Xpd',
  Xpf = 'Xpf',
  Xpt = 'Xpt',
  Xre = 'Xre',
  Xsu = 'Xsu',
  Xts = 'Xts',
  Xua = 'Xua',
  Xxx = 'Xxx',
  Ydd = 'Ydd',
  Yer = 'Yer',
  Yud = 'Yud',
  Yum = 'Yum',
  Yun = 'Yun',
  Zal = 'Zal',
  Zar = 'Zar',
  Zmk = 'Zmk',
  Zmw = 'Zmw',
  Zrn = 'Zrn',
  Zrz = 'Zrz',
  Zwc = 'Zwc',
  Zwd = 'Zwd',
  Zwl = 'Zwl',
  Zwn = 'Zwn',
  Zwr = 'Zwr'
}

export type Notice_Lists = {
  __typename?: 'Notice_Lists';
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type Notice_Lots = {
  __typename?: 'Notice_Lots';
  awardDate?: Maybe<Scalars['String']['output']>;
  awarded: Scalars['Boolean']['output'];
  calculatedExpiry?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  lotNumber?: Maybe<Scalars['String']['output']>;
  lotTitle?: Maybe<Scalars['String']['output']>;
  placeOfPerformance?: Maybe<Scalars['String']['output']>;
  recordGuid: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  /** SupplierSchema: represents a supplier. */
  suppliers?: Maybe<Array<Notice_Lots_Suppliers>>;
  tendersReceived?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** SupplierSchema: represents a supplier. */
export type Notice_Lots_Suppliers = {
  __typename?: 'Notice_Lots_Suppliers';
  address: Scalars['String']['output'];
  categorySrc: Scalars['String']['output'];
  categoryUni: Scalars['String']['output'];
  cleanName: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  fax: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isArchived: Scalars['Boolean']['output'];
  isSme?: Maybe<Scalars['Boolean']['output']>;
  isStotlesVerified: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nuts: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  referenceCode: Scalars['String']['output'];
  town: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type Notice_Lotsv2 = {
  __typename?: 'Notice_Lotsv2';
  contractPeriod?: Maybe<Notice_Lotsv2_ContractPeriod>;
  cpvCodes: Array<Notice_Lotsv2_CpvCodes>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  value?: Maybe<Notice_Lotsv2_Value>;
};

export type Notice_Lotsv2_ContractPeriod = {
  __typename?: 'Notice_Lotsv2_ContractPeriod';
  endDate?: Maybe<Scalars['String']['output']>;
  maxExtentDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type Notice_Lotsv2_CpvCodes = {
  __typename?: 'Notice_Lotsv2_CpvCodes';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Notice_Lotsv2_Value = {
  __typename?: 'Notice_Lotsv2_Value';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Notice_Contracts_Value_CurrencyEnum_0>;
};

export type Notice_ProcurementStage = {
  __typename?: 'Notice_ProcurementStage';
  id: Scalars['String']['output'];
  internalId?: Maybe<Scalars['Float']['output']>;
  procurementProcessId: Scalars['String']['output'];
  stage?: Maybe<Notice_ProcurementStage_StageEnum_0>;
};

/** Enum values for Notice_ProcurementStage.stage */
export enum Notice_ProcurementStage_StageEnum_0 {
  Award = 'Award',
  PreTender = 'PreTender',
  Tender = 'Tender'
}

/** Enum values for Notice.qualification */
export enum Notice_QualificationEnum_0 {
  BidPrep = 'BidPrep',
  BidSubmitted = 'BidSubmitted',
  InReview = 'InReview',
  Lost = 'Lost',
  NoBid = 'NoBid',
  NotRelevant = 'NotRelevant',
  PreEngageDone = 'PreEngageDone',
  PreEngageNotRelevant = 'PreEngageNotRelevant',
  PreEngageToDo = 'PreEngageToDo',
  Unqualified = 'Unqualified',
  Won = 'Won'
}

export type Notice_RelatedFrameworkProcess = {
  __typename?: 'Notice_RelatedFrameworkProcess';
  frameworkId: Scalars['String']['output'];
  frameworkName: Scalars['String']['output'];
  processType: Notice_RelatedFrameworkProcess_ProcessTypeEnum_0;
};

/** Enum values for Notice_RelatedFrameworkProcess.processType */
export enum Notice_RelatedFrameworkProcess_ProcessTypeEnum_0 {
  Framework = 'FRAMEWORK',
  FrameworkCallOff = 'FRAMEWORK_CALL_OFF'
}

export type Notice_Suppliers = {
  __typename?: 'Notice_Suppliers';
  guid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isSme?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type Notice_Timeline = {
  __typename?: 'Notice_Timeline';
  award: Array<Notice_Timeline_Award>;
  preTender?: Maybe<Notice_Timeline_PreTender>;
  tender?: Maybe<Notice_Timeline_Tender>;
};

export type Notice_Timeline_Award = {
  __typename?: 'Notice_Timeline_Award';
  awardDate?: Maybe<Scalars['String']['output']>;
  estimated: Scalars['Boolean']['output'];
  expiryDate?: Maybe<Scalars['String']['output']>;
  extensionDate?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Notice_Timeline_Award_StageEnum_0>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Enum values for Notice_Timeline_Award.stage */
export enum Notice_Timeline_Award_StageEnum_0 {
  AwardedContract = 'AWARDED_CONTRACT',
  CancelledAward = 'CANCELLED_AWARD',
  CancelledTender = 'CANCELLED_TENDER',
  ClosedTender = 'CLOSED_TENDER',
  ExpiredContract = 'EXPIRED_CONTRACT',
  OpenTender = 'OPEN_TENDER',
  Pipeline = 'PIPELINE',
  PreTenderV2 = 'PRE_TENDER_V2',
  StalePreTenderV2 = 'STALE_PRE_TENDER_V2',
  UnknownTender = 'UNKNOWN_TENDER'
}

export type Notice_Timeline_PreTender = {
  __typename?: 'Notice_Timeline_PreTender';
  deadlineDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Notice_Timeline_Award_StageEnum_0>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Notice_Timeline_Tender = {
  __typename?: 'Notice_Timeline_Tender';
  clarificationDate?: Maybe<Scalars['String']['output']>;
  closeDate?: Maybe<Scalars['String']['output']>;
  estimated: Scalars['Boolean']['output'];
  publishedDate?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Notice_Timeline_Award_StageEnum_0>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Notices analysis */
export type NoticesAnalysis = {
  __typename?: 'NoticesAnalysis';
  byGroup?: Maybe<NoticesAnalysis_ByGroup>;
  byPeriod?: Maybe<NoticesAnalysis_ByPeriod>;
  overall?: Maybe<NoticesAnalysis_Overall>;
};


/** Notices analysis */
export type NoticesAnalysisByGroupArgs = {
  NoticesAnalysisByGroupRequest: NoticesAnalysisByGroupRequestSchema;
};


/** Notices analysis */
export type NoticesAnalysisByPeriodArgs = {
  NoticesAnalysisByPeriodRequest: NoticesAnalysisByPeriodRequestSchema;
};

/** Arguments set on byGroup */
export type NoticesAnalysisByGroupRequestSchema = {
  groupBy: NoticesAnalysisByGroupRequestSchema_GroupByEnum_0;
  /** Limit the number of results returned */
  limit: Scalars['Float']['input'];
  /** The current page number */
  page: Scalars['Float']['input'];
  /** Sort field for the results */
  sort: NoticesAnalysisByGroupRequestSchema_SortEnum_0;
  /** Sort order for the results */
  sortOrder: NoticesAnalysisByGroupRequestSchema_SortOrderEnum_0;
};

/** Enum values for NoticesAnalysisByGroupRequestSchema.groupBy */
export enum NoticesAnalysisByGroupRequestSchema_GroupByEnum_0 {
  Buyer = 'BUYER',
  Supplier = 'SUPPLIER'
}

/** Sort field for the results */
export enum NoticesAnalysisByGroupRequestSchema_SortEnum_0 {
  NoticeCount = 'NOTICE_COUNT',
  NoticeValues = 'NOTICE_VALUES'
}

/** Sort order for the results */
export enum NoticesAnalysisByGroupRequestSchema_SortOrderEnum_0 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Arguments set on byPeriod */
export type NoticesAnalysisByPeriodRequestSchema = {
  groupBy: NoticesAnalysisByPeriodRequestSchema_GroupByEnum_0;
  interval: NoticesAnalysisByPeriodRequestSchema_IntervalEnum_0;
};

/** Enum values for NoticesAnalysisByPeriodRequestSchema.groupBy */
export enum NoticesAnalysisByPeriodRequestSchema_GroupByEnum_0 {
  AwardDate = 'AWARD_DATE',
  ExpiryDate = 'EXPIRY_DATE',
  PublishDate = 'PUBLISH_DATE'
}

/** Enum values for NoticesAnalysisByPeriodRequestSchema.interval */
export enum NoticesAnalysisByPeriodRequestSchema_IntervalEnum_0 {
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export type NoticesAnalysis_ByGroup = {
  __typename?: 'NoticesAnalysis_ByGroup';
  maxNoticeCount: Scalars['Float']['output'];
  maxNoticeValues: Scalars['Float']['output'];
  results: Array<NoticesAnalysis_ByGroup_Results>;
  totalResults: Scalars['Float']['output'];
};

export type NoticesAnalysis_ByGroup_Results = {
  __typename?: 'NoticesAnalysis_ByGroup_Results';
  guid: Scalars['String']['output'];
  isSavedCount: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  noticeCount: Scalars['Float']['output'];
  noticeValues: Scalars['Float']['output'];
};

export type NoticesAnalysis_ByPeriod = {
  __typename?: 'NoticesAnalysis_ByPeriod';
  results: Array<NoticesAnalysis_ByPeriod_Results>;
};

export type NoticesAnalysis_ByPeriod_Results = {
  __typename?: 'NoticesAnalysis_ByPeriod_Results';
  dateEnd: Scalars['String']['output'];
  dateStart: Scalars['String']['output'];
  noticeCount: Scalars['Float']['output'];
  noticeValues: Scalars['Float']['output'];
};

export type NoticesAnalysis_Overall = {
  __typename?: 'NoticesAnalysis_Overall';
  noticeValues: Scalars['Float']['output'];
};

/** retrieve notice count by organisation */
export type NoticesCountRequestSchema = {
  orgIds: Array<Scalars['String']['input']>;
  /** NoticeOrgType: type of organisation */
  orgType: NoticesCountRequestSchema_OrgTypeEnum_1;
  sortOrder?: NoticesCountRequestSchema_SortOrderEnum_1;
};

/** NoticeOrgType: type of organisation */
export enum NoticesCountRequestSchema_OrgTypeEnum_1 {
  Buyer = 'BUYER',
  Supplier = 'SUPPLIER'
}

/** Enum values for NoticesCountRequestSchema.sortOrder */
export enum NoticesCountRequestSchema_SortOrderEnum_1 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** a list of notice counts by org ids */
export type NoticesCountResponseSchema = {
  __typename?: 'NoticesCountResponseSchema';
  results: Array<NoticesCountResponseSchema_Results>;
  totalResults: Scalars['Float']['output'];
};

export type NoticesCountResponseSchema_Results = {
  __typename?: 'NoticesCountResponseSchema_Results';
  noticeCount: Scalars['Float']['output'];
  orgId: Scalars['String']['output'];
};

/** Notices search results */
export type NoticesSearch = {
  __typename?: 'NoticesSearch';
  analysis?: Maybe<NoticesAnalysis>;
  /** Notice: notice of a tender or contract */
  results: Array<Notice>;
  totalResults: Scalars['Float']['output'];
};

/** Request to search for notices */
export type NoticesSearchRequest = {
  /** Guids of the user assigned to the notice */
  assignees?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date filter for the award date of the notice */
  awardDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  /** Buyer filters */
  buyerFilters?: InputMaybe<NoticesSearchRequest_BuyerFilters>;
  /** Date filter for the close date of the notice */
  closeDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtering by CPV code can be the whole CPV code or the CPV dimensions which represent the prefix of a certain category of cpv code */
  cpvCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If a notice includes one of these excludeKeywords - it is excluded from the search results. */
  excludeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date filter for the expiry date of the notice */
  expiryDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  /** Includes or excludes framework activity */
  frameworkActivity?: InputMaybe<NoticesSearchRequest_FrameworkActivityEnum_1>;
  /** Guids of frameworks to filter notices by */
  frameworks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter for SME suppliers. If true, show only SMEs, if false show only non-SMEs, if not set then show all */
  isSME?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of keywords to search for in the notice. */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit the number of results returned */
  limit: Scalars['Float']['input'];
  /** Minimum relevance score for the results. In the range of 0 - 3 */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** Procurement stage IDs for the notices */
  noticeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Integer Ids of the notice lists */
  noticeLists?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** The current page number */
  page: Scalars['Float']['input'];
  /** Date filter for the publish date of the notice */
  publishDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  /** QualificationsEnum: Procurement Stage qualification */
  qualifications?: InputMaybe<Array<NoticesSearchRequest_QualificationsEnum_1>>;
  /** Text search input by the user */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** Signals to filter notices by */
  signals?: InputMaybe<NoticesSearchRequest_Signals>;
  /** Sort field for the results */
  sort?: NoticesSearchRequest_SortEnum_1;
  /** Sort order for the results */
  sortOrder: NoticesSearchRequest_SortOrderEnum_1;
  stages?: InputMaybe<Array<NoticesSearchRequest_StagesEnum_1>>;
  /**
   *
   * SupplierMentionTypeSchema: Filter which allows user to distinguish whether or not they want to filter notices/frameworks by
   * suppliers that are directly awarded these entities, just mentioned in them (string name mentioned in the title/description etc.), or both.
   *
   */
  supplierMentionType?: InputMaybe<NoticesSearchRequest_SupplierMentionTypeEnum_1>;
  /** Guids of the organisations the tender was awarded to. Also can contain select all tokens */
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Allows filtering by min and max values, as well as hiding null values */
  value?: InputMaybe<NoticesSearchRequest_Value>;
};

/** Request to search for notices */
export type NoticesSearchRequest_BuyerFilters = {
  /** Guids of the categories of the buyers */
  buyerCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Country codes of the buyers */
  buyerCountryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Guids of the buyer lists */
  buyerLists?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Guids of the regions of buyers */
  buyerRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Guids of the buyers */
  buyers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Request to search for notices */
export type NoticesSearchRequest_CloseDate = {
  /** DateRangeFilter: Allows filtering by min and max dates, can either be discrete dates or relative date filtering   Must be arranged in a singular object so it can be used in the DateRange component in the frontend */
  filter?: InputMaybe<NoticesSearchRequest_CloseDate_Filter>;
  /** Whether or not nulls are hidden in the final results */
  hideNulls?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Request to search for notices */
export type NoticesSearchRequest_CloseDate_Filter = {
  /** Min date the user is filtering from. If not provided, no lower bound is applied */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Relative dates are when we compare the date relatv=ive to today (e.g. 1 month ago) */
  relativeFrom?: InputMaybe<Scalars['String']['input']>;
  /** Relative dates are when we compare the date relatv=ive to today (e.g. 1 month ago) */
  relativeTo?: InputMaybe<Scalars['String']['input']>;
  /** Max date the user is filtering from. If not provided, no upper bound is applied */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Enum values for NoticesSearchRequest.frameworkActivity */
export enum NoticesSearchRequest_FrameworkActivityEnum_1 {
  HideAllFrameworkActivity = 'HIDE_ALL_FRAMEWORK_ACTIVITY',
  HideFrameworkAgreementNotices = 'HIDE_FRAMEWORK_AGREEMENT_NOTICES',
  ShowOnlyFrameworkCallOffs = 'SHOW_ONLY_FRAMEWORK_CALL_OFFS'
}

/** QualificationsEnum: Procurement Stage qualification */
export enum NoticesSearchRequest_QualificationsEnum_1 {
  BidPrep = 'BidPrep',
  BidSubmitted = 'BidSubmitted',
  InReview = 'InReview',
  Lost = 'Lost',
  NoBid = 'NoBid',
  NotRelevant = 'NotRelevant',
  PreEngageDone = 'PreEngageDone',
  PreEngageNotRelevant = 'PreEngageNotRelevant',
  PreEngageToDo = 'PreEngageToDo',
  Unqualified = 'Unqualified',
  Won = 'Won'
}

/** Request to search for notices */
export type NoticesSearchRequest_Signals = {
  categories: Array<Scalars['String']['input']>;
  signalIds: Array<Scalars['String']['input']>;
};

/** Enum values for NoticesSearchRequest.sort */
export enum NoticesSearchRequest_SortEnum_1 {
  AwardDate = 'AWARD_DATE',
  CloseDate = 'CLOSE_DATE',
  Country = 'COUNTRY',
  ExpiryDate = 'EXPIRY_DATE',
  PublishedDate = 'PUBLISHED_DATE',
  Score = 'SCORE',
  Title = 'TITLE',
  ValueAmount = 'VALUE_AMOUNT'
}

/** Sort order for the results */
export enum NoticesSearchRequest_SortOrderEnum_1 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Enum values for NoticesSearchRequest.stages */
export enum NoticesSearchRequest_StagesEnum_1 {
  Awarded = 'AWARDED',
  AwardedContract = 'AWARDED_CONTRACT',
  CancelledAward = 'CANCELLED_AWARD',
  CancelledTender = 'CANCELLED_TENDER',
  Closed = 'CLOSED',
  ClosedTender = 'CLOSED_TENDER',
  ExpiredContract = 'EXPIRED_CONTRACT',
  Open = 'OPEN',
  OpenTender = 'OPEN_TENDER',
  Pipeline = 'PIPELINE',
  PreTender = 'PRE_TENDER',
  PreTenderV2 = 'PRE_TENDER_V2',
  StalePreTender = 'STALE_PRE_TENDER',
  StalePreTenderV2 = 'STALE_PRE_TENDER_V2',
  UnknownTender = 'UNKNOWN_TENDER'
}

/**
 *
 * SupplierMentionTypeSchema: Filter which allows user to distinguish whether or not they want to filter notices/frameworks by
 * suppliers that are directly awarded these entities, just mentioned in them (string name mentioned in the title/description etc.), or both.
 *
 */
export enum NoticesSearchRequest_SupplierMentionTypeEnum_1 {
  DirectlyAwarded = 'DIRECTLY_AWARDED',
  MentionedInOnly = 'MENTIONED_IN_ONLY',
  MentionedOrDirectlyAwarded = 'MENTIONED_OR_DIRECTLY_AWARDED'
}

/** Request to search for notices */
export type NoticesSearchRequest_Value = {
  /** Min value the user is filtering from. If not provided, no lower bound is applied */
  from?: InputMaybe<Scalars['Float']['input']>;
  /** Whether or not nulls are hidden in the final results */
  hideNulls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Max value the user is filtering from. If not provided, no upper bound is applied */
  to?: InputMaybe<Scalars['Float']['input']>;
};

/** Response for evaluation */
export type OppBuyerActivityEvaluationResponse = {
  __typename?: 'OppBuyerActivityEvaluationResponse';
  experimentWebUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** results of a search for opportunities */
export type OpportunitiesResponse = {
  __typename?: 'OpportunitiesResponse';
  /** Opportunity: A stotles opportunity */
  results: Array<Opportunity>;
  total: Scalars['Float']['output'];
};

/** A stotles opportunity */
export type Opportunity = {
  __typename?: 'Opportunity';
  /** User: Stotles user */
  assignedTo?: Maybe<User>;
  /** Bid: A simple bid object */
  bid?: Maybe<Bid>;
  /** OpportunityBuyerActivity: the buyer activity for an opportunity */
  buyerActivity?: Maybe<OpportunityBuyerActivity>;
  /** Organisation: Broad type which can describe a buyer, a supplier, a public body, etc. */
  buyers: Array<Organisation>;
  clarificationDeadline?: Maybe<Scalars['String']['output']>;
  closeDate?: Maybe<Scalars['String']['output']>;
  /** Comment: a users comment */
  comments: Array<Comment>;
  /** Contact: a Stotles contact (underlying model comes from Oscar) */
  contacts: Array<Contact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** User: Stotles user */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Document: A document published by an organisation */
  documents: Array<Document>;
  entityIds: Array<Scalars['String']['output']>;
  existingExpiryDate?: Maybe<Scalars['String']['output']>;
  /** Framework: Top level representation for the procurement process of a framework,     including past and present stages */
  frameworks: Array<Framework>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Notice: notice of a tender or contract */
  notices: Array<Notice>;
  routeToMarket?: Maybe<Scalars['String']['output']>;
  /** OpportunityWorkflowStage: A stage in the workflow */
  stage: OpportunityWorkflowStage;
  startDate?: Maybe<Scalars['String']['output']>;
  submissionDate?: Maybe<Scalars['String']['output']>;
  /** PartnersBuyerSummary: notice summary data for partners */
  supplierBuyerNoticeSummary: Array<PartnersBuyerSummary>;
  /** Organisation: Broad type which can describe a buyer, a supplier, a public body, etc. */
  suppliers: Array<Organisation>;
  /** BasicTeam: A team without any complex relational data */
  team: BasicTeam;
  updatedAt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};


/** A stotles opportunity */
export type OpportunitySupplierBuyerNoticeSummaryArgs = {
  SupplierBuyerNoticeSummaryRequest?: InputMaybe<SupplierBuyerNoticeSummaryRequest>;
};

/** A opportunity without any complex relational data */
export type OpportunityBasic = {
  __typename?: 'OpportunityBasic';
  clarificationDeadline?: Maybe<Scalars['String']['output']>;
  closeDate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  existingExpiryDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  routeToMarket?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  submissionDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** the buyer activity for an opportunity */
export type OpportunityBuyerActivity = {
  __typename?: 'OpportunityBuyerActivity';
  createdAt?: Maybe<Scalars['String']['output']>;
  questions: Array<OpportunityBuyerActivity_Questions>;
  /** Notice: notice of a tender or contract */
  relatedNotices: Array<Notice>;
  status?: Maybe<OpportunityBuyerActivity_StatusEnum_0>;
};

export type OpportunityBuyerActivity_Questions = {
  __typename?: 'OpportunityBuyerActivity_Questions';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

/** Enum values for OpportunityBuyerActivity.status */
export enum OpportunityBuyerActivity_StatusEnum_0 {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Pending = 'PENDING'
}

/** Request to retrieve opportunity count */
export type OpportunityCountSearchRequest = {
  assignee?: InputMaybe<OpportunityCountSearchRequest_Assignee>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Request to retrieve opportunity count */
export type OpportunityCountSearchRequest_Assignee = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeNulls?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response for deleting opportunity entities */
export type OpportunityEntitiesDeleteResponse = {
  __typename?: 'OpportunityEntitiesDeleteResponse';
  bidIds: Array<Scalars['String']['output']>;
  ids: Array<Scalars['String']['output']>;
};

/** Input for a opportunity entity */
export type OpportunityEntitiesInput = {
  /** OpportunityEntities: A stotles opportunity entity */
  entities: Array<OpportunityEntitiesInput_Entities>;
};

/** Input for a opportunity entity */
export type OpportunityEntitiesInput_Entities = {
  entityId: Scalars['String']['input'];
  /** OpportunityEntityType: "notice" | "contact" | "organisation" | "document" | "framework" */
  entityType: OpportunityEntitiesInput_Entities_EntityTypeEnum_1;
};

/** OpportunityEntityType: "notice" | "contact" | "organisation" | "document" | "framework" */
export enum OpportunityEntitiesInput_Entities_EntityTypeEnum_1 {
  Contact = 'contact',
  Document = 'document',
  Framework = 'framework',
  Notice = 'notice',
  Organisation = 'organisation'
}

/** Response for updating opportunity entities */
export type OpportunityEntitiesUpdateResponse = {
  __typename?: 'OpportunityEntitiesUpdateResponse';
  id: Scalars['String']['output'];
};

/** start an evaluation */
export type OpportunityEvaluationRequest = {
  /** Dataset name */
  dataset: Scalars['String']['input'];
  /** Override options for the evaluation */
  opportunityEvaluationOverrides?: InputMaybe<OpportunityEvaluationRequest_OpportunityEvaluationOverrides>;
  /** Type of evaluation */
  type: OpportunityEvaluationRequest_TypeEnum_1;
};

/** start an evaluation */
export type OpportunityEvaluationRequest_OpportunityEvaluationOverrides = {
  model?: InputMaybe<Scalars['String']['input']>;
  prompt?: InputMaybe<Array<OpportunityEvaluationRequest_OpportunityEvaluationOverrides_Prompt>>;
  totalSemanticSearchResults?: InputMaybe<Scalars['Float']['input']>;
};

/** start an evaluation */
export type OpportunityEvaluationRequest_OpportunityEvaluationOverrides_Prompt = {
  content: Scalars['String']['input'];
  role: OpportunityEvaluationRequest_OpportunityEvaluationOverrides_Prompt_RoleEnum_1;
};

/** Enum values for OpportunityEvaluationRequest_OpportunityEvaluationOverrides_Prompt.role */
export enum OpportunityEvaluationRequest_OpportunityEvaluationOverrides_Prompt_RoleEnum_1 {
  System = 'system',
  User = 'user'
}

/** Type of evaluation */
export enum OpportunityEvaluationRequest_TypeEnum_1 {
  QuestionsAnswered = 'questionsAnswered',
  RelatedNotices = 'relatedNotices'
}

/** Input to update an opportunity */
export type OpportunityUpdateInput = {
  assignedToId?: InputMaybe<Scalars['String']['input']>;
  clarificationDeadline?: InputMaybe<Scalars['String']['input']>;
  closeDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  existingExpiryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  routeToMarket?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  submissionDate?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** A workflow for opportunities */
export type OpportunityWorkflow = {
  __typename?: 'OpportunityWorkflow';
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  teamId: Scalars['String']['output'];
  /** OpportunityWorkflowTransition: A transition in the workflow */
  transitions: Array<OpportunityWorkflow_Transitions>;
};

/** A stage in the workflow */
export type OpportunityWorkflowStage = {
  __typename?: 'OpportunityWorkflowStage';
  color: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  opportunityCount?: Maybe<Scalars['Float']['output']>;
  /** The tranisition group of the workflow stage */
  transitionGroup?: Maybe<Scalars['String']['output']>;
};


/** A stage in the workflow */
export type OpportunityWorkflowStageOpportunityCountArgs = {
  OpportunityCountSearchRequest?: InputMaybe<OpportunityCountSearchRequest>;
};

/** OpportunityWorkflowTransition: A transition in the workflow */
export type OpportunityWorkflow_Transitions = {
  __typename?: 'OpportunityWorkflow_Transitions';
  /** WorkflowTransitionGroup: The group which the transition belongs to */
  group: OpportunityWorkflow_Transitions_GroupEnum_2;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  /** OpportunityWorkflowStage: A stage in the workflow */
  stage: OpportunityWorkflowStage;
};

/** WorkflowTransitionGroup: The group which the transition belongs to */
export enum OpportunityWorkflow_Transitions_GroupEnum_2 {
  Bidding = 'Bidding',
  Closed = 'Closed',
  PreEngagement = 'Pre_Engagement',
  TenderQualification = 'Tender_Qualification',
  Won = 'Won'
}

/** Organisation: Broad type which can describe a buyer, a supplier, a public body, etc. */
export type Organisation = {
  __typename?: 'Organisation';
  address?: Maybe<Scalars['String']['output']>;
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  categoryAssignments?: Maybe<Array<Organisation_CategoryAssignments>>;
  countryCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isStotlesVerified?: Maybe<Scalars['Boolean']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noticeCount?: Maybe<Scalars['Float']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  /** OrganisationPrimaryRole: "Buyer" | "Supplier" */
  primaryRole?: Maybe<Organisation_PrimaryRoleEnum_0>;
  town?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Organisation_CategoryAssignments = {
  __typename?: 'Organisation_CategoryAssignments';
  categoryId: Scalars['String']['output'];
  categoryName: Scalars['String']['output'];
  parentCategoryId: Scalars['String']['output'];
  parentCategoryName: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

/** OrganisationPrimaryRole: "Buyer" | "Supplier" */
export enum Organisation_PrimaryRoleEnum_0 {
  Buyer = 'Buyer',
  Supplier = 'Supplier'
}

/** properties to apply pagination to a request */
export type PaginationOptions = {
  /** The current page number */
  page?: Scalars['Int']['input'];
  /** The number of items per page */
  pageSize?: Scalars['Int']['input'];
};

/** notice summary data for partners */
export type PartnersBuyerSummary = {
  __typename?: 'PartnersBuyerSummary';
  /** AwardStats: supplier award stats */
  allAwards: PartnersBuyerSummary_AllAwards;
  /** AwardStats: supplier award stats */
  similarAwards: PartnersBuyerSummary_AllAwards;
  /** Organisation: Broad type which can describe a buyer, a supplier, a public body, etc. */
  supplier: Organisation;
};

/** AwardStats: supplier award stats */
export type PartnersBuyerSummary_AllAwards = {
  __typename?: 'PartnersBuyerSummary_AllAwards';
  totalCount: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
};

/** Persist call off config request */
export type PersistCallOffConfigRequest = {
  config: PersistCallOffConfigRequest_Config;
  frameworkId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Persist call off config request */
export type PersistCallOffConfigRequest_Config = {
  keywords: Array<Array<Scalars['String']['input']>>;
};

/** prompt for an ai model query */
export type Prompt = {
  __typename?: 'Prompt';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  /** Model: openai model to use */
  model: Prompt_ModelEnum_0;
  numberOfResults: Scalars['Float']['output'];
  numberOfSemanticSearchResults?: Maybe<Scalars['Float']['output']>;
  /** PromptTemplate: this is a template for a prompt */
  promptTemplate: Array<Prompt_PromptTemplate>;
  promptType: Prompt_PromptTypeEnum_0;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PromptTemplateInput = {
  role: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

/** Model: openai model to use */
export enum Prompt_ModelEnum_0 {
  Gpt_3p5Turbo = 'gpt_3p5_turbo',
  Gpt_3p5Turbo_0301 = 'gpt_3p5_turbo_0301',
  Gpt_3p5Turbo_0613 = 'gpt_3p5_turbo_0613',
  Gpt_3p5Turbo_16k = 'gpt_3p5_turbo_16k',
  Gpt_3p5Turbo_16k_0613 = 'gpt_3p5_turbo_16k_0613',
  Gpt_3p5Turbo_1106 = 'gpt_3p5_turbo_1106',
  Gpt_4 = 'gpt_4',
  Gpt_4_0314 = 'gpt_4_0314',
  Gpt_4_0613 = 'gpt_4_0613',
  Gpt_4_32k = 'gpt_4_32k',
  Gpt_4_32k_0314 = 'gpt_4_32k_0314',
  Gpt_4_32k_0613 = 'gpt_4_32k_0613',
  Gpt_4_1106Preview = 'gpt_4_1106_preview',
  Gpt_4VisionPreview = 'gpt_4_vision_preview',
  Gpt_4o = 'gpt_4o'
}

/** PromptTemplate: this is a template for a prompt */
export type Prompt_PromptTemplate = {
  __typename?: 'Prompt_PromptTemplate';
  role: Prompt_PromptTemplate_RoleEnum_0;
  template: Scalars['String']['output'];
};

/** Enum values for Prompt_PromptTemplate.role */
export enum Prompt_PromptTemplate_RoleEnum_0 {
  Assistant = 'assistant',
  System = 'system',
  User = 'user'
}

/** Enum values for Prompt.promptType */
export enum Prompt_PromptTypeEnum_0 {
  BuyerQa = 'buyer_qa',
  KeywordGenerator = 'keyword_generator',
  KeywordRecommendation = 'keyword_recommendation'
}

/** Arguments for providing feedback */
export type ProvideFeedbackRequest = {
  isPositive: Scalars['Boolean']['input'];
  questionId: Scalars['String']['input'];
  userDetailedFeedback?: InputMaybe<Scalars['String']['input']>;
};

/** Request to qualify a question */
export type QualifyQuestionRequest = {
  bidId: Scalars['String']['input'];
  procurementStageId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  adminTeams: Array<Team>;
  /** Search for users as admin */
  adminUsers: Array<User>;
  /** Returns all cpv codes from a const defined in the shared directory in our backend. */
  allCpvCodes: CpvCodesResponse;
  bid: Bid;
  bidAnswer: BidAnswer;
  bidAnswers: BidAnswersResponse;
  bidDocument: BidDocument;
  bidDocuments: BidDocumentsResponse;
  bidQuestionGroups: BidQuestionGroupsResponse;
  bids: BidsSearchResponse;
  buyerCpvStats: CpvStatsResponse;
  buyerList: BuyerList;
  buyers: BuyerResponse;
  callOffConfig: Framework_CallOffIdentificationRule;
  /** Get call offs for a framework */
  callOffs: Array<CallOff>;
  company: Company;
  contact: Contact;
  contacts: ContactsSearchResponse;
  /** Returns CPV codes details for a given list of CPV codes if 'codes' is provided, else returns all codes. */
  cpvCodes: CpvCodesResponse;
  credits: CreditsResponse;
  document: Document;
  documents: DocumentsSearchResponse;
  entityOpportunities: Array<Scalars['String']['output']>;
  framework: Framework;
  /** Search for frameworks */
  frameworks: FrameworkSearchResponse;
  getBidReport: Scorecard;
  getDefaultQuestions: AdminBidQuestionsResponse;
  /** Get the stored questions asked by the user */
  getQuestions: Array<Question>;
  getQuestionsByTeam: AdminBidQuestionsResponse;
  highlightDocument: DocumentHighlightResponse;
  highlightFramework: FrameworkHighlightResponse;
  highlightNotice: NoticeHighlightResponse;
  hubspotIdToken: HubspotIdTokenResponse;
  keywords: Keywords;
  keywordsRecommendation: Keywords;
  langsmithPrompts: Array<LangsmithPrompt>;
  notice: Notice;
  /** Retrieves the number of contracts between a list of suppliers or buyers and a single anchor organisation. */
  noticeCountByCrossRefOrg: Array<NoticeCountByCrossRefOrg>;
  noticeCountByOrg: NoticesCountResponseSchema;
  notices: NoticesSearch;
  opportunities: OpportunitiesResponse;
  opportunity: Opportunity;
  opportunityWorkflow: OpportunityWorkflow;
  /** Get organisations by guid */
  organisations: Array<Organisation>;
  prompt: Prompt;
  prompts: Array<Prompt>;
  recordList: RecordList;
  remainingCredits: RemainingCredits;
  /** Get organisations by request parameters */
  searchOrganisations: SearchOrganisationsResponse;
  /** returns all records that have been marked exempt from time-based de-indexing rules */
  seoExemptions: Array<SeoExemption>;
  /** Returns a user's signal settings */
  signalSettings: SignalSettings;
  /** Returns a user's signal definitions in the form of a SignalDefinition object. */
  signals: Array<SignalDefinition>;
  suppliers: SupplierDetailsResponse;
  /** Get the users current team */
  team: Team;
  /** Get all teams in the users company */
  teams: Array<Team>;
  user: User;
  /** Search for users */
  users: Array<User>;
};


export type QueryAdminTeamsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryAdminUsersArgs = {
  SearchUserRequest: SearchUserRequest;
};


export type QueryBidArgs = {
  BidRequest: BidRequest;
};


export type QueryBidAnswerArgs = {
  id: Scalars['String']['input'];
};


export type QueryBidAnswersArgs = {
  bidId: Scalars['String']['input'];
};


export type QueryBidDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryBidDocumentsArgs = {
  id: Scalars['String']['input'];
};


export type QueryBidsArgs = {
  BidsSearchRequest: BidsSearchRequest;
};


export type QueryBuyerCpvStatsArgs = {
  buyerId: Scalars['String']['input'];
  options: CpvStatsRequest;
};


export type QueryBuyerListArgs = {
  id: Scalars['String']['input'];
};


export type QueryBuyersArgs = {
  BuyersRequest: BuyersRequest;
};


export type QueryCallOffConfigArgs = {
  frameworkId: Scalars['String']['input'];
};


export type QueryCallOffsArgs = {
  frameworkId: Scalars['String']['input'];
};


export type QueryContactArgs = {
  getContactById: Scalars['String']['input'];
};


export type QueryContactsArgs = {
  SearchContactsRequest: SearchContactsRequest;
};


export type QueryCpvCodesArgs = {
  CpvCodesRequest: CpvCodesRequest;
};


export type QueryCreditsArgs = {
  CreditsSearchRequest: CreditsSearchRequest;
};


export type QueryDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  DocumentsSearchRequest: DocumentsSearchRequest;
};


export type QueryEntityOpportunitiesArgs = {
  entityId: Scalars['String']['input'];
};


export type QueryFrameworkArgs = {
  frameworkId: Scalars['String']['input'];
};


export type QueryFrameworksArgs = {
  SearchFrameworksRequest: SearchFrameworksRequest;
};


export type QueryGetBidReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetQuestionsArgs = {
  GetQuestionsRequest: GetQuestionsRequest;
};


export type QueryGetQuestionsByTeamArgs = {
  GetQuestionsByTeamRequest: GetQuestionsByTeamRequest;
};


export type QueryHighlightDocumentArgs = {
  DocumentsHighlightRequest: DocumentsHighlightRequest;
};


export type QueryHighlightFrameworkArgs = {
  FrameworkHighlightRequest: FrameworkHighlightRequest;
};


export type QueryHighlightNoticeArgs = {
  NoticeHighlightRequest: NoticeHighlightRequest;
};


export type QueryKeywordsArgs = {
  GenerateKeywordsRequest: GenerateKeywordsRequest;
};


export type QueryKeywordsRecommendationArgs = {
  GenerateKeywordsRecommendationRequest: GenerateKeywordsRecommendationRequest;
};


export type QueryNoticeArgs = {
  noticeId: Scalars['String']['input'];
};


export type QueryNoticeCountByCrossRefOrgArgs = {
  NoticeCountByCrossRefOrgRequest: NoticeCountByCrossRefOrgRequest;
};


export type QueryNoticeCountByOrgArgs = {
  request: NoticesCountRequestSchema;
};


export type QueryNoticesArgs = {
  NoticesSearchRequest: NoticesSearchRequest;
};


export type QueryOpportunitiesArgs = {
  PaginationOptions: PaginationOptions;
  SearchOpportunityRequest: SearchOpportunitiesRequest;
};


export type QueryOpportunityArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganisationsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPromptArgs = {
  id: Scalars['String']['input'];
};


export type QueryRecordListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRemainingCreditsArgs = {
  RemainingCreditRequest: RemainingCreditRequest;
};


export type QuerySearchOrganisationsArgs = {
  SearchOrganisationsRequest: SearchOrganisationsRequest;
};


export type QuerySuppliersArgs = {
  SuppliersRequest: SuppliersRequest;
};


export type QueryUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  SearchUserRequest: SearchUserRequest;
};

/** Question: stored answer to the question asked */
export type Question = {
  __typename?: 'Question';
  answer?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isComplete: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  reportId?: Maybe<Scalars['String']['output']>;
  responseReceivedAt?: Maybe<Scalars['String']['output']>;
};

/** Arguments for asking a question */
export type QuestionRequest = {
  /** The guid of the data type to ask the question to */
  dataId: Scalars['String']['input'];
  /** QuestionDataType: The type of data to ask the question to */
  dataType: QuestionRequest_DataTypeEnum_0;
  question: Scalars['String']['input'];
};

/** QuestionDataType: The type of data to ask the question to */
export enum QuestionRequest_DataTypeEnum_0 {
  Buyer = 'buyer'
}

/** RecordList: Users lists of records */
export type RecordList = {
  __typename?: 'RecordList';
  /** Company: Users companies */
  company: Company;
  companyId: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  guid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** BasicUser: Basic information for a stotles user */
  owner?: Maybe<BasicUser>;
  ownerId: Scalars['Float']['output'];
  /** Record: A procurement notice */
  records: Array<RecordList_Records>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Record: A procurement notice */
export type RecordList_Records = {
  __typename?: 'RecordList_Records';
  buyerId: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  /** RecordDetails: represents a JSON of details stored with a record. */
  details: RecordList_Records_Details;
  entityId: Scalars['Int']['output'];
  entityType: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  procurementStage?: Maybe<RecordList_Records_ProcurementStage>;
  procurementStageId: Scalars['String']['output'];
  projCloseDate: Scalars['String']['output'];
  projCountryCode: Scalars['String']['output'];
  projJournalDate: Scalars['String']['output'];
  publishDate: Scalars['String']['output'];
  recordFamilyId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/** RecordDetails: represents a JSON of details stored with a record. */
export type RecordList_Records_Details = {
  __typename?: 'RecordList_Records_Details';
  award_date?: Maybe<Scalars['String']['output']>;
  buyer_contact_email?: Maybe<Scalars['String']['output']>;
  buyer_contact_name?: Maybe<Scalars['String']['output']>;
  buyer_contact_phone?: Maybe<Scalars['String']['output']>;
  buyer_id: Scalars['Float']['output'];
  close_date?: Maybe<Scalars['String']['output']>;
  contract_guid?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  country_code: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entity_type: Scalars['String']['output'];
  expiry_date?: Maybe<Scalars['String']['output']>;
  journal_date: Scalars['String']['output'];
  language: Scalars['String']['output'];
  language_code: Scalars['String']['output'];
  lots_division?: Maybe<Scalars['Boolean']['output']>;
  lots_number?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  proc_category_src?: Maybe<Scalars['String']['output']>;
  publish_date: Scalars['String']['output'];
  record_family_id?: Maybe<Scalars['String']['output']>;
  reference_code: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tender_date?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  value_src?: Maybe<Scalars['Float']['output']>;
};

export type RecordList_Records_ProcurementStage = {
  __typename?: 'RecordList_Records_ProcurementStage';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  internalId: Scalars['Float']['output'];
  recordFamilyId: Scalars['String']['output'];
  stage: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
};

/** ReferenceOrganisation: Reference organisation data */
export type ReferenceOrganisation = {
  __typename?: 'ReferenceOrganisation';
  /** Address of the reference organisation */
  address?: Maybe<ReferenceOrganisation_Address>;
  /** Basic contact information */
  basicContactInfo?: Maybe<ReferenceOrganisation_BasicContactInfo>;
  /** Name of the reference organisation */
  name: Scalars['String']['output'];
  /** Source of the reference (e.g., 'dun_and_bradstreet') */
  source: Scalars['String']['output'];
  /** Source-specific identifier */
  sourceIdentifier: Scalars['String']['output'];
};

export type ReferenceOrganisation_Address = {
  __typename?: 'ReferenceOrganisation_Address';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
};

export type ReferenceOrganisation_BasicContactInfo = {
  __typename?: 'ReferenceOrganisation_BasicContactInfo';
  phone?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Tells a user how many credits they have for a particular credit type */
export type RemainingCreditRequest = {
  /** CreditType: The type of entity which this credit is based upon */
  creditType: Scalars['String']['input'];
};

/** Remaining credits model */
export type RemainingCredits = {
  __typename?: 'RemainingCredits';
  creditHolderId: Scalars['String']['output'];
  remainingCredits: Scalars['Float']['output'];
};

/** a customer report */
export type Report = {
  __typename?: 'Report';
  adminNotes: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  creatorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPublic: Scalars['Boolean']['output'];
  /** internal label for the report */
  label: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  /** ReportType: the type of report it is */
  reportType: Report_ReportTypeEnum_1;
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** ReportType: the type of report it is */
export enum Report_ReportTypeEnum_1 {
  AccountBriefing = 'account_briefing',
  AiReport = 'ai_report',
  AnalystHoursReport = 'analyst_hours_report',
  CompetitorBriefing = 'competitor_briefing',
  CompetitorLandscapeAnalysis = 'competitor_landscape_analysis',
  ManagementBriefing = 'management_briefing',
  MarketingReport = 'marketing_report',
  OpportunityBriefing = 'opportunity_briefing',
  PartnerBriefing = 'partner_briefing',
  PersonaBriefing = 'persona_briefing',
  WeeklyProspectingBriefing = 'weekly_prospecting_briefing'
}

/** Scorecard: A bid qualification report containing all of the questions and answers for a set of bid documents */
export type Scorecard = {
  __typename?: 'Scorecard';
  creditInfo?: Maybe<Scorecard_CreditInfo>;
  /** ScorecardResponse: Response containing a scorecard */
  result: Array<Scorecard_Result>;
};

export type Scorecard_CreditInfo = {
  __typename?: 'Scorecard_CreditInfo';
  /** Boolean which describes whether or not the user consumed all of their credits */
  consumedAllCredits: Scalars['Boolean']['output'];
  /** Total amount of credits given to the user over time */
  totalCredits: Scalars['Float']['output'];
};

/** ScorecardResponse: Response containing a scorecard */
export type Scorecard_Result = {
  __typename?: 'Scorecard_Result';
  groupName: Scalars['String']['output'];
  questions: Array<Scorecard_Result_Questions>;
};

export type Scorecard_Result_Questions = {
  __typename?: 'Scorecard_Result_Questions';
  /** Raw JSON output from the qualify service */
  answer?: Maybe<BidQualification_Result_Json>;
  answerId: Scalars['String']['output'];
  /** Whether the answer was AI generated */
  autoQualify: Scalars['Boolean']['output'];
  order: Scalars['Float']['output'];
  /** DocumentSources: The sources used to describe where the answer from the LLM was derived from */
  sources?: Maybe<Array<BidChatResponse_Sources>>;
  title: Scalars['String']['output'];
};

/** Arguments for searching contacts */
export type SearchContactsRequest = {
  buyerCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  buyerLists?: InputMaybe<Array<Scalars['String']['input']>>;
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  function?: InputMaybe<Array<Scalars['String']['input']>>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Limit the number of results returned */
  limit: Scalars['Float']['input'];
  mustContainEmail?: InputMaybe<Scalars['Boolean']['input']>;
  mustContainPhone?: InputMaybe<Scalars['Boolean']['input']>;
  /** The current page number */
  page: Scalars['Float']['input'];
  seniority?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Contains the parameters sent from the frontend to query the framework data */
export type SearchFrameworksRequest = {
  /** FrameworkAwardType: Method of awarding call-offs. */
  awardTypes?: InputMaybe<Array<SearchFrameworksRequest_AwardTypesEnum_1>>;
  /** Guids of the categories of the buyers participating in this framework */
  buyerCategoryGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Country codes of the buyers participating in this framework */
  buyerCountryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Guids of the organisations who are procuring through this framework or managing it (depending on buyer participant type) */
  buyerGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Guids of the buyer lists */
  buyerListGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** BuyerParticipantType: Describes what type of pariticpating buyer that the user wants to filter by when searching for frameworks */
  buyerParticipantType?: InputMaybe<SearchFrameworksRequest_BuyerParticipantTypeEnum_1>;
  /** Guids of the regions of the buyers participating in this framework */
  buyerRegionGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date filter for the close date of the tendering stage framework */
  closeDate?: InputMaybe<SearchFrameworksRequest_StartDate>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filtering by CPV code can be the whole CPV code or the CPV dimensions which represent the prefix of a certain category of cpv code */
  cpvCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date filter for the end date of the framework */
  endDate?: InputMaybe<SearchFrameworksRequest_StartDate>;
  /** If a framework includes one of these excludeKeywords - it is excluded from the search results. */
  excludeKeywords?: InputMaybe<Array<Scalars['String']['input']>>;
  frameworkIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Keywords to search for within the framework */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Date filter for the last date at which the top level framework info was updated by a new framework event */
  lastUpdatedDate?: InputMaybe<SearchFrameworksRequest_StartDate>;
  /** Limit the number of results returned */
  limit: Scalars['Float']['input'];
  /** Minimum relevance score for the results. In the range of 0 - 3 */
  minScore?: InputMaybe<Scalars['Float']['input']>;
  /** The current page number */
  page: Scalars['Float']['input'];
  /** FrameworkProcedureType: Type of the framework. */
  procedureTypes?: InputMaybe<Array<SearchFrameworksRequest_ProcedureTypesEnum_1>>;
  /** Text search input by the user */
  searchText?: InputMaybe<Scalars['String']['input']>;
  /** SignalFilter: Signal filter consisting of ids and categories */
  signals?: InputMaybe<NoticesSearchRequest_Signals>;
  /** Sort field for the results */
  sort: Scalars['String']['input'];
  /** Sort order for the results */
  sortOrder: SearchFrameworksRequest_SortOrderEnum_1;
  /** FrameworkStage: The stage in the lifecycle of a procurement process which the framework is presently at. */
  stages?: InputMaybe<Array<SearchFrameworksRequest_StagesEnum_1>>;
  /** Date filter for the start date of the framework */
  startDate?: InputMaybe<SearchFrameworksRequest_StartDate>;
  /** Guids of the organisations the framework is awarded to */
  supplierGuids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Allows filtering by min and max values, as well as hiding null values */
  value?: InputMaybe<SearchFrameworksRequest_Value>;
};

/** Enum values for SearchFrameworksRequest.awardTypes */
export enum SearchFrameworksRequest_AwardTypesEnum_1 {
  CompetitionAndDirect = 'COMPETITION_AND_DIRECT',
  CompetitionOnly = 'COMPETITION_ONLY',
  DirectAward = 'DIRECT_AWARD',
  Other = 'OTHER'
}

/** Enum values for SearchFrameworksRequest.buyerParticipantType */
export enum SearchFrameworksRequest_BuyerParticipantTypeEnum_1 {
  AllBuyers = 'ALL_BUYERS',
  ContractingAuthorityOnly = 'CONTRACTING_AUTHORITY_ONLY',
  ProvidersOnly = 'PROVIDERS_ONLY',
  TransactingBuyersOnly = 'TRANSACTING_BUYERS_ONLY'
}

/** Enum values for SearchFrameworksRequest.procedureTypes */
export enum SearchFrameworksRequest_ProcedureTypesEnum_1 {
  DynamicPurchasingSystem = 'DYNAMIC_PURCHASING_SYSTEM',
  Framework = 'FRAMEWORK'
}

/** Sort order for the results */
export enum SearchFrameworksRequest_SortOrderEnum_1 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Enum values for SearchFrameworksRequest.stages */
export enum SearchFrameworksRequest_StagesEnum_1 {
  Awarded = 'AWARDED',
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Expired = 'EXPIRED',
  Live = 'LIVE',
  Stale = 'STALE',
  Tendering = 'TENDERING',
  Upcoming = 'UPCOMING'
}

/** Contains the parameters sent from the frontend to query the framework data */
export type SearchFrameworksRequest_StartDate = {
  /** DateRangeFilter: Allows filtering by min and max dates, can either be discrete dates or relative date filtering   Must be arranged in a singular object so it can be used in the DateRange component in the frontend */
  filter?: InputMaybe<SearchFrameworksRequest_StartDate_Filter>;
  /** Whether or not nulls are hidden in the final results */
  hideNulls?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains the parameters sent from the frontend to query the framework data */
export type SearchFrameworksRequest_StartDate_Filter = {
  /** Min date the user is filtering from. If not provided, no lower bound is applied */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Relative dates are when we compare the date relative to today (e.g. 1 month ago) */
  relativeFrom?: InputMaybe<Scalars['String']['input']>;
  /** Relative dates are when we compare the date relative to today (e.g. 1 month ago) */
  relativeTo?: InputMaybe<Scalars['String']['input']>;
  /** Max date the user is filtering from. If not provided, no upper bound is applied */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Contains the parameters sent from the frontend to query the framework data */
export type SearchFrameworksRequest_Value = {
  /** Min value the user is filtering from. If not provided, no lower bound is applied */
  from?: InputMaybe<Scalars['Float']['input']>;
  /** Whether or not nulls are hidden in the final results */
  hideNulls?: InputMaybe<Scalars['Boolean']['input']>;
  /** Max value the user is filtering from. If not provided, no upper bound is applied */
  to?: InputMaybe<Scalars['Float']['input']>;
};

/** filters and order options for searching opportunities */
export type SearchOpportunitiesRequest = {
  assignee?: InputMaybe<SearchOpportunitiesRequest_Assignee>;
  buyerFilters?: InputMaybe<NoticesSearchRequest_BuyerFilters>;
  /** Allows filtering by min and max dates, can either be discrete dates or relative date filtering */
  closeDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** Allows filtering by min and max dates, can either be discrete dates or relative date filtering */
  lastUpdatedDate?: InputMaybe<NoticesSearchRequest_CloseDate>;
  opportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Sort order for the results */
  order?: InputMaybe<SearchOpportunitiesRequest_OrderEnum_1>;
  orderBuyerMatchingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** OpportunityOrderBy: fields we can order opportunity by */
  orderBy?: InputMaybe<SearchOpportunitiesRequest_OrderByEnum_1>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  stageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierFilters?: InputMaybe<SearchOpportunitiesRequest_SupplierFilters>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Allows filtering by min and max values, as well as hiding null values */
  value?: InputMaybe<NoticesSearchRequest_Value>;
};

/** filters and order options for searching opportunities */
export type SearchOpportunitiesRequest_Assignee = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  includeNulls?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Enum values for SearchOpportunitiesRequest.orderBy */
export enum SearchOpportunitiesRequest_OrderByEnum_1 {
  AssignedTo = 'assignedTo',
  BuyerMatching = 'buyerMatching',
  BuyerName = 'buyerName',
  CloseDate = 'closeDate',
  CreatedAt = 'createdAt',
  EntityId = 'entityId',
  Name = 'name',
  StageName = 'stageName',
  UpdatedAt = 'updatedAt',
  Value = 'value'
}

/** Enum values for SearchOpportunitiesRequest.order */
export enum SearchOpportunitiesRequest_OrderEnum_1 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** filters and order options for searching opportunities */
export type SearchOpportunitiesRequest_SupplierFilters = {
  /** Guids of the suppliers related to the opportunity */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter for SME suppliers. If true, show only SMEs, if false show only non-SMEs, if not set then show all */
  isSME?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Request body to query organisations with */
export type SearchOrganisationsRequest = {
  /** The country codes to search within */
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The ids of the organisations to search for */
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit the number of results returned */
  limit: Scalars['Float']['input'];
  /** The current page number */
  page: Scalars['Float']['input'];
  /** OrganisationPrimaryRole: "Buyer" | "Supplier" */
  primaryRole?: InputMaybe<SearchOrganisationsRequest_PrimaryRoleEnum_1>;
  /** Sort by field */
  sortBy?: InputMaybe<SearchOrganisationsRequest_SortByEnum_1>;
  /** Sort order for the results */
  sortOrder: SearchOrganisationsRequest_SortOrderEnum_1;
  /** Text search query */
  textSearch?: InputMaybe<Scalars['String']['input']>;
};

/** OrganisationPrimaryRole: "Buyer" | "Supplier" */
export enum SearchOrganisationsRequest_PrimaryRoleEnum_1 {
  Buyer = 'Buyer',
  Supplier = 'Supplier'
}

/** Enum values for SearchOrganisationsRequest.sortBy */
export enum SearchOrganisationsRequest_SortByEnum_1 {
  Name = 'name',
  Relevance = 'relevance'
}

/** Sort order for the results */
export enum SearchOrganisationsRequest_SortOrderEnum_1 {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** SearchOrganisationsRequest: Request body to query organisations with */
export type SearchOrganisationsResponse = {
  __typename?: 'SearchOrganisationsResponse';
  /** Organisations: Organisations returned by the search */
  orgs: Array<Organisation>;
  /** The number of results returned */
  total: Scalars['Float']['output'];
};

/** Arguments for searching users */
export type SearchUserRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  guid?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['Int']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** a list of contact ids */
export type SelectedContacts = {
  contactIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** a list of framework ids */
export type SelectedFrameworks = {
  frameworkIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** a list of notice ids */
export type SelectedNotices = {
  noticeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** a list of opportunity ids */
export type SelectedOpportunities = {
  opportunityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** a listing for an exemption to SEO indexing rules */
export type SeoExemption = {
  __typename?: 'SeoExemption';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  exemptFromIndexingRules: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SignalDefinition = {
  __typename?: 'SignalDefinition';
  category: Scalars['String']['output'];
  colour: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Object which contains information about a user's signal settings.       Contains a user's selected keywords, competitors & partners */
export type SignalSettings = {
  __typename?: 'SignalSettings';
  /** Array containing the organisation IDs of the user's selected competitors */
  competitorGuids: Array<Scalars['String']['output']>;
  /** Competitors: The organisations that the user has selected as their competitors */
  competitors: Array<Organisation>;
  /** Countries: Limits the records which are returned by staying within these countries */
  countries?: Maybe<Array<Scalars['String']['output']>>;
  /** CPV Codes: The cpv codes which describe the type of work being procured */
  cpvCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Keywords: Words or terms of interest that will be used to find relevant content */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /** Languages: Limits the records which are returned by staying within these languages */
  languages?: Maybe<Array<Scalars['String']['output']>>;
  /** Array containing the organisation IDs of the user's selected partners */
  partnerGuids: Array<Scalars['String']['output']>;
  /** Partners: The organisations that the user has selected as their partners */
  partners: Array<Organisation>;
  /** Whether or not the user is using free text supplier names as competitor & partners,       or if they're using supplier objects */
  useSupplierName: Scalars['Boolean']['output'];
  /** Instead of looking back 6 months, the lookback is unlimited */
  useUnlimitedLookback?: Maybe<Scalars['Boolean']['output']>;
};

/** Object which contains information about a user's signal settings but it doesn't contain the competitors and partners org objects */
export type SimpleSignalSettings = {
  __typename?: 'SimpleSignalSettings';
  /** Array containing the organisation IDs of the user's selected competitors */
  competitorGuids: Array<Scalars['String']['output']>;
  /** Countries: Limits the records which are returned by staying within these countries */
  countries?: Maybe<Array<Scalars['String']['output']>>;
  /** CPV Codes: The cpv codes which describe the type of work being procured */
  cpvCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** Keywords: Words or terms of interest that will be used to find relevant content */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /** Languages: Limits the records which are returned by staying within these languages */
  languages?: Maybe<Array<Scalars['String']['output']>>;
  /** Array containing the organisation IDs of the user's selected partners */
  partnerGuids: Array<Scalars['String']['output']>;
  /** Whether or not the user is using free text supplier names as competitor & partners,       or if they're using supplier objects */
  useSupplierName: Scalars['Boolean']['output'];
  /** Instead of looking back 6 months, the lookback is unlimited */
  useUnlimitedLookback?: Maybe<Scalars['Boolean']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  bidChatAnswered: BidChatResponse;
  buyerActivityStatus: BuyerActivitySummaryStatus;
  creditsStatus: CreditsStatus;
  fileExport: FileExportStatus;
  questionAnswered: Question;
};


export type SubscriptionBidChatAnsweredArgs = {
  conversationId: Scalars['String']['input'];
};


export type SubscriptionBuyerActivityStatusArgs = {
  opportunityId: Scalars['String']['input'];
};


export type SubscriptionCreditsStatusArgs = {
  teamId: Scalars['String']['input'];
};


export type SubscriptionFileExportArgs = {
  id: Scalars['String']['input'];
};


export type SubscriptionQuestionAnsweredArgs = {
  id: Scalars['String']['input'];
};

/** request to retrieve supplier relationship summaries */
export type SupplierBuyerNoticeSummaryRequest = {
  suppliers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Supplier: Detailed supplier information */
export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  /** Full address string */
  address?: Maybe<Scalars['String']['output']>;
  /** Full country name */
  country?: Maybe<Scalars['String']['output']>;
  /** Country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** UUID of the supplier */
  guid: Scalars['String']['output'];
  /** Numeric ID of the supplier */
  id: Scalars['Float']['output'];
  /** Whether the supplier is archived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the supplier is an SME */
  isSme?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the supplier is Stotles verified */
  isStotlesVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the supplier */
  name: Scalars['String']['output'];
  /** Phone number */
  phone?: Maybe<Scalars['String']['output']>;
  /** Postal/ZIP code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Related reference organisations */
  referenceOrganisations?: Maybe<Array<ReferenceOrganisation>>;
  /** Town/city */
  town?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp */
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** SupplierDetailsResponse: Response object for fetching supplier details */
export type SupplierDetailsResponse = {
  __typename?: 'SupplierDetailsResponse';
  /** Supplier: Detailed supplier information */
  results: Array<SupplierDetails>;
  totalResults: Scalars['Float']['output'];
};

/** Request object for fetching suppliers by GUID */
export type SuppliersRequest = {
  /** Array of supplier GUIDs to fetch */
  guids?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** a team of users within a company */
export type Team = {
  __typename?: 'Team';
  /** Company: Users companies */
  company?: Maybe<Company>;
  companyGuid: Scalars['String']['output'];
  feedSettingsId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrivate: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** User: Stotles user */
  users: Array<User>;
  /** The number of users in the team */
  usersCount: Scalars['Float']['output'];
};

/** update bid answer request */
export type UpdateBidAnswerRequest = {
  answer: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** request to update the publicity of a bid. Attaches a hash string to the bid */
export type UpdateBidPublicityRequest = {
  bidId: Scalars['String']['input'];
  publicHash: Scalars['String']['input'];
};

/** Request object for updating a comment */
export type UpdateCommentRequest = {
  content: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

/** Request to update a question */
export type UpdateQuestionRequest = {
  autoQualify?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  groupName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  promptId?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  teamId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Signal settings object that when sent, overwrites the existing signal settings     for the user's team */
export type UpdateSignalSettings = {
  /** Array containing the organisation IDs of the user's selected competitors */
  competitorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries: Limits the records which are returned by staying within these countries */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** CPV Codes: The cpv codes which describe the type of work being procured */
  cpvCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Keywords: Words or terms of interest that will be used to find relevant content */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Languages: Limits the records which are returned by staying within these languages */
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Array containing the organisation IDs of the user's selected partners */
  partnerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether or not the user is using free text supplier names as competitor & partners,       or if they're using supplier objects */
  useSupplierName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** input for updating a team */
export type UpdateTeamInput = {
  id: Scalars['String']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Update a user */
export type UpdateUserRequest = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  guid: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  mainGoal?: InputMaybe<UpdateUserRequest_MainGoalEnum_1>;
};

/** Enum values for UpdateUserRequest.mainGoal */
export enum UpdateUserRequest_MainGoalEnum_1 {
  Bids = 'bids',
  Pipeline = 'pipeline',
  Strategy = 'strategy',
  Tenders = 'tenders'
}

/** Arguments for updating a workflow */
export type UpdateWorkflowInput = {
  id: Scalars['String']['input'];
  /** StageReplacements: A map of stage replacements used when updating a workflow */
  stageReplacements: Array<CreateNewWorkflow_StageReplacements>;
  /** OpportunityWorkflowTransitionUpdate: A transition update in the workflow, any transitions that are exactly the same will not be updated */
  transitions: Array<UpdateWorkflowInput_Transitions>;
};

/** Arguments for updating a workflow */
export type UpdateWorkflowInput_Transitions = {
  /** WorkflowTransitionGroup: The group which the transition belongs to */
  group: UpdateWorkflowInput_Transitions_GroupEnum_2;
  /** If updating an exiting transtion provide the id */
  id?: InputMaybe<Scalars['String']['input']>;
  order: Scalars['Float']['input'];
  /** The color of the stage, used when the stage hasnt been created yet */
  stageColor?: InputMaybe<Scalars['String']['input']>;
  /** The icon color of the stage, used when the stage hasnt been created yet */
  stageIconColor?: InputMaybe<Scalars['String']['input']>;
  /** The icon name of the stage, used when the stage hasnt been created yet */
  stageIconName?: InputMaybe<Scalars['String']['input']>;
  stageId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the stage, used when the stage hasnt been created yet */
  stageName?: InputMaybe<Scalars['String']['input']>;
};

/** WorkflowTransitionGroup: The group which the transition belongs to */
export enum UpdateWorkflowInput_Transitions_GroupEnum_2 {
  Bidding = 'Bidding',
  Closed = 'Closed',
  PreEngagement = 'Pre_Engagement',
  TenderQualification = 'Tender_Qualification',
  Won = 'Won'
}

/** Response for requesting a signed url to upload a document */
export type UploadNoticeDocument = {
  __typename?: 'UploadNoticeDocument';
  documentId: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

/** Request to upload a document for a notice */
export type UploadNoticeDocumentRequest = {
  bidId: Scalars['String']['input'];
  documentName: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
};

/** Creates, updates, and or deletes questions for a team */
export type UpsertBidReportQuestionsRequest = {
  /** UpsertBidQuestion: Question to upsert */
  questions: Array<UpsertBidReportQuestionsRequest_Questions>;
};

/** Creates, updates, and or deletes questions for a team */
export type UpsertBidReportQuestionsRequest_Questions = {
  autoQualify: Scalars['Boolean']['input'];
  /** Guid of the company who this question belongs to. If null, it is a default question */
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  groupName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  promptId: Scalars['String']['input'];
  question: Scalars['String']['input'];
  /** ID of the team who this question belongs to. If null, it is a default question */
  teamId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

/** Stotles user */
export type User = {
  __typename?: 'User';
  /** Specifically the data types that are active for the user now and are not disabled */
  activeDataTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Guid of the company this user belongs to. Calling it commanyID to differentiate it from companyId (which is the numeric ID) on the dbUser object */
  companyID?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  feedSettingsId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  hasExportAccess?: Maybe<Scalars['Boolean']['output']>;
  isConfigured: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  mainGoal?: Maybe<User_MainGoalEnum_0>;
  subscription: Scalars['String']['output'];
  teamId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Enum values for User.mainGoal */
export enum User_MainGoalEnum_0 {
  Bids = 'bids',
  Pipeline = 'pipeline',
  Strategy = 'strategy',
  Tenders = 'tenders'
}

/** NoticeCountByCrossRefOrg: The notice count between this org and the anchor organisation in the request */
export type NoticeCountByCrossRefOrg = {
  __typename?: 'noticeCountByCrossRefOrg';
  noticeCount: Scalars['Float']['output'];
  orgId: Scalars['String']['output'];
};

export type CreateCreditTransactionMutationVariables = Exact<{
  request: CreateCreditTransactionRequest;
}>;


export type CreateCreditTransactionMutation = { __typename?: 'Mutation', createCreditTransaction: { __typename?: 'CreditTransaction', id: string } };

export type CreditsQueryVariables = Exact<{
  request: CreditsSearchRequest;
}>;


export type CreditsQuery = { __typename?: 'Query', credits: { __typename?: 'CreditsResponse', totalResults: number, results: Array<{ __typename?: 'Credit', id: string, holderType: string, creditType: string, totalCredits: number, remainingCredits: number, creditHolder?: { __typename?: 'Credit_CreditHolder', team?: { __typename?: 'Team', name: string, company?: { __typename?: 'Company', name: string } | null } | null } | null }> } };

export type RemainingCreditsQueryVariables = Exact<{
  request: RemainingCreditRequest;
}>;


export type RemainingCreditsQuery = { __typename?: 'Query', remainingCredits: { __typename?: 'RemainingCredits', remainingCredits: number } };

export type EvaluateNoticesMutationVariables = Exact<{
  input: EvaluateNoticesRequest;
}>;


export type EvaluateNoticesMutation = { __typename?: 'Mutation', evaluateNotices: { __typename?: 'BidEvaluationResponse', success: boolean, experimentWebUrl?: string | null } };

export type BuyerSummaryEvaluationMutationVariables = Exact<{
  input: OpportunityEvaluationRequest;
}>;


export type BuyerSummaryEvaluationMutation = { __typename?: 'Mutation', buyerSummaryEvaluation: { __typename?: 'OppBuyerActivityEvaluationResponse', success: boolean, experimentWebUrl?: string | null } };

export type LangsmithPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type LangsmithPromptsQuery = { __typename?: 'Query', langsmithPrompts: Array<{ __typename?: 'LangsmithPrompt', promptId: string, description?: string | null, questions: Array<string> }> };

export type PromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type PromptsQuery = { __typename?: 'Query', prompts: Array<{ __typename?: 'Prompt', createdAt?: string | null, updatedAt?: string | null, id: string, isActive: boolean, model: Prompt_ModelEnum_0, numberOfResults: number, numberOfSemanticSearchResults?: number | null, promptType: Prompt_PromptTypeEnum_0, promptTemplate: Array<{ __typename?: 'Prompt_PromptTemplate', role: Prompt_PromptTemplate_RoleEnum_0, template: string }> }> };

export type CreateExemptionMutationVariables = Exact<{
  input: CreateSeoExemptionsRequest;
}>;


export type CreateExemptionMutation = { __typename?: 'Mutation', createExemptions: { __typename?: 'CreateExemptionResponse', createExemptions: Array<{ __typename?: 'SeoExemption', id: string, recordId: string, exemptFromIndexingRules: boolean, createdAt?: string | null }> } };

export type DeleteExemptionMutationVariables = Exact<{
  input: DeleteSeoExemptionRequest;
}>;


export type DeleteExemptionMutation = { __typename?: 'Mutation', deleteExemption: { __typename?: 'DeletedSeoExemption', id: string, recordId: string } };

export type SeoExemptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SeoExemptionsQuery = { __typename?: 'Query', seoExemptions: Array<{ __typename?: 'SeoExemption', id: string, recordId: string, exemptFromIndexingRules: boolean }> };

export type CreatePromptMutationVariables = Exact<{
  input: CreatePromptInput;
  template: Array<PromptTemplateInput> | PromptTemplateInput;
}>;


export type CreatePromptMutation = { __typename?: 'Mutation', createPrompt: { __typename?: 'Prompt', createdAt?: string | null, updatedAt?: string | null, id: string, isActive: boolean, model: Prompt_ModelEnum_0, numberOfResults: number, numberOfSemanticSearchResults?: number | null, promptType: Prompt_PromptTypeEnum_0, promptTemplate: Array<{ __typename?: 'Prompt_PromptTemplate', role: Prompt_PromptTemplate_RoleEnum_0, template: string }> } };

export type DocumentAdminQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DocumentAdminQuery = { __typename?: 'Query', document: { __typename?: 'Document', id: string, title?: string | null, description?: string | null, category?: string | null, publishedAt?: string | null, alternativeSource?: string | null, sourceUrlLinks?: Array<{ __typename?: 'Document_SourceUrlLinks', id: string, sourceUrl?: string | null }> | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null } };

export type DocumentsAdminQueryVariables = Exact<{
  request: DocumentsSearchRequest;
}>;


export type DocumentsAdminQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsSearchResponse', totalResults: number, results: Array<{ __typename?: 'Document', id: string, signalScore?: number | null, title?: string | null, category?: string | null, publishedAt?: string | null, createdAt?: string | null, pdfDocumentUrl?: string | null, createdBy?: { __typename?: 'BasicUser', email: string } | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null }> } };

export type UpdateBidAnswerByIdMutationVariables = Exact<{
  input: UpdateBidAnswerRequest;
}>;


export type UpdateBidAnswerByIdMutation = { __typename?: 'Mutation', updateBidAnswerById: { __typename?: 'BidAnswer', bidId: string, answer: { __typename?: 'BidAnswer_Answer', answer?: string | null } } };

export type BidChatMutationVariables = Exact<{
  req: BidChatRequest;
}>;


export type BidChatMutation = { __typename?: 'Mutation', bidChat: { __typename?: 'BidChatResponse', conversationId: string, question: string } };

export type BidChatAnsweredSubscriptionVariables = Exact<{
  conversationId: Scalars['String']['input'];
}>;


export type BidChatAnsweredSubscription = { __typename?: 'Subscription', bidChatAnswered: { __typename?: 'BidChatResponse', conversationId: string, bidId: string, question: string, answer?: string | null, isComplete: boolean, sources?: Array<{ __typename?: 'BidChatResponse_Sources', document?: string | null, documentId?: string | null, chunkNumber?: number | null, locations: Array<{ __typename?: 'BidChatResponse_Sources_Locations', pageNumber: number, bbox?: { __typename?: 'BidChatResponse_Sources_Locations_Bbox', x: number, y: number, width: number, height: number } | null }> }> | null } };

export type BidDocumentsQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BidDocumentsQuery = { __typename?: 'Query', bidDocuments: { __typename?: 'BidDocumentsResponse', items: Array<{ __typename?: 'BidDocument', id: string, fileName: string }> } };

export type CreateBidDocumentMutationVariables = Exact<{
  request: CreateBidDocumentRequest;
}>;


export type CreateBidDocumentMutation = { __typename?: 'Mutation', createBidDocument: { __typename?: 'BasicBidDocument', bidId: string, fileName: string } };

export type DeleteBidDocumentMutationVariables = Exact<{
  request: DeleteBidDocumentRequest;
}>;


export type DeleteBidDocumentMutation = { __typename?: 'Mutation', deleteBidDocument: { __typename?: 'BasicBidDocument', bidId: string, fileName: string } };

export type GetBidDocumentUrlMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBidDocumentUrlMutation = { __typename?: 'Mutation', getBidDocumentUrl: { __typename?: 'BidDocumentUrlResponse', documentUrl: string } };

export type UploadNoticeDocumentUrlMutationVariables = Exact<{
  input: UploadNoticeDocumentRequest;
}>;


export type UploadNoticeDocumentUrlMutation = { __typename?: 'Mutation', uploadNoticeDocument: { __typename?: 'UploadNoticeDocument', signedUrl: string, documentId: string } };

export type AskBidQuestionMutationVariables = Exact<{
  req: QualifyQuestionRequest;
}>;


export type AskBidQuestionMutation = { __typename?: 'Mutation', askBidQuestion: { __typename?: 'AskBidQuestionAnswer', answer?: string | null, sources?: Array<{ __typename?: 'BidChatResponse_Sources', document?: string | null, documentId?: string | null, chunkNumber?: number | null, locations: Array<{ __typename?: 'BidChatResponse_Sources_Locations', pageNumber: number, bbox?: { __typename?: 'BidChatResponse_Sources_Locations_Bbox', x: number, y: number, width: number, height: number } | null }> }> | null } };

export type BidQuestionGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type BidQuestionGroupsQuery = { __typename?: 'Query', bidQuestionGroups: { __typename?: 'BidQuestionGroupsResponse', groups: Array<{ __typename?: 'BidQuestionGroupsResponse_Groups', name: string, questions: Array<{ __typename?: 'BidQuestion', id: string, title: string, question: string, groupName: string, promptId: string, order: number, teamId?: string | null, companyId?: string | null, autoQualify: boolean }> }> } };

export type CreateQuestionMutationVariables = Exact<{
  input: CreateQuestionRequest;
}>;


export type CreateQuestionMutation = { __typename?: 'Mutation', createQuestion: { __typename?: 'BidQuestionResponse', success: boolean, question?: { __typename?: 'BidQuestion', id: string, title: string, question: string, promptId: string, order: number, groupName: string, companyId?: string | null, teamId?: string | null, createdAt?: string | null, updatedAt?: string | null, autoQualify: boolean } | null } };

export type DeleteQuestionMutationVariables = Exact<{
  request: DeleteQuestionRequest;
}>;


export type DeleteQuestionMutation = { __typename?: 'Mutation', deleteQuestion: { __typename?: 'BidQuestionResponse', success: boolean } };

export type UpdateQuestionMutationVariables = Exact<{
  input: UpdateQuestionRequest;
}>;


export type UpdateQuestionMutation = { __typename?: 'Mutation', updateQuestion: { __typename?: 'BidQuestionResponse', success: boolean } };

export type GetDefaultQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultQuestionsQuery = { __typename?: 'Query', getDefaultQuestions: { __typename?: 'AdminBidQuestionsResponse', questions: Array<{ __typename?: 'BidQuestion', id: string, title: string, question: string, groupName: string, promptId: string, order: number, teamId?: string | null, autoQualify: boolean }> } };

export type GetQuestionsByTeamQueryVariables = Exact<{
  request: GetQuestionsByTeamRequest;
}>;


export type GetQuestionsByTeamQuery = { __typename?: 'Query', getQuestionsByTeam: { __typename?: 'AdminBidQuestionsResponse', questions: Array<{ __typename?: 'BidQuestion', id: string, title: string, question: string, groupName: string, promptId: string, order: number, teamId?: string | null, autoQualify: boolean }> } };

export type QualifyQuestionMutationVariables = Exact<{
  input: QualifyQuestionRequest;
}>;


export type QualifyQuestionMutation = { __typename?: 'Mutation', qualifyQuestion: { __typename?: 'Scorecard_Result_Questions', answerId: string, title: string, autoQualify: boolean, answer?: { __typename?: 'BidQualification_Result_Json', answer?: string | null } | null, sources?: Array<{ __typename?: 'BidChatResponse_Sources', documentId?: string | null, chunkNumber?: number | null, locations: Array<{ __typename?: 'BidChatResponse_Sources_Locations', pageNumber: number, bbox?: { __typename?: 'BidChatResponse_Sources_Locations_Bbox', x: number, y: number, width: number, height: number } | null }> }> | null } };

export type UpsertBidReportQuestionsMutationVariables = Exact<{
  req: UpsertBidReportQuestionsRequest;
}>;


export type UpsertBidReportQuestionsMutation = { __typename?: 'Mutation', upsertBidReportQuestions: { __typename?: 'BidQuestionGroupsResponse', groups: Array<{ __typename?: 'BidQuestionGroupsResponse_Groups', name: string, questions: Array<{ __typename?: 'BidQuestion', id: string, title: string, question: string, groupName: string, promptId: string, order: number, teamId?: string | null, companyId?: string | null, autoQualify: boolean }> }> } };

export type BidQueryVariables = Exact<{
  request: BidRequest;
}>;


export type BidQuery = { __typename?: 'Query', bid: { __typename?: 'Bid', id: string, createdAt?: string | null, updatedAt?: string | null, procurementStageId?: string | null, opportunityId: string, companyId: string, teamId: string, publicHash?: string | null, notice?: { __typename?: 'Notice', guid: string, name?: string | null, buyers: Array<{ __typename?: 'Buyer', guid: string, name: string }> } | null, opportunity: { __typename?: 'Opportunity', name: string, stage: { __typename?: 'OpportunityWorkflowStage', id: string } } } };

export type BidsQueryVariables = Exact<{
  request: BidsSearchRequest;
}>;


export type BidsQuery = { __typename?: 'Query', bids: { __typename?: 'BidsSearchResponse', totalResults: number, results: Array<{ __typename?: 'Bid', id: string, createdAt?: string | null, updatedAt?: string | null, procurementStageId?: string | null, opportunity: { __typename?: 'Opportunity', id: string, name: string } }> } };

export type CreateBidMutationVariables = Exact<{
  bid: CreateBidRequest;
}>;


export type CreateBidMutation = { __typename?: 'Mutation', createBid: { __typename?: 'Bid', id: string, createdAt?: string | null, updatedAt?: string | null, procurementStageId?: string | null, opportunity: { __typename?: 'Opportunity', id: string, name: string } } };

export type DeleteBidMutationVariables = Exact<{
  input: BidDeleteRequest;
}>;


export type DeleteBidMutation = { __typename?: 'Mutation', deleteBid: { __typename?: 'Bid', id: string, opportunityId: string, procurementStageId?: string | null } };

export type ExportBidReportAsPdfMutationVariables = Exact<{
  input: ExportBidReportRequest;
}>;


export type ExportBidReportAsPdfMutation = { __typename?: 'Mutation', exportBidReportAsPDF: { __typename?: 'ExportBidReportResponse', id: string, url: string } };

export type UpdateBidPublicityMutationVariables = Exact<{
  input: UpdateBidPublicityRequest;
}>;


export type UpdateBidPublicityMutation = { __typename?: 'Mutation', updateBidPublicity: { __typename?: 'Bid', id: string, opportunityId: string, publicHash?: string | null } };

export type GetBidReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBidReportQuery = { __typename?: 'Query', getBidReport: { __typename?: 'Scorecard', result: Array<{ __typename?: 'Scorecard_Result', groupName: string, questions: Array<{ __typename?: 'Scorecard_Result_Questions', answerId: string, autoQualify: boolean, title: string, order: number, answer?: { __typename?: 'BidQualification_Result_Json', answer?: string | null } | null, sources?: Array<{ __typename?: 'BidChatResponse_Sources', document?: string | null, documentId?: string | null, chunkNumber?: number | null, locations: Array<{ __typename?: 'BidChatResponse_Sources_Locations', pageNumber: number, bbox?: { __typename?: 'BidChatResponse_Sources_Locations_Bbox', x: number, y: number, width: number, height: number } | null }> }> | null }> }> } };

export type QualifyBidMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QualifyBidMutation = { __typename?: 'Mutation', qualifyBid: { __typename?: 'Scorecard', result: Array<{ __typename?: 'Scorecard_Result', groupName: string, questions: Array<{ __typename?: 'Scorecard_Result_Questions', answerId: string, autoQualify: boolean, title: string, order: number, answer?: { __typename?: 'BidQualification_Result_Json', answer?: string | null } | null, sources?: Array<{ __typename?: 'BidChatResponse_Sources', document?: string | null, documentId?: string | null, chunkNumber?: number | null, locations: Array<{ __typename?: 'BidChatResponse_Sources_Locations', pageNumber: number, bbox?: { __typename?: 'BidChatResponse_Sources_Locations_Bbox', x: number, y: number, width: number, height: number } | null }> }> | null }> }>, creditInfo?: { __typename?: 'Scorecard_CreditInfo', totalCredits: number, consumedAllCredits: boolean } | null } };

export type BuyerCpvStatsQueryVariables = Exact<{
  buyerId: Scalars['String']['input'];
  options: CpvStatsRequest;
}>;


export type BuyerCpvStatsQuery = { __typename?: 'Query', buyerCpvStats: { __typename?: 'CpvStatsResponse', overallStats: { __typename?: 'CpvStat', totalValue: number, totalAwarded: number, avgContractValue: number, percentToSmes: number }, perCpvStats: Array<{ __typename?: 'CpvStat', totalValue: number, totalAwarded: number, avgContractValue: number, percentToSmes: number, code?: string | null, name?: string | null }> } };

export type BuyerDetailsQueryVariables = Exact<{
  guids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type BuyerDetailsQuery = { __typename?: 'Query', buyers: { __typename?: 'BuyerResponse', totalResults: number, results: Array<{ __typename?: 'Buyer', id: number, name: string, guid: string, categorySource?: string | null, categoryUni?: string | null, referenceCode?: string | null, createdAt?: string | null, updatedAt?: string | null, buyerUrl?: string | null, country?: string | null, countryCode?: string | null, town?: string | null, postalCode?: string | null, address?: string | null, cleanName?: string | null, nutsLocation?: string | null, oscarId?: string | null, logoUrl?: string | null, isStotlesVerified?: boolean | null, isArchived?: boolean | null, isInactive?: boolean | null, twitterHandle?: string | null, oscarCategory?: Array<string> | null, employeeCount?: string | null, annualSpend?: string | null, locationSummary?: string | null, url?: string | null, categoryAssignments: Array<{ __typename?: 'Buyer_CategoryAssignments', categoryId: string, categoryName: string, parentCategoryId?: string | null, parentCategoryName?: string | null, source: string }> }> } };

export type BuyerStatsGqlQueryVariables = Exact<{
  inputAllNotices: NoticesSearchRequest;
  inputOpenOpps: NoticesSearchRequest;
  inputUpcomingExpiries: NoticesSearchRequest;
}>;


export type BuyerStatsGqlQuery = { __typename?: 'Query', allNotices: { __typename?: 'NoticesSearch', totalResults: number }, openOpps: { __typename?: 'NoticesSearch', totalResults: number }, upcomingExpiries: { __typename?: 'NoticesSearch', totalResults: number } };

export type CreateCommentMutationVariables = Exact<{
  request: CreateCommentRequest;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'BasicComment', id: string, content: string, companyId: string, objectId: string, createdAt?: string | null, updatedAt?: string | null } };

export type DeleteCommentMutationVariables = Exact<{
  request: DeleteCommentRequest;
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: { __typename?: 'BasicComment', id: string } };

export type UpdateCommentMutationVariables = Exact<{
  request: UpdateCommentRequest;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'BasicComment', id: string, content: string, companyId: string, objectId: string, createdAt?: string | null, updatedAt?: string | null } };

export type CompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', users: Array<{ __typename?: 'User', guid: string, firstName: string, lastName: string }> } };

export type ExportContactsMutationVariables = Exact<{
  filters: SearchContactsRequest;
  exportFormat: ExportFormatArgs;
  selectedContacts: SelectedContacts;
}>;


export type ExportContactsMutation = { __typename?: 'Mutation', exportContacts: { __typename?: 'FileExport', id: string } };

export type ContactsQueryVariables = Exact<{
  request: SearchContactsRequest;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactsSearchResponse', totalResults: number, results: Array<{ __typename?: 'Contact', id: string, jobTitle: string, title: string, firstName: string, lastName: string, seniority: string, jobFunction: Array<string>, orgId?: string | null, email?: string | null, phone?: string | null, orgUrn?: string | null, oscarOrgName?: string | null, buyer?: { __typename?: 'Organisation', id: string, name: string, isStotlesVerified?: boolean | null, logoUrl?: string | null, categoryAssignments?: Array<{ __typename?: 'Organisation_CategoryAssignments', categoryId: string, source: string }> | null } | null, opportunities: Array<{ __typename?: 'OpportunityBasic', id: string }> }> } };

export type BuyersQueryVariables = Exact<{
  request: BuyersRequest;
}>;


export type BuyersQuery = { __typename?: 'Query', buyers: { __typename?: 'BuyerResponse', results: Array<{ __typename?: 'Buyer', id: number, name: string, oscarId?: string | null }> } };

export type AllCpvCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCpvCodesQuery = { __typename?: 'Query', allCpvCodes: { __typename?: 'CpvCodesResponse', cpvCodes: Array<{ __typename?: 'CpvCodesResponse_CpvCodes', id: number, name: string, code: string, parentCode?: string | null, childIds?: Array<string> | null }> } };

export type CpvCodesQueryVariables = Exact<{
  request: CpvCodesRequest;
}>;


export type CpvCodesQuery = { __typename?: 'Query', cpvCodes: { __typename?: 'CpvCodesResponse', cpvCodes: Array<{ __typename?: 'CpvCodesResponse_CpvCodes', id: number, name: string, code: string, parentCode?: string | null }> } };

export type CpvCodesWithChildrenQueryVariables = Exact<{
  request: CpvCodesRequest;
}>;


export type CpvCodesWithChildrenQuery = { __typename?: 'Query', cpvCodes: { __typename?: 'CpvCodesResponse', cpvCodes: Array<{ __typename?: 'CpvCodesResponse_CpvCodes', id: number, name: string, code: string, parentCode?: string | null, childIds?: Array<string> | null }> } };

export type CreditsStatusSubscriptionVariables = Exact<{
  teamId: Scalars['String']['input'];
}>;


export type CreditsStatusSubscription = { __typename?: 'Subscription', creditsStatus: { __typename?: 'CreditsStatus', creditLimitReached: boolean, totalCredits: number } };

export type DocumentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DocumentQuery = { __typename?: 'Query', document: { __typename?: 'Document', id: string, title?: string | null, category?: string | null, publishedAt?: string | null, signalScore?: number | null, pdfDocumentUrl?: string | null, downloadUrl?: string | null, alternativeSource?: string | null, originalMimeType?: string | null, sourceUrlLinks?: Array<{ __typename?: 'Document_SourceUrlLinks', id: string, sourceUrl?: string | null }> | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null } };

export type HighlightDocumentQueryVariables = Exact<{
  request: DocumentsHighlightRequest;
}>;


export type HighlightDocumentQuery = { __typename?: 'Query', highlightDocument: { __typename?: 'DocumentHighlightResponse', titleHighlights?: Array<string> | null, contentHighlights?: Array<string> | null } };

export type DocumentsQueryVariables = Exact<{
  request: DocumentsSearchRequest;
}>;


export type DocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentsSearchResponse', totalResults: number, results: Array<{ __typename?: 'Document', id: string, signalScore?: number | null, title?: string | null, category?: string | null, publishedAt?: string | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null }> } };

export type FileExportSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FileExportSubscription = { __typename?: 'Subscription', fileExport: { __typename?: 'FileExportStatus', status: string, isComplete: boolean, isError: boolean, downloadUrl?: string | null } };

export type DescribeFrameworkQueryVariables = Exact<{
  frameworkId: Scalars['String']['input'];
  includeDebugInfo: Scalars['Boolean']['input'];
}>;


export type DescribeFrameworkQuery = { __typename?: 'Query', framework: { __typename?: 'Framework', id: string, signalScore?: number | null, title: string, sourceUrl?: string | null, countryCode: string, procedureType?: Framework_ProcedureTypeEnum_0 | null, awardType?: Framework_AwardTypeEnum_0 | null, validatedByProvider: boolean, stage: Framework_StageEnum_0, extensionAvailable?: boolean | null, textSections?: Array<{ __typename?: 'Framework_TextSections', title: string, role: string, content: { __typename?: 'Framework_TextSections_Content', content: string, content_type: string } }> | null, value?: { __typename?: 'Framework_Value', amount: number, currency: string } | null, contactDetails?: { __typename?: 'Framework_ContactDetails', address?: string | null, email?: string | null, name?: string | null, phone?: string | null } | null, contractPeriod?: { __typename?: 'Framework_PlanningPeriod', startDate?: string | null, endDate?: string | null } | null, tenderPeriod?: { __typename?: 'Framework_PlanningPeriod', startDate?: string | null, endDate?: string | null } | null, planningPeriod?: { __typename?: 'Framework_PlanningPeriod', startDate?: string | null, endDate?: string | null } | null, serviceProvider?: { __typename?: 'Organisation', id: string, name: string } | null, suppliers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null, contractingAuthority?: { __typename?: 'Organisation', id: string, name: string } | null, lots: Array<{ __typename?: 'Framework_Lots', id: string, title?: string | null, supplierGuids?: Array<string> | null, description?: { __typename?: 'Framework_TextSections_Content', content: string, content_type: string } | null, contractPeriod?: { __typename?: 'Framework_PlanningPeriod', startDate?: string | null, endDate?: string | null } | null, value?: { __typename?: 'Framework_Value', amount: number, currency: string } | null }>, signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string }> | null, timeline?: Array<{ __typename?: 'Framework_Timeline', stage: Framework_Timeline_StageEnum_0, externalSourceUrl?: string | null, startDate?: string | null, endDate?: string | null, notice?: { __typename?: 'Framework_Timeline_Notice', recordGuid?: string | null, title?: string | null, stotlesUrl?: string | null, publishDate?: string | null } | null }> | null, debugInfo?: { __typename?: 'Framework_DebugInfo', frameworkInfo?: string | null, frameworkEventInfo?: string | null } | null } };

export type HighlightFrameworkQueryVariables = Exact<{
  request: FrameworkHighlightRequest;
}>;


export type HighlightFrameworkQuery = { __typename?: 'Query', highlightFramework: { __typename?: 'FrameworkHighlightResponse', title?: Array<string> | null, description?: Array<string> | null, lotTitle?: Array<string> | null, lotDescription?: Array<string> | null } };

export type ExportFrameworkSuppliersMutationVariables = Exact<{
  frameworkId: Scalars['String']['input'];
  exportFormat: ExportFormatArgs;
  selectedSupplierGuids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  selectedFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ExportFrameworkSuppliersMutation = { __typename?: 'Mutation', exportFrameworkSuppliers: { __typename?: 'FileExport', id: string } };

export type FrameworkUrlInformationQueryVariables = Exact<{
  frameworkId: Scalars['String']['input'];
}>;


export type FrameworkUrlInformationQuery = { __typename?: 'Query', framework: { __typename?: 'Framework', id: string, title: string } };

export type ExportFrameworksMutationVariables = Exact<{
  filters: SearchFrameworksRequest;
  exportFormat: ExportFormatArgs;
  selectedFrameworks: SelectedFrameworks;
  selectedFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ExportFrameworksMutation = { __typename?: 'Mutation', exportFrameworks: { __typename?: 'FileExport', id: string } };

export type SearchFrameworksQueryVariables = Exact<{
  request: SearchFrameworksRequest;
  includeSignals: Scalars['Boolean']['input'];
}>;


export type SearchFrameworksQuery = { __typename?: 'Query', frameworks: { __typename?: 'FrameworkSearchResponse', totalResults: number, results: Array<{ __typename?: 'Framework', id: string, title: string, signalScore?: number | null, stage: Framework_StageEnum_0, procedureType?: Framework_ProcedureTypeEnum_0 | null, awardType?: Framework_AwardTypeEnum_0 | null, validatedByProvider: boolean, supplierCount: number, lotCount: number, buyerCount: number, callOffCount: number, signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string }> | null, callOff: { __typename?: 'Framework_CallOff', count: number, averageAmount?: { __typename?: 'Framework_CallOff_AverageAmount', amount: number, currency: string } | null }, serviceProvider?: { __typename?: 'Organisation', id: string, name: string } | null, textSections?: Array<{ __typename?: 'Framework_TextSections', title: string, role: string, content: { __typename?: 'Framework_TextSections_Content', content: string, content_type: string } }> | null, contractPeriod?: { __typename?: 'Framework_PlanningPeriod', startDate?: string | null, endDate?: string | null } | null, tenderPeriod?: { __typename?: 'Framework_PlanningPeriod', startDate?: string | null, endDate?: string | null } | null, value?: { __typename?: 'Framework_Value', amount: number, currency: string } | null }> } };

export type DocumentsCountQueryVariables = Exact<{
  request: DocumentsSearchRequest;
}>;


export type DocumentsCountQuery = { __typename?: 'Query', documents: { __typename: 'DocumentsSearchResponse', totalResults: number } };

export type FrameworksCountQueryVariables = Exact<{
  request: SearchFrameworksRequest;
}>;


export type FrameworksCountQuery = { __typename?: 'Query', frameworks: { __typename: 'FrameworkSearchResponse', totalResults: number } };

export type NoticesOverallQueryVariables = Exact<{
  request: NoticesSearchRequest;
}>;


export type NoticesOverallQuery = { __typename?: 'Query', notices: { __typename: 'NoticesSearch', totalResults: number, analysis?: { __typename?: 'NoticesAnalysis', overall?: { __typename?: 'NoticesAnalysis_Overall', noticeValues: number } | null } | null } };

export type OpportunitiesStagesQueryVariables = Exact<{
  request?: InputMaybe<OpportunityCountSearchRequest>;
}>;


export type OpportunitiesStagesQuery = { __typename?: 'Query', opportunityWorkflow: { __typename?: 'OpportunityWorkflow', transitions: Array<{ __typename?: 'OpportunityWorkflow_Transitions', group: OpportunityWorkflow_Transitions_GroupEnum_2, order: number, stage: { __typename?: 'OpportunityWorkflowStage', id: string, name: string, color: string, iconColor: string, iconName: string, opportunityCount?: number | null } }> } };

export type HubspotIdTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type HubspotIdTokenQuery = { __typename?: 'Query', hubspotIdToken: { __typename?: 'HubspotIdTokenResponse', token: string } };

export type GenerateKeywordsMutationVariables = Exact<{
  args: GenerateKeywordsRequest;
}>;


export type GenerateKeywordsMutation = { __typename?: 'Mutation', generateKeywords: { __typename?: 'Keywords', keywords: Array<string> } };

export type KeywordsRecommendationsMutationVariables = Exact<{
  args: GenerateKeywordsRecommendationRequest;
}>;


export type KeywordsRecommendationsMutation = { __typename?: 'Mutation', keywordsRecommendations: { __typename?: 'Keywords', keywords: Array<string> } };

export type KeywordsQueryVariables = Exact<{
  args: GenerateKeywordsRequest;
}>;


export type KeywordsQuery = { __typename?: 'Query', keywords: { __typename?: 'Keywords', companyName?: string | null, keywords: Array<string> } };

export type KeywordsRecommendationQueryVariables = Exact<{
  args: GenerateKeywordsRecommendationRequest;
}>;


export type KeywordsRecommendationQuery = { __typename?: 'Query', keywordsRecommendation: { __typename?: 'Keywords', keywords: Array<string> } };

export type MakeWebhookMutationVariables = Exact<{
  req: MakeWebhookRequest;
}>;


export type MakeWebhookMutation = { __typename?: 'Mutation', makeWebhook: boolean };

export type NoticesAnalysisByGroupQueryVariables = Exact<{
  request: NoticesSearchRequest;
  byGroupOptions: NoticesAnalysisByGroupRequestSchema;
}>;


export type NoticesAnalysisByGroupQuery = { __typename?: 'Query', notices: { __typename?: 'NoticesSearch', totalResults: number, analysis?: { __typename?: 'NoticesAnalysis', overall?: { __typename?: 'NoticesAnalysis_Overall', noticeValues: number } | null, byGroup?: { __typename?: 'NoticesAnalysis_ByGroup', totalResults: number, maxNoticeCount: number, maxNoticeValues: number, results: Array<{ __typename?: 'NoticesAnalysis_ByGroup_Results', guid: string, name: string, noticeCount: number, noticeValues: number, isSavedCount: number }> } | null } | null } };

export type NoticesAnalysisByPeriodQueryVariables = Exact<{
  request: NoticesSearchRequest;
  byPeriodOptions: NoticesAnalysisByPeriodRequestSchema;
}>;


export type NoticesAnalysisByPeriodQuery = { __typename?: 'Query', notices: { __typename?: 'NoticesSearch', totalResults: number, analysis?: { __typename?: 'NoticesAnalysis', overall?: { __typename?: 'NoticesAnalysis_Overall', noticeValues: number } | null, byPeriod?: { __typename?: 'NoticesAnalysis_ByPeriod', results: Array<{ __typename?: 'NoticesAnalysis_ByPeriod_Results', dateStart: string, dateEnd: string, noticeCount: number, noticeValues: number }> } | null } | null } };

export type NoticeQueryVariables = Exact<{
  id: Scalars['String']['input'];
  useLegacySignalScore: Scalars['Boolean']['input'];
}>;


export type NoticeQuery = { __typename?: 'Query', notice: { __typename?: 'Notice', guid: string, name?: string | null, description?: string | null, entityType?: BasicNotice_EntityTypeEnum_0 | null, stage?: BasicNotice_StageEnum_0 | null, stagev2?: Notice_Timeline_Award_StageEnum_0 | null, qualification?: Notice_QualificationEnum_0 | null, legacyRelevanceScore?: number | null, score?: number | null, value?: number | null, currency?: string | null, url: string, expiryDate?: string | null, closeDate?: string | null, publishDate?: string | null, buyerContactName?: string | null, buyerContactEmail?: string | null, buyerContactPhone?: string | null, redacted: boolean, procurementStage: { __typename?: 'Notice_ProcurementStage', id: string, stage?: Notice_ProcurementStage_StageEnum_0 | null, procurementProcessId: string }, lots: Array<{ __typename?: 'Notice_Lots', lotNumber?: string | null, lotTitle?: string | null, value?: number | null, currency?: string | null, endDate?: string | null, suppliers?: Array<{ __typename?: 'Notice_Lots_Suppliers', id: number, guid: string, name: string }> | null }>, lotsv2: Array<{ __typename?: 'Notice_Lotsv2', id: string, title: string, description?: string | null, value?: { __typename?: 'Notice_Lotsv2_Value', amount?: number | null, currency?: Notice_Contracts_Value_CurrencyEnum_0 | null } | null, cpvCodes: Array<{ __typename?: 'Notice_Lotsv2_CpvCodes', code: string, name: string }>, contractPeriod?: { __typename?: 'Notice_Lotsv2_ContractPeriod', startDate?: string | null, maxExtentDate?: string | null, endDate?: string | null } | null }>, contracts: Array<{ __typename?: 'Notice_Contracts', awardId: string, title?: string | null, description?: string | null, awardDate?: string | null, value?: { __typename?: 'Notice_Contracts_Value', amount?: number | null, currency?: Notice_Contracts_Value_CurrencyEnum_0 | null } | null, contractPeriod?: { __typename?: 'Notice_Contracts_ContractPeriod', startDate?: string | null, maxExtentDate?: string | null, endDate?: string | null } | null, suppliers: Array<{ __typename?: 'Notice_Contracts_Suppliers', name: string, guid: string }>, cpvCodes: Array<{ __typename?: 'Notice_Lotsv2_CpvCodes', code: string, name: string }>, lots: Array<{ __typename?: 'Notice_Contracts_Lots', id: string, title: string }> }>, cpvCodes: Array<{ __typename?: 'Notice_Lotsv2_CpvCodes', code: string, name: string }>, buyers: Array<{ __typename?: 'Buyer', id: number, guid: string, name: string, buyerUrl?: string | null, country?: string | null, town?: string | null, postalCode?: string | null, address?: string | null }>, assignee?: { __typename?: 'BasicUser', guid: string, firstName: string, lastName: string } | null, seenByUsers: Array<{ __typename?: 'BasicUser', guid: string, firstName: string }>, relatedFrameworkProcess?: { __typename?: 'Notice_RelatedFrameworkProcess', frameworkId: string, frameworkName: string, processType: Notice_RelatedFrameworkProcess_ProcessTypeEnum_0 } | null, signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string }> | null, timeline?: { __typename?: 'Notice_Timeline', preTender?: { __typename?: 'Notice_Timeline_PreTender', title?: string | null, stage?: Notice_Timeline_Award_StageEnum_0 | null, publishedDate?: string | null, deadlineDates?: Array<string | null> | null } | null, tender?: { __typename?: 'Notice_Timeline_Tender', title?: string | null, stage?: Notice_Timeline_Award_StageEnum_0 | null, estimated: boolean, publishedDate?: string | null, clarificationDate?: string | null, closeDate?: string | null } | null, award: Array<{ __typename?: 'Notice_Timeline_Award', title?: string | null, stage?: Notice_Timeline_Award_StageEnum_0 | null, estimated: boolean, publishedDate?: string | null, awardDate?: string | null, startDate?: string | null, expiryDate?: string | null, extensionDate?: string | null }> } | null, duplicates: Array<{ __typename?: 'Notice', guid: string, name?: string | null, url: string }> } };

export type ExportNoticesMutationVariables = Exact<{
  filters: NoticesSearchRequest;
  exportFormat: ExportFormatArgs;
  selectedNotices: SelectedNotices;
  selectedFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ExportNoticesMutation = { __typename?: 'Mutation', exportNotices: { __typename?: 'FileExport', id: string } };

export type HighlightNoticeQueryVariables = Exact<{
  request: NoticeHighlightRequest;
}>;


export type HighlightNoticeQuery = { __typename?: 'Query', highlightNotice: { __typename?: 'NoticeHighlightResponse', title?: Array<string> | null, description?: Array<string> | null } };

export type NoticesQueryVariables = Exact<{
  request: NoticesSearchRequest;
  includeSignals: Scalars['Boolean']['input'];
}>;


export type NoticesQuery = { __typename?: 'Query', notices: { __typename?: 'NoticesSearch', totalResults: number, results: Array<{ __typename?: 'Notice', redacted: boolean, score?: number | null, guid: string, country?: string | null, stage?: BasicNotice_StageEnum_0 | null, stagev2?: Notice_Timeline_Award_StageEnum_0 | null, name?: string | null, entityType?: BasicNotice_EntityTypeEnum_0 | null, currency?: string | null, value?: number | null, publishDate?: string | null, closeDate?: string | null, awardDate?: string | null, expiryDate?: string | null, url: string, qualification?: Notice_QualificationEnum_0 | null, procurementStage: { __typename?: 'Notice_ProcurementStage', id: string, stage?: Notice_ProcurementStage_StageEnum_0 | null }, signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string }> | null, buyers: Array<{ __typename?: 'Buyer', id: number, guid: string, name: string, categoryAssignments: Array<{ __typename?: 'Buyer_CategoryAssignments', categoryId: string, categoryName: string, parentCategoryId?: string | null, parentCategoryName?: string | null, source: string }> }>, suppliers: Array<{ __typename?: 'Notice_Suppliers', id: number, name: string, guid: string, isSme?: boolean | null }>, lists: Array<{ __typename?: 'Notice_Lists', id: number, name: string }>, assignee?: { __typename?: 'BasicUser', guid: string, firstName: string, lastName: string } | null, comments: Array<{ __typename?: 'Comment', id: string, content: string }>, seenByUsers: Array<{ __typename?: 'BasicUser', firstName: string, guid: string }>, relatedFrameworkProcess?: { __typename?: 'Notice_RelatedFrameworkProcess', frameworkId: string, frameworkName: string, processType: Notice_RelatedFrameworkProcess_ProcessTypeEnum_0 } | null, opportunities: Array<{ __typename?: 'OpportunityBasic', id: string }> }> } };

export type AddOpportunityEntityMutationVariables = Exact<{
  id: Scalars['String']['input'];
  entities: OpportunityEntitiesInput;
}>;


export type AddOpportunityEntityMutation = { __typename?: 'Mutation', addOpportunityEntities: { __typename?: 'OpportunityEntitiesUpdateResponse', id: string } };

export type BuyerActivityStatusSubscriptionVariables = Exact<{
  opportunityId: Scalars['String']['input'];
}>;


export type BuyerActivityStatusSubscription = { __typename?: 'Subscription', buyerActivityStatus: { __typename?: 'BuyerActivitySummaryStatus', opportunityId: string, isComplete: boolean, result: { __typename?: 'OpportunityBuyerActivity', status?: OpportunityBuyerActivity_StatusEnum_0 | null, createdAt?: string | null, questions: Array<{ __typename?: 'OpportunityBuyerActivity_Questions', question: string, answer: string }>, relatedNotices: Array<{ __typename?: 'Notice', guid: string, name?: string | null, stage?: BasicNotice_StageEnum_0 | null, stagev2?: Notice_Timeline_Award_StageEnum_0 | null, expiryDate?: string | null, closeDate?: string | null, publishDate?: string | null, value?: number | null, lots: Array<{ __typename?: 'Notice_Lots', suppliers?: Array<{ __typename?: 'Notice_Lots_Suppliers', guid: string, name: string }> | null }>, buyers: Array<{ __typename?: 'Buyer', guid: string }>, procurementStage: { __typename?: 'Notice_ProcurementStage', id: string, stage?: Notice_ProcurementStage_StageEnum_0 | null } }> } } };

export type CreateOpportunityMutationVariables = Exact<{
  opportunity: CreateOpportunity;
  entities: OpportunityEntitiesInput;
}>;


export type CreateOpportunityMutation = { __typename?: 'Mutation', createOpportunity: { __typename?: 'OpportunityBasic', id: string } };

export type DeleteOpportunityMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteOpportunityMutation = { __typename?: 'Mutation', deleteOpportunity: { __typename?: 'OpportunityEntitiesDeleteResponse', ids: Array<string>, bidIds: Array<string> } };

export type EntityOpportunitiesQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EntityOpportunitiesQuery = { __typename?: 'Query', entityOpportunities: Array<string> };

export type OpportunitiesQueryVariables = Exact<{
  options: SearchOpportunitiesRequest;
  pagination: PaginationOptions;
}>;


export type OpportunitiesQuery = { __typename?: 'Query', opportunities: { __typename?: 'OpportunitiesResponse', total: number, results: Array<{ __typename?: 'Opportunity', id: string, name: string, description?: string | null, value?: number | null, createdAt?: string | null, updatedAt?: string | null, closeDate?: string | null, assignedTo?: { __typename?: 'User', guid: string, firstName: string, lastName: string } | null, stage: { __typename?: 'OpportunityWorkflowStage', id: string, name: string, color: string, iconName: string, iconColor: string }, buyers: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null }>, suppliers: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null }> }> } };

export type OpportunityQueryVariables = Exact<{
  id: Scalars['String']['input'];
  supplierBuyerNoticeSummaryRequest?: InputMaybe<SupplierBuyerNoticeSummaryRequest>;
  includeSupplierBuyerNoticeSummary: Scalars['Boolean']['input'];
}>;


export type OpportunityQuery = { __typename?: 'Query', opportunity: { __typename?: 'Opportunity', id: string, name: string, description?: string | null, value?: number | null, routeToMarket?: string | null, clarificationDeadline?: string | null, submissionDate?: string | null, startDate?: string | null, existingExpiryDate?: string | null, closeDate?: string | null, createdAt?: string | null, updatedAt?: string | null, assignedTo?: { __typename?: 'User', guid: string, firstName: string, lastName: string } | null, createdBy?: { __typename?: 'User', guid: string, firstName: string, lastName: string } | null, notices: Array<{ __typename?: 'Notice', guid: string, name?: string | null, stage?: BasicNotice_StageEnum_0 | null, stagev2?: Notice_Timeline_Award_StageEnum_0 | null, expiryDate?: string | null, closeDate?: string | null, publishDate?: string | null, procurementStage: { __typename?: 'Notice_ProcurementStage', id: string }, lots: Array<{ __typename?: 'Notice_Lots', suppliers?: Array<{ __typename?: 'Notice_Lots_Suppliers', guid: string, name: string }> | null }>, buyers: Array<{ __typename?: 'Buyer', guid: string, name: string, logoUrl?: string | null }> }>, buyerActivity?: { __typename?: 'OpportunityBuyerActivity', status?: OpportunityBuyerActivity_StatusEnum_0 | null, createdAt?: string | null, relatedNotices: Array<{ __typename?: 'Notice', guid: string, name?: string | null, stage?: BasicNotice_StageEnum_0 | null, stagev2?: Notice_Timeline_Award_StageEnum_0 | null, expiryDate?: string | null, closeDate?: string | null, publishDate?: string | null, value?: number | null, lots: Array<{ __typename?: 'Notice_Lots', suppliers?: Array<{ __typename?: 'Notice_Lots_Suppliers', guid: string, name: string }> | null }>, buyers: Array<{ __typename?: 'Buyer', guid: string }>, procurementStage: { __typename?: 'Notice_ProcurementStage', id: string, stage?: Notice_ProcurementStage_StageEnum_0 | null } }>, questions: Array<{ __typename?: 'OpportunityBuyerActivity_Questions', question: string, answer: string }> } | null, documents: Array<{ __typename?: 'Document', id: string, title?: string | null, category?: string | null, publishedAt?: string | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null }>, frameworks: Array<{ __typename?: 'Framework', id: string, title: string, stage: Framework_StageEnum_0, tenderPeriod?: { __typename?: 'Framework_PlanningPeriod', endDate?: string | null } | null, contractPeriod?: { __typename?: 'Framework_PlanningPeriod', endDate?: string | null } | null, buyers?: Array<{ __typename?: 'Organisation', id: string, name: string }> | null }>, suppliers: Array<{ __typename?: 'Organisation', name: string, countryCode?: string | null, id: string, logoUrl?: string | null, noticeCount?: number | null }>, buyers: Array<{ __typename?: 'Organisation', id: string, name: string, logoUrl?: string | null, categoryAssignments?: Array<{ __typename?: 'Organisation_CategoryAssignments', categoryName: string, parentCategoryName: string }> | null }>, comments: Array<{ __typename?: 'Comment', id: string, content: string, createdAt?: string | null, updatedAt?: string | null, author: { __typename?: 'BasicUser', guid: string, firstName: string, lastName: string } }>, stage: { __typename?: 'OpportunityWorkflowStage', id: string, name: string, color: string, iconName: string, iconColor: string, transitionGroup?: string | null }, contacts: Array<{ __typename?: 'Contact', id: string, title: string, jobTitle: string, jobFunction: Array<string>, seniority: string, firstName: string, lastName: string, email?: string | null, phone?: string | null, buyer?: { __typename?: 'Organisation', id: string, name: string } | null, opportunities: Array<{ __typename?: 'OpportunityBasic', id: string }> }>, bid?: { __typename?: 'Bid', id: string } | null, supplierBuyerNoticeSummary?: Array<{ __typename?: 'PartnersBuyerSummary', supplier: { __typename?: 'Organisation', name: string, id: string, logoUrl?: string | null }, allAwards: { __typename?: 'PartnersBuyerSummary_AllAwards', totalCount: number, totalValue: number }, similarAwards: { __typename?: 'PartnersBuyerSummary_AllAwards', totalCount: number, totalValue: number } }> } };

export type ExportOpportunitiesMutationVariables = Exact<{
  filters: SearchOpportunitiesRequest;
  exportFormat: ExportFormatArgs;
  pagination: PaginationOptions;
  selectedOpportunities: SelectedOpportunities;
  selectedFields?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ExportOpportunitiesMutation = { __typename?: 'Mutation', exportOpportunities: { __typename?: 'FileExport', id: string } };

export type OpportunityWorkflowQueryVariables = Exact<{ [key: string]: never; }>;


export type OpportunityWorkflowQuery = { __typename?: 'Query', opportunityWorkflow: { __typename?: 'OpportunityWorkflow', id: string, isDefault: boolean, transitions: Array<{ __typename?: 'OpportunityWorkflow_Transitions', id: string, group: OpportunityWorkflow_Transitions_GroupEnum_2, order: number, stage: { __typename?: 'OpportunityWorkflowStage', id: string, name: string, color: string, iconColor: string, iconName: string } }> } };

export type RegenerateOpportunityBuyerSummaryMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RegenerateOpportunityBuyerSummaryMutation = { __typename?: 'Mutation', regenerateOpportunityBuyerSummary: { __typename?: 'OpportunityBuyerActivity', status?: OpportunityBuyerActivity_StatusEnum_0 | null, createdAt?: string | null, relatedNotices: Array<{ __typename?: 'Notice', guid: string, name?: string | null, stage?: BasicNotice_StageEnum_0 | null, stagev2?: Notice_Timeline_Award_StageEnum_0 | null, expiryDate?: string | null, closeDate?: string | null, publishDate?: string | null, value?: number | null, lots: Array<{ __typename?: 'Notice_Lots', suppliers?: Array<{ __typename?: 'Notice_Lots_Suppliers', guid: string, name: string }> | null }>, buyers: Array<{ __typename?: 'Buyer', guid: string }>, procurementStage: { __typename?: 'Notice_ProcurementStage', id: string, stage?: Notice_ProcurementStage_StageEnum_0 | null } }>, questions: Array<{ __typename?: 'OpportunityBuyerActivity_Questions', question: string, answer: string }> } };

export type RemoveOpportunityEntityMutationVariables = Exact<{
  id: Scalars['String']['input'];
  entities: OpportunityEntitiesInput;
}>;


export type RemoveOpportunityEntityMutation = { __typename?: 'Mutation', removeOpportunityEntity: { __typename?: 'OpportunityEntitiesUpdateResponse', id: string } };

export type SupplierBuyerNoticeSummaryQueryVariables = Exact<{
  opportunityId: Scalars['String']['input'];
  searchRequest: SupplierBuyerNoticeSummaryRequest;
}>;


export type SupplierBuyerNoticeSummaryQuery = { __typename?: 'Query', opportunity: { __typename?: 'Opportunity', supplierBuyerNoticeSummary: Array<{ __typename?: 'PartnersBuyerSummary', supplier: { __typename?: 'Organisation', name: string, id: string }, allAwards: { __typename?: 'PartnersBuyerSummary_AllAwards', totalCount: number, totalValue: number }, similarAwards: { __typename?: 'PartnersBuyerSummary_AllAwards', totalCount: number, totalValue: number } }> } };

export type UpdateOpportunityMutationVariables = Exact<{
  opportunity: OpportunityUpdateInput;
}>;


export type UpdateOpportunityMutation = { __typename?: 'Mutation', updateOpportunity: { __typename?: 'Opportunity', id: string, name: string, description?: string | null, createdAt?: string | null, updatedAt?: string | null, value?: number | null, closeDate?: string | null, stage: { __typename?: 'OpportunityWorkflowStage', id: string } } };

export type BulkUpdateOpportunitiesStageMutationVariables = Exact<{
  input: BulkUpdateOpportunitiesStageInput;
}>;


export type BulkUpdateOpportunitiesStageMutation = { __typename?: 'Mutation', bulkUpdateOpportunitiesStage: { __typename?: 'BulkUpdateOpportunitiesStageResponse', count: number } };

export type CompetitorPartnerCountOnBuyerQueryVariables = Exact<{
  req: NoticeCountByCrossRefOrgRequest;
}>;


export type CompetitorPartnerCountOnBuyerQuery = { __typename?: 'Query', noticeCountByCrossRefOrg: Array<{ __typename?: 'noticeCountByCrossRefOrg', orgId: string, noticeCount: number }> };

export type OrganisationsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrganisationsQuery = { __typename?: 'Query', organisations: Array<{ __typename?: 'Organisation', id: string, name: string, url?: string | null, email?: string | null, phone?: string | null, address?: string | null, town?: string | null, postalCode?: string | null, primaryRole?: Organisation_PrimaryRoleEnum_0 | null }> };

export type SearchOrganisationsQueryVariables = Exact<{
  request: SearchOrganisationsRequest;
  includeNotices: Scalars['Boolean']['input'];
  includeAliases: Scalars['Boolean']['input'];
}>;


export type SearchOrganisationsQuery = { __typename?: 'Query', searchOrganisations: { __typename?: 'SearchOrganisationsResponse', total: number, orgs: Array<{ __typename?: 'Organisation', id: string, address?: string | null, countryCode?: string | null, email?: string | null, isStotlesVerified?: boolean | null, name: string, phone?: string | null, postalCode?: string | null, town?: string | null, url?: string | null, primaryRole?: Organisation_PrimaryRoleEnum_0 | null, noticeCount?: number | null, aliases?: Array<string> | null }> } };

export type GenerateOutreachMutationVariables = Exact<{
  input: GenerateOutreachRequest;
}>;


export type GenerateOutreachMutation = { __typename?: 'Mutation', generateOutreach: { __typename?: 'GenerateOutreachResponse', responses: Array<{ __typename?: 'GenerateOutreachResponse_Responses', subject: string, body: string }> } };

export type AskQuestionMutationVariables = Exact<{
  input: QuestionRequest;
}>;


export type AskQuestionMutation = { __typename?: 'Mutation', askQuestion: { __typename?: 'Question', id: string, question: string, answer?: string | null, isComplete: boolean } };

export type CreateAiReportMutationVariables = Exact<{
  input: CreateAiReportInput;
}>;


export type CreateAiReportMutation = { __typename?: 'Mutation', createAiReport: { __typename?: 'Report', id: string } };

export type ProvideQaFeedbackMutationVariables = Exact<{
  args: ProvideFeedbackRequest;
}>;


export type ProvideQaFeedbackMutation = { __typename?: 'Mutation', provideQaFeedback: { __typename?: 'Feedback', questionId: string, userDetailedFeedback?: string | null, isPositive: boolean } };

export type QuestionAnsweredSubscriptionVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type QuestionAnsweredSubscription = { __typename?: 'Subscription', questionAnswered: { __typename?: 'Question', id: string, question: string, answer?: string | null, isComplete: boolean, referenceId: string } };

export type GetQuestionsQueryVariables = Exact<{
  args: GetQuestionsRequest;
}>;


export type GetQuestionsQuery = { __typename?: 'Query', getQuestions: Array<{ __typename?: 'Question', id: string, question: string, isComplete: boolean, answer?: string | null, responseReceivedAt?: string | null, referenceId: string, reportId?: string | null }> };

export type DocumentSignalsQueryVariables = Exact<{
  documentId: Scalars['String']['input'];
}>;


export type DocumentSignalsQuery = { __typename?: 'Query', document: { __typename?: 'Document', signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string, colour: string }> | null } };

export type FrameworkSignalsQueryVariables = Exact<{
  frameworkId: Scalars['String']['input'];
}>;


export type FrameworkSignalsQuery = { __typename?: 'Query', framework: { __typename?: 'Framework', signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string, colour: string }> | null } };

export type NoticeSignalsQueryVariables = Exact<{
  noticeId: Scalars['String']['input'];
}>;


export type NoticeSignalsQuery = { __typename?: 'Query', notice: { __typename?: 'Notice', signals?: Array<{ __typename?: 'SignalDefinition', id: string, name: string, category: string, colour: string }> | null } };

export type SavedSuppliersQueryVariables = Exact<{ [key: string]: never; }>;


export type SavedSuppliersQuery = { __typename?: 'Query', signalSettings: { __typename?: 'SignalSettings', competitorGuids: Array<string>, partnerGuids: Array<string> } };

export type UpdateSignalSettingsMutationVariables = Exact<{
  input: UpdateSignalSettings;
}>;


export type UpdateSignalSettingsMutation = { __typename?: 'Mutation', updateSignalSettings: { __typename?: 'SimpleSignalSettings', countries?: Array<string> | null, keywords?: Array<string> | null, languages?: Array<string> | null, cpvCodes?: Array<string> | null, competitorGuids: Array<string>, partnerGuids: Array<string>, useSupplierName: boolean } };

export type SupplierDetailsQueryVariables = Exact<{
  guids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SupplierDetailsQuery = { __typename?: 'Query', suppliers: { __typename?: 'SupplierDetailsResponse', totalResults: number, results: Array<{ __typename?: 'SupplierDetails', id: number, guid: string, name: string, country?: string | null, countryCode?: string | null, isSme?: boolean | null, address?: string | null, town?: string | null, postalCode?: string | null, phone?: string | null, email?: string | null, isStotlesVerified?: boolean | null, isArchived?: boolean | null, createdAt?: string | null, updatedAt?: string | null, referenceOrganisations?: Array<{ __typename?: 'ReferenceOrganisation', name: string, source: string, sourceIdentifier: string, address?: { __typename?: 'ReferenceOrganisation_Address', address?: string | null, address2?: string | null, postCode?: string | null, countryCode?: string | null } | null, basicContactInfo?: { __typename?: 'ReferenceOrganisation_BasicContactInfo', phone?: string | null, websiteUrl?: string | null } | null }> | null }> } };

export type SupplierStatsGqlQueryVariables = Exact<{
  inputDirect: NoticesSearchRequest;
  inputMentioned: NoticesSearchRequest;
  inputUpcomingExpiries: NoticesSearchRequest;
}>;


export type SupplierStatsGqlQuery = { __typename?: 'Query', directAwards: { __typename?: 'NoticesSearch', totalResults: number }, mentionedNotices: { __typename?: 'NoticesSearch', totalResults: number }, upcomingExpiries: { __typename?: 'NoticesSearch', totalResults: number } };

export type AddTeamToDevcycleAudienceMutationVariables = Exact<{
  input: AddTeamToDevcycleInput;
}>;


export type AddTeamToDevcycleAudienceMutation = { __typename?: 'Mutation', addTeamToDevcycleAudience: { __typename?: 'DevCycleAudienceDetails', name: string, description: string } };

export type AdminTeamsQueryVariables = Exact<{
  companyId: Scalars['String']['input'];
}>;


export type AdminTeamsQuery = { __typename?: 'Query', adminTeams: Array<{ __typename?: 'Team', id: string, name: string, isPrivate: boolean, feedSettingsId?: string | null, users: Array<{ __typename?: 'User', guid: string, firstName: string, lastName: string }> }> };

export type HardDeleteTeamFromOnboardingMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;


export type HardDeleteTeamFromOnboardingMutation = { __typename?: 'Mutation', hardDeleteTeamFromOnboarding: { __typename?: 'DeletedTeamResponse', id: string } };

export type SignalSettingsQueryVariables = Exact<{
  includeNotices: Scalars['Boolean']['input'];
  includeAliases: Scalars['Boolean']['input'];
}>;


export type SignalSettingsQuery = { __typename?: 'Query', signalSettings: { __typename?: 'SignalSettings', countries?: Array<string> | null, languages?: Array<string> | null, keywords?: Array<string> | null, cpvCodes?: Array<string> | null, competitors: Array<{ __typename?: 'Organisation', id: string, name: string, noticeCount?: number | null, aliases?: Array<string> | null, countryCode?: string | null }>, partners: Array<{ __typename?: 'Organisation', id: string, name: string, noticeCount?: number | null, aliases?: Array<string> | null, countryCode?: string | null }> } };

export type TeamQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamQuery = { __typename?: 'Query', team: { __typename?: 'Team', id: string, name: string, users: Array<{ __typename?: 'User', guid: string, firstName: string, lastName: string }> } };

export type TeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamsQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: string, name: string, isPrivate: boolean, feedSettingsId?: string | null, users: Array<{ __typename?: 'User', guid: string, firstName: string, lastName: string }> }> };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'BasicTeam', id: string, name: string, isPrivate: boolean } };

export type SearchAdminUsersQueryVariables = Exact<{
  request: SearchUserRequest;
}>;


export type SearchAdminUsersQuery = { __typename?: 'Query', adminUsers: Array<{ __typename?: 'User', guid: string, firstName: string, lastName: string, email: string }> };

export type UpdateUserMutationVariables = Exact<{
  request: UpdateUserRequest;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', guid: string } };

export type DescribeFrameworkConfigQueryVariables = Exact<{
  frameworkId: Scalars['String']['input'];
}>;


export type DescribeFrameworkConfigQuery = { __typename?: 'Query', framework: { __typename?: 'Framework', id: string, title: string, callOff: { __typename?: 'Framework_CallOff', count: number }, serviceProvider?: { __typename?: 'Organisation', id: string, name: string } | null, callOffIdentificationRule?: { __typename?: 'Framework_CallOffIdentificationRule', id: string, frameworkId: string, config: { __typename?: 'Framework_CallOffIdentificationRule_Config', keywords: Array<Array<string>> } } | null } };

export type PersistCallOffConfigMutationVariables = Exact<{
  args: PersistCallOffConfigRequest;
}>;


export type PersistCallOffConfigMutation = { __typename?: 'Mutation', persistCallOffConfig: { __typename?: 'Framework_CallOffIdentificationRule', id: string, frameworkId: string, config: { __typename?: 'Framework_CallOffIdentificationRule_Config', keywords: Array<Array<string>> } } };

export type SearchFrameworkConfigsQueryVariables = Exact<{
  request: SearchFrameworksRequest;
}>;


export type SearchFrameworkConfigsQuery = { __typename?: 'Query', frameworks: { __typename?: 'FrameworkSearchResponse', totalResults: number, results: Array<{ __typename?: 'Framework', id: string, title: string, callOff: { __typename?: 'Framework_CallOff', count: number }, serviceProvider?: { __typename?: 'Organisation', id: string, name: string } | null, callOffIdentificationRule?: { __typename?: 'Framework_CallOffIdentificationRule', id: string, frameworkId: string, config: { __typename?: 'Framework_CallOffIdentificationRule_Config', keywords: Array<Array<string>> } } | null }> } };


export const CreateCreditTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCreditTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCreditTransactionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCreditTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreateCreditTransactionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCreditTransactionMutation, CreateCreditTransactionMutationVariables>;
export const CreditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"credits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreditsSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreditsSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"holderType"}},{"kind":"Field","name":{"kind":"Name","value":"creditType"}},{"kind":"Field","name":{"kind":"Name","value":"totalCredits"}},{"kind":"Field","name":{"kind":"Name","value":"remainingCredits"}},{"kind":"Field","name":{"kind":"Name","value":"creditHolder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<CreditsQuery, CreditsQueryVariables>;
export const RemainingCreditsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"remainingCredits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemainingCreditRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remainingCredits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"RemainingCreditRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"remainingCredits"}}]}}]}}]} as unknown as DocumentNode<RemainingCreditsQuery, RemainingCreditsQueryVariables>;
export const EvaluateNoticesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EvaluateNotices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EvaluateNoticesRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"evaluateNotices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"EvaluateNoticesRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"experimentWebUrl"}}]}}]}}]} as unknown as DocumentNode<EvaluateNoticesMutation, EvaluateNoticesMutationVariables>;
export const BuyerSummaryEvaluationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"buyerSummaryEvaluation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityEvaluationRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerSummaryEvaluation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"OpportunityEvaluationRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"experimentWebUrl"}}]}}]}}]} as unknown as DocumentNode<BuyerSummaryEvaluationMutation, BuyerSummaryEvaluationMutationVariables>;
export const LangsmithPromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LangsmithPrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"langsmithPrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promptId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"questions"}}]}}]}}]} as unknown as DocumentNode<LangsmithPromptsQuery, LangsmithPromptsQueryVariables>;
export const PromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"prompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfResults"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfSemanticSearchResults"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"promptTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}}]}}]}}]} as unknown as DocumentNode<PromptsQuery, PromptsQueryVariables>;
export const CreateExemptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createExemption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSeoExemptionsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExemptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreateSeoExemptionsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createExemptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"exemptFromIndexingRules"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateExemptionMutation, CreateExemptionMutationVariables>;
export const DeleteExemptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteExemption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSeoExemptionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteExemption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DeleteSeoExemptionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}}]}}]}}]} as unknown as DocumentNode<DeleteExemptionMutation, DeleteExemptionMutationVariables>;
export const SeoExemptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"seoExemptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seoExemptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"exemptFromIndexingRules"}}]}}]}}]} as unknown as DocumentNode<SeoExemptionsQuery, SeoExemptionsQueryVariables>;
export const CreatePromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePromptInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"template"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PromptTemplateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPrompt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreatePromptInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"PromptTemplate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"template"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfResults"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfSemanticSearchResults"}},{"kind":"Field","name":{"kind":"Name","value":"promptType"}},{"kind":"Field","name":{"kind":"Name","value":"promptTemplate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"template"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePromptMutation, CreatePromptMutationVariables>;
export const DocumentAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrlLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alternativeSource"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentAdminQuery, DocumentAdminQueryVariables>;
export const DocumentsAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentsAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentsSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DocumentsSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signalScore"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pdfDocumentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<DocumentsAdminQuery, DocumentsAdminQueryVariables>;
export const UpdateBidAnswerByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateBidAnswerById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBidAnswerRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBidAnswerById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpdateBidAnswerRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidId"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateBidAnswerByIdMutation, UpdateBidAnswerByIdMutationVariables>;
export const BidChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BidChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"req"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BidChatRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidChat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"BidChatRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"req"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}}]}}]}}]} as unknown as DocumentNode<BidChatMutation, BidChatMutationVariables>;
export const BidChatAnsweredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"bidChatAnswered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidChatAnswered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"bidId"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}}]}}]}}]} as unknown as DocumentNode<BidChatAnsweredSubscription, BidChatAnsweredSubscriptionVariables>;
export const BidDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bidDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]}}]} as unknown as DocumentNode<BidDocumentsQuery, BidDocumentsQueryVariables>;
export const CreateBidDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBidDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBidDocumentRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBidDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreateBidDocumentRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<CreateBidDocumentMutation, CreateBidDocumentMutationVariables>;
export const DeleteBidDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBidDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteBidDocumentRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBidDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DeleteBidDocumentRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidId"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<DeleteBidDocumentMutation, DeleteBidDocumentMutationVariables>;
export const GetBidDocumentUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetBidDocumentUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBidDocumentUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}}]}}]} as unknown as DocumentNode<GetBidDocumentUrlMutation, GetBidDocumentUrlMutationVariables>;
export const UploadNoticeDocumentUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadNoticeDocumentURL"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadNoticeDocumentRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadNoticeDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UploadNoticeDocumentRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}}]}}]}}]} as unknown as DocumentNode<UploadNoticeDocumentUrlMutation, UploadNoticeDocumentUrlMutationVariables>;
export const AskBidQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AskBidQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"req"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QualifyQuestionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askBidQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"QualifyQuestionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"req"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AskBidQuestionMutation, AskBidQuestionMutationVariables>;
export const BidQuestionGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bidQuestionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bidQuestionGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"promptId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BidQuestionGroupsQuery, BidQuestionGroupsQueryVariables>;
export const CreateQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateQuestionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreateQuestionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"promptId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}}]}}]}}]}}]} as unknown as DocumentNode<CreateQuestionMutation, CreateQuestionMutationVariables>;
export const DeleteQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteQuestionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DeleteQuestionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteQuestionMutation, DeleteQuestionMutationVariables>;
export const UpdateQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateQuestionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpdateQuestionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const GetDefaultQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDefaultQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDefaultQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"promptId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}}]}}]}}]}}]} as unknown as DocumentNode<GetDefaultQuestionsQuery, GetDefaultQuestionsQueryVariables>;
export const GetQuestionsByTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetQuestionsByTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetQuestionsByTeamRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getQuestionsByTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GetQuestionsByTeamRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"promptId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}}]}}]}}]}}]} as unknown as DocumentNode<GetQuestionsByTeamQuery, GetQuestionsByTeamQueryVariables>;
export const QualifyQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QualifyQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QualifyQuestionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifyQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"QualifyQuestionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<QualifyQuestionMutation, QualifyQuestionMutationVariables>;
export const UpsertBidReportQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertBidReportQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"req"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertBidReportQuestionsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertBidReportQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpsertBidReportQuestionsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"req"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"promptId"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertBidReportQuestionsMutation, UpsertBidReportQuestionsMutationVariables>;
export const BidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Bid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BidRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"BidRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStageId"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"publicHash"}},{"kind":"Field","name":{"kind":"Name","value":"notice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<BidQuery, BidQueryVariables>;
export const BidsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"bids"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BidsSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bids"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"BidsSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStageId"}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<BidsQuery, BidsQueryVariables>;
export const CreateBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateBidRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStageId"}},{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateBidMutation, CreateBidMutationVariables>;
export const DeleteBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BidDeleteRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"BidDeleteRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStageId"}}]}}]}}]} as unknown as DocumentNode<DeleteBidMutation, DeleteBidMutationVariables>;
export const ExportBidReportAsPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportBidReportAsPDF"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportBidReportRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportBidReportAsPDF"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ExportBidReportRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ExportBidReportAsPdfMutation, ExportBidReportAsPdfMutationVariables>;
export const UpdateBidPublicityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateBidPublicity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateBidPublicityRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBidPublicity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpdateBidPublicityRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"publicHash"}}]}}]}}]} as unknown as DocumentNode<UpdateBidPublicityMutation, UpdateBidPublicityMutationVariables>;
export const GetBidReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBidReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBidReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBidReportQuery, GetBidReportQueryVariables>;
export const QualifyBidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"QualifyBid"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qualifyBid"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerId"}},{"kind":"Field","name":{"kind":"Name","value":"autoQualify"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"answer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"chunkNumber"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"x"}},{"kind":"Field","name":{"kind":"Name","value":"y"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCredits"}},{"kind":"Field","name":{"kind":"Name","value":"consumedAllCredits"}}]}}]}}]}}]} as unknown as DocumentNode<QualifyBidMutation, QualifyBidMutationVariables>;
export const BuyerCpvStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"buyerCpvStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"buyerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CpvStatsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerCpvStats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"buyerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"buyerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overallStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalAwarded"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractValue"}},{"kind":"Field","name":{"kind":"Name","value":"percentToSmes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"perCpvStats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalValue"}},{"kind":"Field","name":{"kind":"Name","value":"totalAwarded"}},{"kind":"Field","name":{"kind":"Name","value":"avgContractValue"}},{"kind":"Field","name":{"kind":"Name","value":"percentToSmes"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BuyerCpvStatsQuery, BuyerCpvStatsQueryVariables>;
export const BuyerDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"buyerDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"BuyersRequest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"guids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"categorySource"}},{"kind":"Field","name":{"kind":"Name","value":"categoryUni"}},{"kind":"Field","name":{"kind":"Name","value":"referenceCode"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"buyerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"cleanName"}},{"kind":"Field","name":{"kind":"Name","value":"nutsLocation"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"oscarId"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isStotlesVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"isInactive"}},{"kind":"Field","name":{"kind":"Name","value":"twitterHandle"}},{"kind":"Field","name":{"kind":"Name","value":"oscarCategory"}},{"kind":"Field","name":{"kind":"Name","value":"employeeCount"}},{"kind":"Field","name":{"kind":"Name","value":"annualSpend"}},{"kind":"Field","name":{"kind":"Name","value":"locationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<BuyerDetailsQuery, BuyerDetailsQueryVariables>;
export const BuyerStatsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"buyerStatsGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputAllNotices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputOpenOpps"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputUpcomingExpiries"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"allNotices"},"name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputAllNotices"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"openOpps"},"name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputOpenOpps"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingExpiries"},"name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputUpcomingExpiries"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<BuyerStatsGqlQuery, BuyerStatsGqlQueryVariables>;
export const CreateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCommentRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreateCommentRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<CreateCommentMutation, CreateCommentMutationVariables>;
export const DeleteCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteCommentRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DeleteCommentRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const UpdateCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCommentRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpdateCommentRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"objectId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const CompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyQuery, CompanyQueryVariables>;
export const ExportContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportContacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchContactsRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormatArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedContacts"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedContacts"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportContacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchContactsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"ExportFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedContacts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedContacts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExportContactsMutation, ExportContactsMutationVariables>;
export const ContactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"contacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchContactsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchContactsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"seniority"}},{"kind":"Field","name":{"kind":"Name","value":"jobFunction"}},{"kind":"Field","name":{"kind":"Name","value":"orgId"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isStotlesVerified"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"orgUrn"}},{"kind":"Field","name":{"kind":"Name","value":"oscarOrgName"}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<ContactsQuery, ContactsQueryVariables>;
export const BuyersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"buyers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BuyersRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"BuyersRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"oscarId"}}]}}]}}]}}]} as unknown as DocumentNode<BuyersQuery, BuyersQueryVariables>;
export const AllCpvCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allCpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allCpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"parentCode"}},{"kind":"Field","name":{"kind":"Name","value":"childIds"}}]}}]}}]}}]} as unknown as DocumentNode<AllCpvCodesQuery, AllCpvCodesQueryVariables>;
export const CpvCodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cpvCodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CpvCodesRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CpvCodesRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"parentCode"}}]}}]}}]}}]} as unknown as DocumentNode<CpvCodesQuery, CpvCodesQueryVariables>;
export const CpvCodesWithChildrenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"cpvCodesWithChildren"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CpvCodesRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CpvCodesRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"parentCode"}},{"kind":"Field","name":{"kind":"Name","value":"childIds"}}]}}]}}]}}]} as unknown as DocumentNode<CpvCodesWithChildrenQuery, CpvCodesWithChildrenQueryVariables>;
export const CreditsStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"creditsStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creditsStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"teamId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"teamId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"creditLimitReached"}},{"kind":"Field","name":{"kind":"Name","value":"totalCredits"}}]}}]}}]} as unknown as DocumentNode<CreditsStatusSubscription, CreditsStatusSubscriptionVariables>;
export const DocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"document"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"signalScore"}},{"kind":"Field","name":{"kind":"Name","value":"pdfDocumentUrl"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrlLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"alternativeSource"}},{"kind":"Field","name":{"kind":"Name","value":"originalMimeType"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentQuery, DocumentQueryVariables>;
export const HighlightDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"highlightDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentsHighlightRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlightDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DocumentsHighlightRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"titleHighlights"}},{"kind":"Field","name":{"kind":"Name","value":"contentHighlights"}}]}}]}}]} as unknown as DocumentNode<HighlightDocumentQuery, HighlightDocumentQueryVariables>;
export const DocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentsSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DocumentsSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signalScore"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<DocumentsQuery, DocumentsQueryVariables>;
export const FileExportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"fileExport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileExport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}},{"kind":"Field","name":{"kind":"Name","value":"isError"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<FileExportSubscription, FileExportSubscriptionVariables>;
export const DescribeFrameworkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"describeFramework"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDebugInfo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"framework"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frameworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"signalScore"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"textSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"procedureType"}},{"kind":"Field","name":{"kind":"Name","value":"awardType"}},{"kind":"Field","name":{"kind":"Name","value":"validatedByProvider"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenderPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planningPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractingAuthority"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierGuids"}},{"kind":"Field","name":{"kind":"Name","value":"contractPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordGuid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"stotlesUrl"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"externalSourceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"extensionAvailable"}},{"kind":"Field","name":{"kind":"Name","value":"debugInfo"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDebugInfo"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frameworkInfo"}},{"kind":"Field","name":{"kind":"Name","value":"frameworkEventInfo"}}]}}]}}]}}]} as unknown as DocumentNode<DescribeFrameworkQuery, DescribeFrameworkQueryVariables>;
export const HighlightFrameworkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"highlightFramework"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FrameworkHighlightRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlightFramework"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"FrameworkHighlightRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lotTitle"}},{"kind":"Field","name":{"kind":"Name","value":"lotDescription"}}]}}]}}]} as unknown as DocumentNode<HighlightFrameworkQuery, HighlightFrameworkQueryVariables>;
export const ExportFrameworkSuppliersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportFrameworkSuppliers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormatArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedSupplierGuids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportFrameworkSuppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frameworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}}},{"kind":"Argument","name":{"kind":"Name","value":"ExportFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedSupplierGuids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedSupplierGuids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExportFrameworkSuppliersMutation, ExportFrameworkSuppliersMutationVariables>;
export const FrameworkUrlInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"frameworkUrlInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"framework"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frameworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<FrameworkUrlInformationQuery, FrameworkUrlInformationQueryVariables>;
export const ExportFrameworksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportFrameworks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchFrameworksRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormatArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedFrameworks"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedFrameworks"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportFrameworks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchFrameworksRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"ExportFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedFrameworks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedFrameworks"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExportFrameworksMutation, ExportFrameworksMutationVariables>;
export const SearchFrameworksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchFrameworks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchFrameworksRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSignals"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frameworks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchFrameworksRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"signalScore"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"procedureType"}},{"kind":"Field","name":{"kind":"Name","value":"awardType"}},{"kind":"Field","name":{"kind":"Name","value":"validatedByProvider"}},{"kind":"Field","name":{"kind":"Name","value":"supplierCount"}},{"kind":"Field","name":{"kind":"Name","value":"lotCount"}},{"kind":"Field","name":{"kind":"Name","value":"buyerCount"}},{"kind":"Field","name":{"kind":"Name","value":"callOffCount"}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSignals"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callOff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"averageAmount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"content_type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenderPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<SearchFrameworksQuery, SearchFrameworksQueryVariables>;
export const DocumentsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentsSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DocumentsSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<DocumentsCountQuery, DocumentsCountQueryVariables>;
export const FrameworksCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"frameworksCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchFrameworksRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frameworks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchFrameworksRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<FrameworksCountQuery, FrameworksCountQueryVariables>;
export const NoticesOverallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"noticesOverall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticeValues"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NoticesOverallQuery, NoticesOverallQueryVariables>;
export const OpportunitiesStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunitiesStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityCountSearchRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunityWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"iconColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"OpportunityCountSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}]}]}}]}}]}}]}}]} as unknown as DocumentNode<OpportunitiesStagesQuery, OpportunitiesStagesQueryVariables>;
export const HubspotIdTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hubspotIdToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hubspotIdToken"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<HubspotIdTokenQuery, HubspotIdTokenQueryVariables>;
export const GenerateKeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generateKeywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateKeywordsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateKeywords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GenerateKeywordsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]} as unknown as DocumentNode<GenerateKeywordsMutation, GenerateKeywordsMutationVariables>;
export const KeywordsRecommendationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"keywordsRecommendations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateKeywordsRecommendationRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywordsRecommendations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GenerateKeywordsRecommendationRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]} as unknown as DocumentNode<KeywordsRecommendationsMutation, KeywordsRecommendationsMutationVariables>;
export const KeywordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"keywords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateKeywordsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GenerateKeywordsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyName"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]} as unknown as DocumentNode<KeywordsQuery, KeywordsQueryVariables>;
export const KeywordsRecommendationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"keywordsRecommendation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateKeywordsRecommendationRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywordsRecommendation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GenerateKeywordsRecommendationRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]} as unknown as DocumentNode<KeywordsRecommendationQuery, KeywordsRecommendationQueryVariables>;
export const MakeWebhookDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"makeWebhook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"req"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MakeWebhookRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"makeWebhook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"MakeWebhookRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"req"}}}]}]}}]} as unknown as DocumentNode<MakeWebhookMutation, MakeWebhookMutationVariables>;
export const NoticesAnalysisByGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"noticesAnalysisByGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"byGroupOptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesAnalysisByGroupRequestSchema"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticeValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesAnalysisByGroupRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"byGroupOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"maxNoticeCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxNoticeValues"}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"}},{"kind":"Field","name":{"kind":"Name","value":"noticeValues"}},{"kind":"Field","name":{"kind":"Name","value":"isSavedCount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NoticesAnalysisByGroupQuery, NoticesAnalysisByGroupQueryVariables>;
export const NoticesAnalysisByPeriodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"noticesAnalysisByPeriod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"byPeriodOptions"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesAnalysisByPeriodRequestSchema"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overall"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticeValues"}}]}},{"kind":"Field","name":{"kind":"Name","value":"byPeriod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesAnalysisByPeriodRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"byPeriodOptions"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateStart"}},{"kind":"Field","name":{"kind":"Name","value":"dateEnd"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"}},{"kind":"Field","name":{"kind":"Name","value":"noticeValues"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NoticesAnalysisByPeriodQuery, NoticesAnalysisByPeriodQueryVariables>;
export const NoticeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"useLegacySignalScore"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noticeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"stagev2"}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"legacyRelevanceScore"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useLegacySignalScore"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"score"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"skip"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"useLegacySignalScore"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"buyerContactName"}},{"kind":"Field","name":{"kind":"Name","value":"buyerContactEmail"}},{"kind":"Field","name":{"kind":"Name","value":"buyerContactPhone"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"procurementProcessId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lotNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lotTitle"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lotsv2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"maxExtentDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awardId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"awardDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"maxExtentDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"buyerUrl"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenByUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedFrameworkProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frameworkId"}},{"kind":"Field","name":{"kind":"Name","value":"frameworkName"}},{"kind":"Field","name":{"kind":"Name","value":"processType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preTender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"deadlineDates"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"estimated"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"clarificationDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"award"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"estimated"}},{"kind":"Field","name":{"kind":"Name","value":"publishedDate"}},{"kind":"Field","name":{"kind":"Name","value":"awardDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"extensionDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"redacted"}},{"kind":"Field","name":{"kind":"Name","value":"duplicates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]} as unknown as DocumentNode<NoticeQuery, NoticeQueryVariables>;
export const ExportNoticesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportNotices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormatArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedNotices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedNotices"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportNotices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"ExportFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedNotices"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedNotices"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExportNoticesMutation, ExportNoticesMutationVariables>;
export const HighlightNoticeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"highlightNotice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticeHighlightRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"highlightNotice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticeHighlightRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<HighlightNoticeQuery, HighlightNoticeQueryVariables>;
export const NoticesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"notices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSignals"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redacted"}},{"kind":"Field","name":{"kind":"Name","value":"score"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signals"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSignals"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"stagev2"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entityType"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"awardDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"}},{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryId"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryName"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"isSme"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenByUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedFrameworkProcess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frameworkId"}},{"kind":"Field","name":{"kind":"Name","value":"frameworkName"}},{"kind":"Field","name":{"kind":"Name","value":"processType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<NoticesQuery, NoticesQueryVariables>;
export const AddOpportunityEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addOpportunityEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityEntitiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOpportunityEntities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"entities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddOpportunityEntityMutation, AddOpportunityEntityMutationVariables>;
export const BuyerActivityStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"buyerActivityStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyerActivityStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"opportunityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunityId"}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relatedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"stagev2"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"procurementStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BuyerActivityStatusSubscription, BuyerActivityStatusSubscriptionVariables>;
export const CreateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateOpportunity"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityEntitiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entities"}}},{"kind":"Argument","name":{"kind":"Name","value":"opportunity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOpportunityMutation, CreateOpportunityMutationVariables>;
export const DeleteOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ids"}},{"kind":"Field","name":{"kind":"Name","value":"bidIds"}}]}}]}}]} as unknown as DocumentNode<DeleteOpportunityMutation, DeleteOpportunityMutationVariables>;
export const EntityOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"entityOpportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityOpportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<EntityOpportunitiesQuery, EntityOpportunitiesQueryVariables>;
export const OpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"options"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchOpportunitiesRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationOptions"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchOpportunityRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"options"}}},{"kind":"Argument","name":{"kind":"Name","value":"PaginationOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assignedTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"iconColor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<OpportunitiesQuery, OpportunitiesQueryVariables>;
export const OpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierBuyerNoticeSummaryRequest"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierBuyerNoticeSummaryRequest"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeSupplierBuyerNoticeSummary"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"assignedTo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"stagev2"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"procurementStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyerActivity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"relatedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"stagev2"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"procurementStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"frameworks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"tenderPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contractPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"categoryAssignments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryName"}},{"kind":"Field","name":{"kind":"Name","value":"parentCategoryName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"author"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}},{"kind":"Field","name":{"kind":"Name","value":"iconColor"}},{"kind":"Field","name":{"kind":"Name","value":"transitionGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"jobTitle"}},{"kind":"Field","name":{"kind":"Name","value":"jobFunction"}},{"kind":"Field","name":{"kind":"Name","value":"seniority"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"opportunities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"routeToMarket"}},{"kind":"Field","name":{"kind":"Name","value":"clarificationDeadline"}},{"kind":"Field","name":{"kind":"Name","value":"submissionDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"existingExpiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"bid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierBuyerNoticeSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SupplierBuyerNoticeSummaryRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierBuyerNoticeSummaryRequest"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeSupplierBuyerNoticeSummary"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAwards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarAwards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityQuery, OpportunityQueryVariables>;
export const ExportOpportunitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"exportOpportunities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchOpportunitiesRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ExportFormatArgs"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaginationOptions"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedOpportunities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectedOpportunities"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exportOpportunities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchOpportunityRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"ExportFormat"},"value":{"kind":"Variable","name":{"kind":"Name","value":"exportFormat"}}},{"kind":"Argument","name":{"kind":"Name","value":"PaginationOptions"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedOpportunities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedOpportunities"}}},{"kind":"Argument","name":{"kind":"Name","value":"SelectedFields"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedFields"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ExportOpportunitiesMutation, ExportOpportunitiesMutationVariables>;
export const OpportunityWorkflowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"opportunityWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunityWorkflow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"transitions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"group"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"iconColor"}},{"kind":"Field","name":{"kind":"Name","value":"iconName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpportunityWorkflowQuery, OpportunityWorkflowQueryVariables>;
export const RegenerateOpportunityBuyerSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"regenerateOpportunityBuyerSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regenerateOpportunityBuyerSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"relatedNotices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"stagev2"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"publishDate"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"lots"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"buyers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"procurementStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<RegenerateOpportunityBuyerSummaryMutation, RegenerateOpportunityBuyerSummaryMutationVariables>;
export const RemoveOpportunityEntityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeOpportunityEntity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entities"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityEntitiesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOpportunityEntity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"entities"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entities"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveOpportunityEntityMutation, RemoveOpportunityEntityMutationVariables>;
export const SupplierBuyerNoticeSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"supplierBuyerNoticeSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchRequest"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierBuyerNoticeSummaryRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplierBuyerNoticeSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SupplierBuyerNoticeSummaryRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchRequest"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allAwards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}},{"kind":"Field","name":{"kind":"Name","value":"similarAwards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalValue"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierBuyerNoticeSummaryQuery, SupplierBuyerNoticeSummaryQueryVariables>;
export const UpdateOpportunityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateOpportunity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"opportunity"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpportunityUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOpportunity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"opportunity"},"value":{"kind":"Variable","name":{"kind":"Name","value":"opportunity"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"closeDate"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOpportunityMutation, UpdateOpportunityMutationVariables>;
export const BulkUpdateOpportunitiesStageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bulkUpdateOpportunitiesStage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BulkUpdateOpportunitiesStageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkUpdateOpportunitiesStage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<BulkUpdateOpportunitiesStageMutation, BulkUpdateOpportunitiesStageMutationVariables>;
export const CompetitorPartnerCountOnBuyerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"competitorPartnerCountOnBuyer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"req"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticeCountByCrossRefOrgRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noticeCountByCrossRefOrg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticeCountByCrossRefOrgRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"req"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgId"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"}}]}}]}}]} as unknown as DocumentNode<CompetitorPartnerCountOnBuyerQuery, CompetitorPartnerCountOnBuyerQueryVariables>;
export const OrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"organisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRole"}}]}}]}}]} as unknown as DocumentNode<OrganisationsQuery, OrganisationsQueryVariables>;
export const SearchOrganisationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchOrganisations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchOrganisationsRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeNotices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAliases"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchOrganisations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchOrganisationsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orgs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isStotlesVerified"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"primaryRole"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeNotices"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"aliases"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAliases"}}}]}]}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<SearchOrganisationsQuery, SearchOrganisationsQueryVariables>;
export const GenerateOutreachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"generateOutreach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateOutreachRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateOutreach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GenerateOutreachRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"responses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"body"}}]}}]}}]}}]} as unknown as DocumentNode<GenerateOutreachMutation, GenerateOutreachMutationVariables>;
export const AskQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"askQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"QuestionRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}}]}}]}}]} as unknown as DocumentNode<AskQuestionMutation, AskQuestionMutationVariables>;
export const CreateAiReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAiReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateAiReportInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAiReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"CreateAiReportInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateAiReportMutation, CreateAiReportMutationVariables>;
export const ProvideQaFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"provideQaFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProvideFeedbackRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provideQaFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ProvideFeedbackRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"userDetailedFeedback"}},{"kind":"Field","name":{"kind":"Name","value":"isPositive"}}]}}]}}]} as unknown as DocumentNode<ProvideQaFeedbackMutation, ProvideQaFeedbackMutationVariables>;
export const QuestionAnsweredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"questionAnswered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"questionAnswered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}}]}}]}}]} as unknown as DocumentNode<QuestionAnsweredSubscription, QuestionAnsweredSubscriptionVariables>;
export const GetQuestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getQuestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetQuestionsRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getQuestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"GetQuestionsRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"isComplete"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"responseReceivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"reportId"}}]}}]}}]} as unknown as DocumentNode<GetQuestionsQuery, GetQuestionsQueryVariables>;
export const DocumentSignalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentSignals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentSignalsQuery, DocumentSignalsQueryVariables>;
export const FrameworkSignalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"frameworkSignals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"framework"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frameworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}}]}}]}}]}}]} as unknown as DocumentNode<FrameworkSignalsQuery, FrameworkSignalsQueryVariables>;
export const NoticeSignalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"noticeSignals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noticeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noticeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noticeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"colour"}}]}}]}}]}}]} as unknown as DocumentNode<NoticeSignalsQuery, NoticeSignalsQueryVariables>;
export const SavedSuppliersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"savedSuppliers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signalSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"competitorGuids"}},{"kind":"Field","name":{"kind":"Name","value":"partnerGuids"}}]}}]}}]} as unknown as DocumentNode<SavedSuppliersQuery, SavedSuppliersQueryVariables>;
export const UpdateSignalSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSignalSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateSignalSettings"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSignalSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpdateSignalSettings"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"}},{"kind":"Field","name":{"kind":"Name","value":"competitorGuids"}},{"kind":"Field","name":{"kind":"Name","value":"partnerGuids"}},{"kind":"Field","name":{"kind":"Name","value":"useSupplierName"}}]}}]}}]} as unknown as DocumentNode<UpdateSignalSettingsMutation, UpdateSignalSettingsMutationVariables>;
export const SupplierDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"supplierDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SuppliersRequest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"guids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guids"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"isSme"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"town"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isStotlesVerified"}},{"kind":"Field","name":{"kind":"Name","value":"isArchived"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"referenceOrganisations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"sourceIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"postCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"basicContactInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<SupplierDetailsQuery, SupplierDetailsQueryVariables>;
export const SupplierStatsGqlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"supplierStatsGql"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputDirect"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputMentioned"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inputUpcomingExpiries"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NoticesSearchRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"directAwards"},"name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputDirect"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"mentionedNotices"},"name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputMentioned"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"upcomingExpiries"},"name":{"kind":"Name","value":"notices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"NoticesSearchRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inputUpcomingExpiries"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<SupplierStatsGqlQuery, SupplierStatsGqlQueryVariables>;
export const AddTeamToDevcycleAudienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addTeamToDevcycleAudience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddTeamToDevcycleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTeamToDevcycleAudience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"AddTeamToDevcycleInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AddTeamToDevcycleAudienceMutation, AddTeamToDevcycleAudienceMutationVariables>;
export const AdminTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"adminTeams"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminTeams"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedSettingsId"}}]}}]}}]} as unknown as DocumentNode<AdminTeamsQuery, AdminTeamsQueryVariables>;
export const HardDeleteTeamFromOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"hardDeleteTeamFromOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hardDeleteTeamFromOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"DeleteTeamInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<HardDeleteTeamFromOnboardingMutation, HardDeleteTeamFromOnboardingMutationVariables>;
export const SignalSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"signalSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeNotices"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeAliases"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signalSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countries"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"cpvCodes"}},{"kind":"Field","name":{"kind":"Name","value":"competitors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeNotices"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"aliases"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAliases"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"partners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"noticeCount"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeNotices"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"aliases"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeAliases"}}}]}]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}}]}}]}}]}}]} as unknown as DocumentNode<SignalSettingsQuery, SignalSettingsQueryVariables>;
export const TeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<TeamQuery, TeamQueryVariables>;
export const TeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"feedSettingsId"}}]}}]}}]} as unknown as DocumentNode<TeamsQuery, TeamsQueryVariables>;
export const UpdateTeamDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateTeam"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTeamInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTeam"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"UpdateTeamInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isPrivate"}}]}}]}}]} as unknown as DocumentNode<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const SearchAdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchAdminUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchUserRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchUserRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<SearchAdminUsersQuery, SearchAdminUsersQueryVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const DescribeFrameworkConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"describeFrameworkConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"framework"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"frameworkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"frameworkId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"callOff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callOffIdentificationRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frameworkId"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]}}]}}]} as unknown as DocumentNode<DescribeFrameworkConfigQuery, DescribeFrameworkConfigQueryVariables>;
export const PersistCallOffConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"persistCallOffConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PersistCallOffConfigRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"persistCallOffConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"PersistCallOffConfigRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frameworkId"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]}}]} as unknown as DocumentNode<PersistCallOffConfigMutation, PersistCallOffConfigMutationVariables>;
export const SearchFrameworkConfigsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchFrameworkConfigs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"request"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchFrameworksRequest"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"frameworks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"SearchFrameworksRequest"},"value":{"kind":"Variable","name":{"kind":"Name","value":"request"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"callOff"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callOffIdentificationRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"frameworkId"}},{"kind":"Field","name":{"kind":"Name","value":"config"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalResults"}}]}}]}}]} as unknown as DocumentNode<SearchFrameworkConfigsQuery, SearchFrameworkConfigsQueryVariables>;